import LocalizedStrings from "react-localization";

export interface IBaseStrings {
    //App Names
    AppName: string;

    // Languages
    Language: string;
    english: string;
    german: string;

    // Pages
    Contact: string;
    LegalNotice: string;

    // Utility
    BrightMode: string;
    DarkMode: string;
    SUBMIT: string;
    Download: string;
    GoogleDrive: string;
    To: string;


    // Legal Notice
    firstName: string;
    secondName: string;
    myCity: string;
    addressLine1: string;
    addressLine2: string;
    addressLine3: string;
    addressLine4: string;
    companyName: string;

    // Contact
    contactMeInfo: string;
    Name: string;
    EnterName: string;
    Email: string;
    EnterEmail: string;
    Subject: string;
    EnterSubject: string;
    Message: string;
    TypeYourMessageHere: string;
    sendingEmailSuccessful: string;

    // Team
    teamMember01Name: string;

    // Home
    personal: string;
    career: string;

    // Projects
    personalProjectsDescription: string;
    careerProjectsDescription
    Gameplay: string;
    Trailer: string;

    // DinoKing
    dinoKingName: string;
    dinoKingSubHeader: string;
    dinoKingImageDescription;
    dinoKingDinosImageDescription: string;
    dinoKingThumbnailDescription: string;
    dinoKingSectionDescription_01: string;
    dinoKingSectionHeader_02: string;
    dinoKingSectionDescription_02: string;

    // Skyblock
    skyBlockName: string;
    skyBlockSubHeader: string;
    skyBlockImageDescription
    skyBlockDescription: string;
    skyBlockSectionHeader_01: string;
    skyBlockSectionDescription_01: string;

    // Corridor
    corridorDescription: string;
    corridorImageDescription: string;
    corridorReferenceImageDescription: string;
    corridorName: string;
    corridorSubHeader: string;
    corridorSectionHeader_01: string;
    corridorSectionDescription_01: string;
    corridorSectionHeader_02: string;
    corridorSectionDescription_02: string;

    // Door
    doorName: string;
    doorSubHeader: string;
    doorImageDescription: string;
    doorDescription: string;
    doorSectionHeader_01: string;
    doorSectionDescription_01: string;

    // Shield
    shieldName: string;
    shieldSubHeader: string;
    shieldFrontImageDescription: string;
    shieldBackImageDescription: string;
    shieldSideImageDescription: string;
    shieldReferenceImageDescription: string;
    shieldDescription: string;
    shieldSectionHeader_01: string;
    shieldSectionDescription_01: string;
    shieldSectionHeader_02: string;
    shieldSectionDescription_02: string;
    shieldSectionHeader_03: string;
    shieldSectionDescription_03: string;
    shieldSectionHeader_04: string;
    shieldSectionDescription_04: string;

    // Spider
    spiderName: string;
    spiderSubHeader: string;
    spiderFrontImageDescription: string;
    spiderBackImageDescription: string;
    spiderFrontWireframeImageDescription: string;
    spiderBackWireFrameImageDescription: string;
    spiderDescription: string;
    spiderSectionHeader_01: string;
    spiderSectionDescription_01: string;
    spiderSectionHeader_02: string;
    spiderSectionDescription_02: string;
    spiderSectionHeader_03: string;
    spiderSectionDescription_03: string;
    spiderSectionHeader_04: string;
    spiderSectionDescription_04: string;

    // Staff
    staffName: string;
    staffSubHeader: string;
    staffImageDescription: string;
    staffReferenceImageDescription: string;
    staffDescription: string;
    staffSectionHeader_01: string;
    staffSectionDescription_01: string;
    staffSectionHeader_02: string;
    staffSectionDescription_02: string;

    // Planets
    planetsName: string;
    planetsSubHeader: string;
    planetsPlanetImageDescription: string;
    planetsPlanetsImageDescription: string;
    planetsDescription: string;
    planetsSectionHeader_01: string;
    planetsSectionDescription_01: string;
    planetsSectionHeader_02: string;
    planetsSectionDescription_02: string;

    // SymbolQuest
    symbolQuestName: string;
    symbolQuestSubHeader: string;
    symbolQuestImageDescription: string;
    symbolQuestVideoImageDescription: string;
    symbolQuestDescription: string;
    symbolQuestSectionHeader_01: string;
    symbolQuestSectionDescription_01: string;
    symbolQuestSectionHeader_02: string;
    symbolQuestSectionDescription_02: string;

    // TerribleTower
    terribleTowerName: string;
    terribleTowerSubHeader: string;
    terribleTowerTitleScreenImageDescription: string;
    terribleTowerVideoImageDescription: string;
    terribleTowerStoneAgeImageDescription: string;
    terribleTowerRuneAgeImageDescription: string;
    terribleTowerRomeAgeImageDescription: string;
    terribleTowerMedievalAgeImageDescription: string;
    terribleTowerIndustrialAgeImageDescription: string;
    terribleTowerArtAgeImageDescription: string;
    terribleTowerAtomAgeImageDescription: string;
    terribleTowerMatrixAgeImageDescription: string;
    terribleTowerSciFiAgeImageDescription: string;
    terribleTowerEndAgeImageDescription: string;
    terribleTowerMenuImageDescription: string;
    terribleTowerDescription: string;
    terribleTowerSectionHeaderTrailer: string;
    terribleTowerSectionDescriptionTrailer: string;
    terribleTowerSectionHeader_00: string;
    terribleTowerSectionDescription_00: string;
    terribleTowerSectionHeader_01: string;
    terribleTowerSectionDescription_01: string;
    terribleTowerSectionHeader_02: string;
    terribleTowerSectionDescription_02: string;
    terribleTowerSectionHeader_03: string;
    terribleTowerSectionDescription_03: string;
    terribleTowerSectionHeader_04: string;
    terribleTowerSectionDescription_04: string;
    terribleTowerSectionHeader_05: string;
    terribleTowerSectionDescription_05: string;
    terribleTowerSectionHeader_06: string;
    terribleTowerSectionDescription_06: string;
    terribleTowerSectionHeader_07: string;
    terribleTowerSectionDescription_07: string;
    terribleTowerSectionHeader_08: string;
    terribleTowerSectionDescription_08: string;
    terribleTowerSectionHeader_09: string;
    terribleTowerSectionDescription_09: string;
    terribleTowerSectionHeader_10: string;
    terribleTowerSectionDescription_10: string;
    terribleTowerSectionHeader_11: string;
    terribleTowerSectionDescription_11: string;

    // BachelorThesis
    bachelorThesis: string;
    bachelorName: string;
    bachelorSubHeader: string;
    bachelorStartImageDescription: string;
    bachelorVideoImageDescription: string;
    bachelorHyperbolicRoomsImageDescription: string;
    bachelorImpossibleRooms3TurnsImageDescription: string;
    bachelorImpossibleRoomsAdvantagesImageDescription: string;
    bachelorPortalImageDescription: string;
    bachelorEuclideanImageDescription: string;
    bachelorNonEuclideanImageDescription: string;
    bachelorComponentViewImageDescription: string;
    bachelorDescription: string;
    bachelorSectionHeader_01: string;
    bachelorSectionDescription_01: string;
    bachelorSectionHeader_02: string;
    bachelorSectionDescription_02: string;
    bachelorSectionHeader_03: string;
    bachelorSectionDescription_03: string;
    bachelorSectionHeader_04: string;
    bachelorSectionDescription_04: string;
    bachelorSectionHeader_05: string;
    bachelorSectionDescription_05: string;
    bachelorSectionHeader_06: string;
    bachelorSectionDescription_06: string;
    bachelorSectionHeader_07: string;
    bachelorSectionDescription_07: string;
    bachelorSectionHeader_08: string;
    bachelorSectionDescription_08: string;
    bachelorSectionHeader_09: string;
    bachelorSectionDescription_09: string;

    // PenAndPaperVr
    penAndPaperVrName: string;
    penAndPaperVrSubHeader: string;
    penAndPaperVrCharSheetImageDescription: string;
    penAndPaperVrCharSheetEditedImageDescription: string;
    penAndPaperVrEnvironmentAddedImageDescription: string;
    penAndPaperVrCubeImageDescription: string;
    penAndPaperVrDescription: string;
    penAndPaperVrSectionHeader_01: string;
    penAndPaperVrSectionDescription_01: string;
    penAndPaperVrSectionHeader_02: string;
    penAndPaperVrSectionDescription_02: string;
    penAndPaperVrSectionHeader_03: string;
    penAndPaperVrSectionDescription_03: string;
    penAndPaperVrSectionHeader_04: string;
    penAndPaperVrSectionDescription_04: string;

    // MachineLearning
    machineLearningPaper: string;
    machineLearningName: string;
    machineLearningSubHeader: string;
    machineLearningVideoImageDescription: string;
    machineLearningRuleSelectionImageDescription: string;
    machineLearningDescription: string;
    machineLearningSectionHeader_01: string;
    machineLearningSectionDescription_01: string;
    machineLearningSectionHeader_02: string;
    machineLearningSectionDescription_02: string;

    // PimpTheLimb
    pimpTheLimbName: string;
    pimpTheLimbSubHeader: string;
    pimpTheLimbVideoImageDescription: string;
    pimpTheLimbV1ImageDescription: string;
    pimpTheLimbV2ImageDescription: string;
    pimpTheLimbDescription: string;
    pimpTheLimbSectionHeader_01: string;
    pimpTheLimbSectionDescription_01: string;
    pimpTheLimbSectionHeader_02: string;
    pimpTheLimbSectionDescription_02: string;
    pimpTheLimbSectionHeader_03: string;
    pimpTheLimbSectionDescription_03: string;

    // Portals
    portalGunName: string;
    portalGunSubHeader: string;
    portalsVideoImageDescription: string;
    portalGunDescription: string;
    portalGunSectionHeader_01: string;
    portalGunSectionDescription_01: string;

    // Empfängnis
    empfaengnisName: string;
    empfaengnisSubHeader: string;
    empfaengnisImageDescription: string;
    empfaengnisDescription: string;
    empfaengnisSectionHeader_01: string;
    empfaengnisSectionDescription_01: string;

    // StealthCommander
    stealthCommanderName: string;
    stealthCommanderSubHeader: string;
    stealthCommanderVideoImageDescription: string;
    stealthCommanderDescription: string;
    stealthCommanderSectionHeader_01: string;
    stealthCommanderSectionDescription_01: string;

    // GrimRepair
    grimRepairName: string;
    grimRepairSubHeader: string;
    grimRepairVideoImageDescription: string;
    grimRepairDescription: string;
    grimRepairSectionHeader_01: string;
    grimRepairSectionDescription_01: string;

    // Catastrophic
    catastrophicName: string;
    catastrophicSubHeader: string;
    catastrophicVideoImageDescription: string;
    catastrophicDescription: string;
    catastrophicSectionHeader_01: string;
    catastrophicSectionDescription_01: string;

    // Homepage3D
    homepage3DName: string;
    homepage3DSubHeader: string;
    homepage3DLandingPageImageDescription: string;
    homepage3DVideoDescription: string;
    homepage3D3DFontImageDescription: string;
    homepage3D3DContract1ImageDescription: string;
    homepage3D3DContract2ImageDescription: string;
    homepage3D3DPageImageDescription: string;
    homepage3DDescription: string;
    homepage3DSectionHeader_01: string;
    homepage3DSectionDescription_01: string;
    homepage3DSectionHeader_02: string;
    homepage3DSectionDescription_02: string;
    homepage3DSectionHeader_03: string;
    homepage3DSectionDescription_03: string;
    homepage3DSectionHeader_04: string;
    homepage3DSectionDescription_04: string;
    homepage3DSectionHeader_05: string;
    homepage3DSectionDescription_05: string;

    // KSP

    // Noita

    // RTS

    // ColorSpace


    // Homepage2D
    homepage2DName: string;
    homepage2DSubHeader: string;
    homepage2DImageDescription: string;
    homepage2DFrontendImageDescription: string;
    homepage2DColorPalettesImageDescription: string;
    homepage2DMuiImageDescription: string;
    homepage2DReduxImageDescription: string;
    homepage2DContactPageImageDescription: string;
    homepage2DFrontendDevImageDescription: string;
    homepage2DExampleProjectImageDescription: string;
    homepage2DProjectTypesImageDescription: string;
    homepage2DDockerFileImageDescription: string;
    homepage2DeploymentImageDescription: string;
    homepage2DUtilitiesImageDescription: string;
    homepage2DImageKitIoImageDescription: string;
    homepage2DMobileImageDescription: string;
    homepage2DDescription: string;
    homepage2DSectionHeader_01: string;
    homepage2DSectionDescription_01: string;
    homepage2DSectionHeader_01_5: string;
    homepage2DSectionDescription_01_5: string;
    homepage2DSectionHeader_02: string;
    homepage2DSectionDescription_02: string;
    homepage2DSectionHeader_03: string;
    homepage2DSectionDescription_03: string;
    homepage2DSectionHeader_04: string;
    homepage2DSectionDescription_04: string;
    homepage2DSectionHeader_05: string;
    homepage2DSectionDescription_05: string;
    homepage2DSectionHeader_06: string;
    homepage2DSectionDescription_06: string;
    homepage2DSectionHeader_07: string;
    homepage2DSectionDescription_07: string;
    homepage2DSectionHeader_08: string;
    homepage2DSectionDescription_08: string;
    homepage2DSectionHeader_09: string;
    homepage2DSectionDescription_09: string;
    homepage2DSectionHeader_10: string;
    homepage2DSectionDescription_10: string;
    homepage2DSectionHeader_11: string;
    homepage2DSectionDescription_11: string;
    homepage2DSectionHeader_12: string;
    homepage2DSectionDescription_12: string;
    homepage2DSectionHeader_13: string;
    homepage2DSectionDescription_13: string;

    // LaserEngraver
    laserEngraverDescription: string;
    laserEngraverName: string;
    laserEngraverSubHeader: string;
    laserEngraverImageDescription_01: string;
    laserEngraverSectionHeader_01: string;
    laserEngraverSectionDescription_01: string;

    laserEngraverImageDescription_02: string;
    laserEngraverSectionHeader_02: string;
    laserEngraverSectionDescription_02: string;

    laserEngraverImageDescription_03: string;
    laserEngraverSectionHeader_03: string;
    laserEngraverSectionDescription_03: string;

    laserEngraverImageDescription_04: string;
    laserEngraverSectionHeader_04: string;
    laserEngraverSectionDescription_04: string;

    laserEngraverImageDescription_05: string;
    laserEngraverSectionHeader_05: string;
    laserEngraverSectionDescription_05: string;

    laserEngraverImageDescription_06: string;
    laserEngraverSectionHeader_06: string;
    laserEngraverSectionDescription_06: string;

    laserEngraverImageDescription_07: string;
    laserEngraverSectionHeader_07: string;
    laserEngraverSectionDescription_07: string;

    laserEngraverImageDescription_08: string;
    laserEngraverSectionHeader_08: string;
    laserEngraverSectionDescription_08: string;

    laserEngraverImageDescription_09: string;
    laserEngraverSectionHeader_09: string;
    laserEngraverSectionDescription_09: string;

    laserEngraverImageDescription_10: string;
    laserEngraverSectionHeader_10: string;
    laserEngraverSectionDescription_10: string;

    // LampClock
    lampClockDescription: string;
    lampClockName: string;
    lampClockSubHeader: string;
    lampClockImageDescription_01: string;
    lampClockSectionHeader_01: string;
    lampClockSectionDescription_01: string;
    lampClockImageDescription_02: string;
    lampClockSectionHeader_02: string;
    lampClockSectionDescription_02: string;
    lampClockImageDescription_03: string;
    lampClockSectionHeader_03: string;
    lampClockSectionDescription_03: string;
    lampClockImageDescription_04: string;
    lampClockSectionHeader_04: string;
    lampClockSectionDescription_04: string;
    lampClockImageDescription_05: string;
    lampClockSectionHeader_05: string;
    lampClockSectionDescription_05: string;
    lampClockImageDescription_06: string;
    lampClockSectionHeader_06: string;
    lampClockSectionDescription_06: string;
    lampClockImageDescription_07: string;
    lampClockSectionHeader_07: string;
    lampClockSectionDescription_07: string;
    lampClockImageDescription_08: string;
    lampClockSectionHeader_08: string;
    lampClockSectionDescription_08: string;
    lampClockImageDescription_09: string;
    lampClockSectionHeader_09: string;
    lampClockSectionDescription_09: string;
    lampClockImageDescription_10: string;
    lampClockSectionHeader_10: string;
    lampClockSectionDescription_10: string;
    lampClockImageDescription_11: string;
    lampClockSectionHeader_11: string;
    lampClockSectionDescription_11: string;
    lampClockImageDescription_12: string;
    lampClockSectionHeader_12: string;
    lampClockSectionDescription_12: string;
    lampClockImageDescription_13: string;
    lampClockSectionHeader_13: string;
    lampClockSectionDescription_13: string;
    lampClockImageDescription_14: string;
    lampClockSectionHeader_14: string;
    lampClockSectionDescription_14: string;
    lampClockImageDescription_15: string;
    lampClockSectionHeader_15: string;
    lampClockSectionDescription_15: string;
    lampClockImageDescription_16: string;
    lampClockSectionHeader_16: string;
    lampClockSectionDescription_16: string;
    lampClockImageDescription_17: string;
    lampClockSectionHeader_17: string;
    lampClockSectionDescription_17: string;

    // BoxOfCards V3
    boxOfCardsV3Name: string;
    boxOfCardsV3Description: string;
    boxOfCardsV3SubHeader: string;
    boxOfCardsV3SectionImageDescription_01: string;
    boxOfCardsV3SectionHeader_01: string;
    boxOfCardsV3SectionDescription_01: string;
    boxOfCardsV3SectionImageDescription_02: string;
    boxOfCardsV3SectionHeader_02: string;
    boxOfCardsV3SectionDescription_02: string;
    boxOfCardsV3SectionImageDescription_03: string;
    boxOfCardsV3SectionHeader_03: string;
    boxOfCardsV3SectionDescription_03: string;
    boxOfCardsV3SectionImageDescription_04: string;
    boxOfCardsV3SectionHeader_04: string;
    boxOfCardsV3SectionDescription_04: string;
    boxOfCardsV3SectionImageDescription_05: string;
    boxOfCardsV3SectionHeader_05: string;
    boxOfCardsV3SectionDescription_05: string;
    boxOfCardsV3SectionImageDescription_06: string;
    boxOfCardsV3SectionHeader_06: string;
    boxOfCardsV3SectionDescription_06: string;
    boxOfCardsV3SectionImageDescription_07: string;
    boxOfCardsV3SectionHeader_07: string;
    boxOfCardsV3SectionDescription_07: string;
    boxOfCardsV3SectionImageDescription_08: string;
    boxOfCardsV3SectionHeader_08: string;
    boxOfCardsV3SectionDescription_08: string;
    boxOfCardsV3SectionImageDescription_09: string;
    boxOfCardsV3SectionHeader_09: string;
    boxOfCardsV3SectionDescription_09: string;
    boxOfCardsV3SectionImageDescription_10: string;
    boxOfCardsV3SectionHeader_10: string;
    boxOfCardsV3SectionDescription_10: string;
    boxOfCardsV3SectionImageDescription_11: string;
    boxOfCardsV3SectionHeader_11: string;
    boxOfCardsV3SectionDescription_11: string;
    boxOfCardsV3SectionImageDescription_12: string;
    boxOfCardsV3SectionHeader_12: string;
    boxOfCardsV3SectionDescription_12: string;
    boxOfCardsV3SectionImageDescription_13: string;
    boxOfCardsV3SectionHeader_13: string;
    boxOfCardsV3SectionDescription_13: string;
    boxOfCardsV3SectionImageDescription_14: string;
    boxOfCardsV3SectionHeader_14: string;
    boxOfCardsV3SectionDescription_14: string;
    boxOfCardsV3SectionImageDescription_15: string;
    boxOfCardsV3SectionHeader_15: string;
    boxOfCardsV3SectionDescription_15: string;
    boxOfCardsV3SectionImageDescription_16: string;
    boxOfCardsV3SectionHeader_16: string;
    boxOfCardsV3SectionDescription_16: string;
    boxOfCardsV3SectionImageDescription_17: string;
    boxOfCardsV3SectionHeader_17: string;
    boxOfCardsV3SectionDescription_17: string;
    boxOfCardsV3SectionImageDescription_18: string;
    boxOfCardsV3SectionHeader_18: string;
    boxOfCardsV3SectionDescription_18: string;
    boxOfCardsV3SectionImageDescription_19: string;
    boxOfCardsV3SectionHeader_19: string;
    boxOfCardsV3SectionDescription_19: string;
    boxOfCardsV3SectionImageDescription_20: string;
    boxOfCardsV3SectionHeader_20: string;
    boxOfCardsV3SectionDescription_20: string;
    boxOfCardsV3SectionImageDescription_21: string;
    boxOfCardsV3SectionHeader_21: string;
    boxOfCardsV3SectionDescription_21: string;
    boxOfCardsV3SectionImageDescription_22: string;
    boxOfCardsV3SectionHeader_22: string;
    boxOfCardsV3SectionDescription_22: string;
    boxOfCardsV3SectionImageDescription_23: string;
    boxOfCardsV3SectionHeader_23: string;
    boxOfCardsV3SectionDescription_23: string;
    boxOfCardsV3SectionImageDescription_24: string;
    boxOfCardsV3SectionHeader_24: string;
    boxOfCardsV3SectionDescription_24: string;
    boxOfCardsV3SectionImageDescription_25: string;
    boxOfCardsV3SectionHeader_25: string;
    boxOfCardsV3SectionDescription_25: string;
    boxOfCardsV3SectionImageDescription_26: string;
    boxOfCardsV3SectionHeader_26: string;
    boxOfCardsV3SectionDescription_26: string;
    boxOfCardsV3SectionImageDescription_27: string;
    boxOfCardsV3SectionHeader_27: string;
    boxOfCardsV3SectionDescription_27: string;
    boxOfCardsV3SectionImageDescription_28: string;
    boxOfCardsV3SectionHeader_28: string;
    boxOfCardsV3SectionDescription_28: string;
    boxOfCardsV3SectionImageDescription_29: string;
    boxOfCardsV3SectionHeader_29: string;
    boxOfCardsV3SectionDescription_29: string;
    boxOfCardsV3SectionImageDescription_30: string;
    boxOfCardsV3SectionHeader_30: string;
    boxOfCardsV3SectionDescription_30: string;
    boxOfCardsV3SectionImageDescription_31: string;
    boxOfCardsV3SectionHeader_31: string;
    boxOfCardsV3SectionDescription_31: string;
    boxOfCardsV3SectionImageDescription_32: string;
    boxOfCardsV3SectionHeader_32: string;
    boxOfCardsV3SectionDescription_32: string;
    boxOfCardsV3SectionImageDescription_33: string;
    boxOfCardsV3SectionHeader_33: string;
    boxOfCardsV3SectionDescription_33: string;
    boxOfCardsV3SectionImageDescription_34: string;
    boxOfCardsV3SectionHeader_34: string;
    boxOfCardsV3SectionDescription_34: string;
    boxOfCardsV3SectionImageDescription_35: string;
    boxOfCardsV3SectionHeader_35: string;
    boxOfCardsV3SectionDescription_35: string;

    // Ts-cluster
    tsClusterName: string
    tsClusterDescription: string;
    tsClusterSubHeader: string;

    tsClusterSectionImageDescription_01: string;
    tsClusterSectionHeader_01: string;
    tsClusterSectionDescription_01: string;
    tsClusterSectionImageDescription_02: string;
    tsClusterSectionHeader_02: string;
    tsClusterSectionDescription_02: string;
    tsClusterSectionImageDescription_03: string;
    tsClusterSectionHeader_03: string;
    tsClusterSectionDescription_03: string;
    tsClusterSectionImageDescription_04: string;
    tsClusterSectionHeader_04: string;
    tsClusterSectionDescription_04: string;
    tsClusterSectionImageDescription_05: string;
    tsClusterSectionHeader_05: string;
    tsClusterSectionDescription_05: string;
    tsClusterSectionImageDescription_06: string;
    tsClusterSectionHeader_06: string;
    tsClusterSectionDescription_06: string;
    tsClusterSectionImageDescription_07: string;
    tsClusterSectionHeader_07: string;
    tsClusterSectionDescription_07: string;
    tsClusterSectionImageDescription_08: string;
    tsClusterSectionHeader_08: string;
    tsClusterSectionDescription_08: string;
    tsClusterSectionImageDescription_09: string;
    tsClusterSectionHeader_09: string;
    tsClusterSectionDescription_09: string;

    // BoxOfCards V2
    boxOfCardsV2Name: string;
    boxOfCardsV2SubHeader: string;
    boxOfCardsV2Description: string;
    boxOfCardsV2LandingPageImageDescription: string;
    boxOfCardsV2ComponentsImageDescription: string;

    boxOfCardsV2SectionImageDescription_01: string;
    boxOfCardsV2SectionHeader_01: string;
    boxOfCardsV2SectionDescription_01: string;
    boxOfCardsV2SectionImageDescription_02: string;
    boxOfCardsV2SectionHeader_02: string;
    boxOfCardsV2SectionDescription_02: string;
    boxOfCardsV2SectionImageDescription_03: string;
    boxOfCardsV2SectionHeader_03: string;
    boxOfCardsV2SectionDescription_03: string;
    boxOfCardsV2SectionImageDescription_04: string;
    boxOfCardsV2SectionHeader_04: string;
    boxOfCardsV2SectionDescription_04: string;
    boxOfCardsV2SectionImageDescription_05: string;
    boxOfCardsV2SectionHeader_05: string;
    boxOfCardsV2SectionDescription_05: string;
    boxOfCardsV2SectionImageDescription_06: string;
    boxOfCardsV2SectionHeader_06: string;
    boxOfCardsV2SectionDescription_06: string;
    boxOfCardsV2SectionImageDescription_07: string;
    boxOfCardsV2SectionHeader_07: string;
    boxOfCardsV2SectionDescription_07: string;
    boxOfCardsV2SectionImageDescription_08: string;
    boxOfCardsV2SectionHeader_08: string;
    boxOfCardsV2SectionDescription_08: string;
    boxOfCardsV2SectionImageDescription_09: string;
    boxOfCardsV2SectionHeader_09: string;
    boxOfCardsV2SectionDescription_09: string;
    boxOfCardsV2SectionImageDescription_10: string;
    boxOfCardsV2SectionHeader_10: string;
    boxOfCardsV2SectionDescription_10: string;
    boxOfCardsV2SectionImageDescription_11: string;
    boxOfCardsV2SectionHeader_11: string;
    boxOfCardsV2SectionDescription_11: string;
    boxOfCardsV2SectionImageDescription_12: string;
    boxOfCardsV2SectionHeader_12: string;
    boxOfCardsV2SectionDescription_12: string;
    boxOfCardsV2SectionImageDescription_13: string;
    boxOfCardsV2SectionHeader_13: string;
    boxOfCardsV2SectionDescription_13: string;
    boxOfCardsV2SectionImageDescription_14: string;
    boxOfCardsV2SectionHeader_14: string;
    boxOfCardsV2SectionDescription_14: string;
    boxOfCardsV2SectionImageDescription_15: string;
    boxOfCardsV2SectionHeader_15: string;
    boxOfCardsV2SectionDescription_15: string;
    boxOfCardsV2SectionImageDescription_16: string;
    boxOfCardsV2SectionHeader_16: string;
    boxOfCardsV2SectionDescription_16: string;
    boxOfCardsV2SectionImageDescription_17: string;
    boxOfCardsV2SectionHeader_17: string;
    boxOfCardsV2SectionDescription_17: string;
    boxOfCardsV2SectionImageDescription_18: string;
    boxOfCardsV2SectionHeader_18: string;
    boxOfCardsV2SectionDescription_18: string;
    boxOfCardsV2SectionImageDescription_19: string;
    boxOfCardsV2SectionHeader_19: string;
    boxOfCardsV2SectionDescription_19: string;
    boxOfCardsV2SectionImageDescription_20: string;
    boxOfCardsV2SectionHeader_20: string;
    boxOfCardsV2SectionDescription_20: string;
    boxOfCardsV2SectionHeader_21: string;
    boxOfCardsV2SectionDescription_21: string;

    // BoxOfCards V1
    boxOfCardsV1Name: string;
    boxOfCardsV1SubHeader: string;
    boxOfCardsV1LandingPageImageDescription: string;
    boxOfCardsV2CardTutorialImageDescription: string;
    boxOfCardsV1DeckSelectionImageDescription: string;
    boxOfCardsV1DeckEditorImageDescription: string;
    boxOfCardsV1MultiplayerLobbyImageDescription: string;
    boxOfCardsV1GameLobbyImageDescription: string;
    boxOfCardsV1WebAppImageDescription: string;
    boxOfCardsV1ComponentsAllImageDescription: string;
    boxOfCardsV1ComponentWebAppImageDescription: string;
    boxOfCardsV1ComponentBackendWebAppImageDescription: string;
    boxOfCardsV1ComponentRedisImageDescription: string;
    boxOfCardsV1ComponentRabbitMqDescription: string;
    boxOfCardsV1ComponentGoogleCloudImageDescription: string;
    boxOfCardsV1ComponentKubeCtlGetAllImageDescription: string;
    boxOfCardsV1ComponentDigitalOceanKubernetesImageDescription: string;
    boxOfCardsV1WebClientImageDescription: string;
    boxOfCardsV1BackendServicesImageDescription: string;
    boxOfCardsV1PackagesImageDescription: string;
    boxOfCardsV1GoogleCloudFunctionsImageDescription: string;
    boxOfCardsV1RabbitMqImageDescription: string;
    boxOfCardsV1GitWorkflowImageDescription: string;
    boxOfCardsV1ShellScriptImageDescription: string;
    boxOfCardsV1GameTestsImageDescription: string;
    boxOfCardsV1TimeoutHandlerImageDescription: string;
    boxOfCardsV1OldDesign1ImageDescription: string;
    boxOfCardsV1OldDesign2ImageDescription: string;
    boxOfCardsV1FirstLandingPageImageDescription: string;
    boxOfCardsV1SecondLandingPageImageDescription: string;
    boxOfCardsV1LoginDesignsImageDescription: string;
    boxOfCardsV1LogoAttemptImageDescription: string;
    boxOfCardsV1LandingPageDesignsImageDescription: string;
    boxOfCardsV1GameDesign1ImageDescription: string;
    boxOfCardsV1PeopleChooseFontImageDescription: string;
    boxOfCardsV1FontNoUmlautsImageDescription: string;
    boxOfCardsV1FontDoesNotLikeBordersImageDescription: string;
    boxOfCardsV1ColorDifferenceOfMyMonitorsImageDescription: string;
    boxOfCardsV1ObstacleTypesImageDescription: string;
    boxOfCardsV1ObstaclesZeitplanungImageDescription: string;

    boxOfCardsV1Description: string;
    boxOfCardsV1WebappSectionHeader_01: string;
    boxOfCardsV1WebappSectionDescription_01: string;
    boxOfCardsV1WebappSectionHeader_02: string;
    boxOfCardsV1WebappSectionDescription_02: string;
    boxOfCardsV1WebappSectionHeader_03: string;
    boxOfCardsV1WebappSectionDescription_03: string;
    boxOfCardsV1WebappSectionHeader_04: string;
    boxOfCardsV1WebappSectionDescription_04: string;
    boxOfCardsV1WebappSectionHeader_05: string;
    boxOfCardsV1WebappSectionDescription_05: string;
    boxOfCardsV1WebappSectionHeader_06: string;
    boxOfCardsV1WebappSectionDescription_06: string;
    boxOfCardsV1ArchitectureSectionHeader_00: string;
    boxOfCardsV1ArchitectureSectionDescription_00: string;
    boxOfCardsV1ArchitectureSectionHeader_01: string;
    boxOfCardsV1ArchitectureSectionDescription_01: string;
    boxOfCardsV1ArchitectureSectionHeader_02: string;
    boxOfCardsV1ArchitectureSectionDescription_02: string;
    boxOfCardsV1ArchitectureSectionHeader_03: string;
    boxOfCardsV1ArchitectureSectionDescription_03: string;
    boxOfCardsV1ArchitectureSectionHeader_04: string;
    boxOfCardsV1ArchitectureSectionDescription_04: string;
    boxOfCardsV1ArchitectureSectionHeader_05: string;
    boxOfCardsV1ArchitectureSectionDescription_05: string;
    boxOfCardsV1ArchitectureSectionHeader_06: string;
    boxOfCardsV1ArchitectureSectionDescription_06: string;
    boxOfCardsV1ArchitectureSectionHeader_07: string;
    boxOfCardsV1ArchitectureSectionDescription_07: string;
    boxOfCardsV1ArchitectureSectionHeader_08: string;
    boxOfCardsV1ArchitectureSectionDescription_08: string;
    boxOfCardsV1TechStackSectionHeader_00: string;
    boxOfCardsV1TechStackSectionDescription_00: string;
    boxOfCardsV1TechStackSectionHeader_01: string;
    boxOfCardsV1TechStackSectionDescription_01: string;
    boxOfCardsV1TechStackSectionHeader_02: string;
    boxOfCardsV1TechStackSectionDescription_02: string;
    boxOfCardsV1TechStackSectionHeader_03: string;
    boxOfCardsV1TechStackSectionDescription_03: string;
    boxOfCardsV1TechStackSectionHeader_04: string;
    boxOfCardsV1TechStackSectionDescription_04: string;
    boxOfCardsV1TechStackSectionHeader_05: string;
    boxOfCardsV1TechStackSectionDescription_05: string;
    boxOfCardsV1DeploymentSectionHeader_00: string;
    boxOfCardsV1DeploymentSectionDescription_00: string;
    boxOfCardsV1DeploymentSectionHeader_01: string;
    boxOfCardsV1DeploymentSectionDescription_01: string;
    boxOfCardsV1DeploymentSectionHeader_02: string;
    boxOfCardsV1DeploymentSectionDescription_02: string;
    boxOfCardsV1TestsSectionHeader_01: string;
    boxOfCardsV1TestsSectionDescription_01: string;
    boxOfCardsV1TestsSectionHeader_02: string;
    boxOfCardsV1TestsSectionDescription_02: string;
    boxOfCardsV1DesignSectionHeader_00: string;
    boxOfCardsV1DesignSectionDescription_00: string;
    boxOfCardsV1DesignSectionHeader_01: string;
    boxOfCardsV1DesignSectionDescription_01: string;
    boxOfCardsV1DesignSectionHeader_02: string;
    boxOfCardsV1DesignSectionDescription_02: string;
    boxOfCardsDesignSectionHeader_03: string;
    boxOfCardsDesignSectionDescription_03: string;
    boxOfCardsDesignSectionHeader_04: string;
    boxOfCardsDesignSectionDescription_04: string;
    boxOfCardsDesignSectionHeader_05: string;
    boxOfCardsDesignSectionDescription_05: string;
    boxOfCardsDesignSectionHeader_06: string;
    boxOfCardsDesignSectionDescription_06: string;
    boxOfCardsV1DesignSectionHeader_07: string;
    boxOfCardsV1DesignSectionDescription_07: string;
    boxOfCardsV1DesignSectionHeader_08: string;
    boxOfCardsV1DesignSectionDescription_08: string;
    boxOfCardsV1DesignSectionHeader_09: string;
    boxOfCardsV1DesignSectionDescription_09: string;
    boxOfCardsV1DesignSectionHeader_10: string;
    boxOfCardsV1DesignSectionDescription_10: string;
    boxOfCardsV1DesignSectionHeader_11: string;
    boxOfCardsV1DesignSectionDescription_11: string;
    boxOfCardsV1DesignSectionHeader_12: string;
    boxOfCardsV1DesignSectionDescription_12: string;
    boxOfCardsV1DesignSectionHeader_13: string;
    boxOfCardsV1DesignSectionDescription_13: string;
    boxOfCardsV1ObstaclesSectionHeader_00: string;
    boxOfCardsV1ObstaclesSectionDescription_00: string;
    boxOfCardsV1ObstaclesSectionHeader_01: string;
    boxOfCardsV1ObstaclesSectionDescription_01: string;
    boxOfCardsV1ObstaclesSectionHeader_02: string;
    boxOfCardsV1ObstaclesSectionDescription_02: string;
    boxOfCardsV1ObstaclesSectionHeader_03: string;
    boxOfCardsV1ObstaclesSectionDescription_03: string;
    boxOfCardsV1ObstaclesSectionHeader_04: string;
    boxOfCardsV1ObstaclesSectionDescription_04: string;
    boxOfCardsV1ObstaclesSectionHeader_05: string;
    boxOfCardsV1ObstaclesSectionDescription_05: string;

    // Career Projects
    today: string;

    boxOfCardsV3CareerHeader: string;
    boxOfCardsV3CareerSubHeader: string;
    boxOfCardsV3CareerDescription: string;
    boxOfCardsV3CareerBulletPoint1: string;
    boxOfCardsV3CareerBulletPoint2: string;
    boxOfCardsV3CareerBulletPoint3: string;
    boxOfCardsV3CareerBulletPoint4: string;
    boxOfCardsV3CareerBulletPoint5: string;
    boxOfCardsV3CareerBulletPoint6: string;

    hrisHeader: string;
    hrisSubHeader: string;
    hrisDescription: string;
    hrisBulletPoint1: string;
    hrisBulletPoint2: string;
    hrisBulletPoint3: string;
    hrisBulletPoint4: string;
    hrisBulletPoint5: string;
    hrisBulletPoint6: string;

    kotlinRecommendationAppHeader: string;
    kotlinRecommendationAppSubHeader: string;
    kotlinRecommendationAppDescription: string;

    boxOfCardsV2CareerHeader: string;
    boxOfCardsV2CareerSubHeader: string;
    boxOfCardsV2CareerDescription: string;
    boxOfCardsV2CareerBulletPoint1: string;
    boxOfCardsV2CareerBulletPoint2: string;
    boxOfCardsV2CareerBulletPoint3: string;
    boxOfCardsV2CareerBulletPoint4: string;
    boxOfCardsV2CareerBulletPoint5: string;

    charityHeader: string;
    charitySubHeader: string;
    charityDescription: string;
    charityBulletPoint1: string;
    charityBulletPoint2: string;
    charityBulletPoint3: string;
    charityBulletPoint4: string;
    charityBulletPoint5: string;
    charityBulletPoint6: string;

    agricultureHeader: string;
    agricultureSubHeader: string;
    agricultureDescription: string;
    agricultureBulletPoint1: string;
    agricultureBulletPoint2: string;
    agricultureBulletPoint3: string;
    agricultureBulletPoint4: string;
    agricultureBulletPoint5: string;
    agricultureBulletPoint6: string;
    agricultureBulletPoint7: string;

    eCommerceHeader: string;
    eCommerceSubHeader: string;
    eCommerceDescription: string;
    eCommerceBulletPoint1: string;
    eCommerceBulletPoint2: string;
    eCommerceBulletPoint3: string;
    eCommerceBulletPoint4: string;
    eCommerceBulletPoint5: string;
    eCommerceBulletPoint6: string;
    eCommerceBulletPoint7: string;
    eCommerceBulletPoint8: string;

    bookingHeader: string;
    bookingSubHeader: string;
    bookingDescription: string;
    bookingBulletPoint1: string;
    bookingBulletPoint2: string;
    bookingBulletPoint3: string;
    bookingBulletPoint4: string;
    bookingBulletPoint5: string;

    awsSolutionArchitectHeader: string;
    awsSolutionArchitectSubHeader: string;
    awsSolutionArchitectDescription: string;

    awsCloudPractitionerHeader: string;
    awsCloudPractitionerSubHeader: string;
    awsCloudPractitionerDescription: string;

    boxOfCardsV1CareerHeader: string;
    boxOfCardsV1CareerSubHeader: string;
    boxOfCardsV1CareerDescription: string;
    boxOfCardsV1CareerBulletPoint1: string;
    boxOfCardsV1CareerBulletPoint2: string;
    boxOfCardsV1VCareerBulletPoint3: string;
    boxOfCardsV1CareerBulletPoint4: string;
    boxOfCardsV1CareerBulletPoint5: string;

    fundingHeader: string;
    fundingSubHeader: string;
    fundingDescription: string;

    diagnosisAdhdHeader: string;
    diagnosisAdhdSubHeader: string;
    diagnosisAdhdDescription: string;

    diagnosisAspergersHeader: string;
    diagnosisAspergersSubHeader: string;
    diagnosisAspergersDescription: string;

    depressionHeader: string;
    depressionSubHeader: string;
    depressionDescription: string;

    memoreHeader: string;
    memoreSubHeader: string;
    memoreDescription: string;
    memoreBulletPoint1: string;
    memoreBulletPoint2: string;
    memoreBulletPoint3: string;
    memoreBulletPoint4: string;
    memoreBulletPoint5: string;
    memoreBulletPoint6: string;
    memoreBulletPoint7: string;
    memoreBulletPoint8: string;

    bachelorFinishHeader: string;
    bachelorFinishSubHeader: string;
    bachelorFinishDescription: string;

    bachelorThesisHeader: string;
    bachelorThesisSubHeader: string;
    bachelorThesisDescription: string;
    bachelorThesisBulletPoint1: string;
    bachelorThesisBulletPoint2: string;
    bachelorThesisBulletPoint3: string;
    bachelorThesisBulletPoint4: string;

    memoreCareHeader: string;
    memoreCareSubHeader: string;
    memoreCareDescription: string;
    memoreCareBulletPoint1: string;
    memoreCareBulletPoint2: string;
    memoreCareBulletPoint3: string;
    memoreCareBulletPoint4: string;
    memoreCareBulletPoint5: string;

    magentoHeader: string;
    magentoSubHeader: string;
    magentoDescription: string;
    magentoBulletPoint1: string;
    magentoBulletPoint2: string;
    magentoBulletPoint3: string;

    synonymServiceHeader: string;
    synonymServiceSubHeader: string;
    synonymServiceDescription: string;
    synonymServiceBulletPoint1: string;
    synonymServiceBulletPoint2: string;

    bachelorStartHeader: string;
    bachelorStartSubHeader: string;
    bachelorStartDescription: string;

    racingHeader: string;
    racingSubHeader: string;
    racingDescription: string;
    racingBulletPoint1: string;
    racingBulletPoint2: string;
    racingBulletPoint3: string;

    puzzleHeader: string;
    puzzleSubHeader: string;
    puzzleDescription: string;
    puzzleBulletPoint1: string;
    puzzleBulletPoint2: string;
    puzzleBulletPoint3: string;

    jumpnRunHeader: string;
    jumpnRunSubHeader: string;
    jumpnRunDescription: string;
    jumpnRunBulletPoint1: string;
    jumpnRunBulletPoint2: string;
    jumpnRunBulletPoint3: string;
    jumpnRunBulletPoint4: string;

    saeFinishHeader: string;
    saeFinishSubHeader: string;
    saeFinishDescription: string;

    brawlerHeader: string;
    brawlerSubHeader: string;
    brawlerDescription: string;
    brawlerBulletPoint1: string;
    brawlerBulletPoint2: string;
    brawlerBulletPoint3: string;

    saeStartHeader: string;
    saeStartSubHeader: string;
    saeStartDescription: string;

    abiturHeader: string;
    start: string;

    // Skills
    websockets: string;
    redux: string;
    jest: string;
    redis: string;
    kubernetes: string;
    gcp: string;
    firebase: string;
    affinityDesigner: string;
    affinityPhoto: string;
    nuget: string;
    git: string;
    sensorTower: string;
    appAnnie: string;
    aso: string;
    unity3D: string;
    java: string;
    vite: string;
    typescript: string;
    nodeJs: string;
    digitalOcean: string;
    nextJs: string;
    prisma: string;
    react: string;
    rtk: string;
    postgreSQL: string;
    azure: string;
    dotNet: string;
    entityFramework: string;
    swagger: string;
    xUnit: string;
    moq: string;
    mui: string;
    muiDatagrid: string;
    yup: string;
    rtkQuery: string;
    scrum: string;
    businessProcessReengineering: string;
    textControl: string;
    figma: string;
    miro: string;
    aws: string;
    awsCdk: string;
    awsEc2: string;
    awsFargate: string;
    awsEcr: string;
    awsS3: string;
    awsDynamoDb: string;
    awsLambda: string;
    awsSns: string;
    awsSqs: string;
    awsCloudwatch: string;
    awsCloudFront: string;
    awsCloudformation: string;
    awsCognito: string;
    awsEcs: string;
    awsAurora: string;
    awsRoute53: string;
    apiGateway: string;
    appsync: string;
    graphql: string;
    apollo: string;
    terraform: string;
    keycloak: string;
    githubCiCd: string;
    gitlabCiCd: string;
    docker: string;
    rabbitMq: string;
    kafka: string;
    hibernate: string;
    springIntegration: string;
    jUnit: string;
    maven: string;
    angularMaterial: string;
    yarn: string;
    liquidJs: string;
    emarsys: string;
    confluence: string;
    springBoot: string;
    azureAd: string;
    ruby: string;
    prolog: string;
    c: string;
    assembler: string;
    cSharp: string;
    databases: string;
    broker: string;
    automation: string;
    algorithms: string;
    softwareDevelopment: string;
    softwareArchitecture: string;
    distributedSystems: string;
    itSecurity: string;
    vr: string;
    machineLearning: string;
    nUnit: string;
    Nuget: string;
    jira: string;
    motionTracking: string;
    jenkins: string;
    excel: string;
    lateX: string;
    aspNetCore: string;
    mySQL: string;
    linux: string;
    apache: string;
    php: string;
    magento: string;
    jQuery: string;
    symfony: string;
    javascript: string;
    android: string;
    iOs: string;
    adobePhotoshop: string;
    autodeskMaya: string;
    zBrush: string;
    mudbox: string;
    adobeIllustrator: string;
    rigging: string;
    threeDAnimation: string;
    substancePainter: string;
    nDo: string;
    dDo: string;
    kotlin: string;
    material: string;
    chatGpt: string;
    sharepoint: string;
    microsoftGraphApi: string;


    // Quotes
    quotes: string[];
    quoterPrefix: string[];
    quoter: string[];
}

const EN: IBaseStrings = {
    //App Names
    AppName: "Home",

    // Languages
    Language: "Language",
    english: "English",
    german: "German",

    // Pages
    Contact: "Contact",
    LegalNotice: "Legal Notice",

    // Utility
    BrightMode: "Bright",
    DarkMode: "Dark",
    SUBMIT: 'SUBMIT',
    Download: 'Download',
    GoogleDrive: 'Google Drive',
    To: 'To',

    // Legal Notice
    firstName: "Tim",
    secondName: "Fehrmann",
    myCity: "Hamburg",
    addressLine1: "Postanschrift",
    addressLine2: "Kjeld Schmidt",
    addressLine3: "Rochusstraße 54",
    addressLine4: "50827 Köln",
    companyName: "Deutschland",


    // Contact
    contactMeInfo: "Just write and I will respond",
    Name: "Name",
    EnterName: "Enter Name",
    Email: "Email",
    EnterEmail: "Enter email",
    Subject: "Subject",
    EnterSubject: "Enter subject",
    Message: "Message",
    TypeYourMessageHere: "Type your message here",
    sendingEmailSuccessful: "sending email successful",

    // Team
    teamMember01Name: "Tim Fehrmann",

    // Home
    personal: "Personal",
    career: "Career",

    // Projects
    personalProjectsDescription: "These are some projects from my spare time.",
    careerProjectsDescription: "These are some projects from various employments.",
    Gameplay: "Gameplay",
    Trailer: "Trailer",

    dinoKingName: "Dino King",
    dinoKingSubHeader: "A mobile game prototype",
    dinoKingImageDescription: "Active Game",
    dinoKingDinosImageDescription: "Dinos!",
    dinoKingThumbnailDescription: "Throw ham and defend against Dinos!",
    dinoKingSectionDescription_01: "In Dino King a Neanderthal fights off dinosaurs." +
        "Dinos are repelled by throwing meat hams." +
        "The player paints the trajectory of the ham with his finger and tries not to get eaten for as long as possible.",
    dinoKingSectionHeader_02: "Enemies",
    dinoKingSectionDescription_02: "The never stopping hordes of dinos. Aren't they cute? They are so cute. ADMIT IT!",

    skyBlockName: "Sky Block",
    skyBlockSubHeader: "Testing the pigart art style",
    skyBlockImageDescription: "3D Rendering",
    skyBlockDescription: "A low poly landscape in pigart style",
    skyBlockSectionHeader_01: "Description",
    skyBlockSectionDescription_01: "A lovingly 3D Landscape in pigart style.",

    corridorName: "3D Corridor",
    corridorSubHeader: "Practicing 3D Modeling by Reference",
    corridorImageDescription: "3D Rendering",
    corridorReferenceImageDescription: "3D Reference",
    corridorDescription: "A high-poly 3D model of a corridor",
    corridorSectionHeader_01: "Description",
    corridorSectionDescription_01: "This rendering shows a 3D, high-poly model of a Sci Fi corridor.",
    corridorSectionHeader_02: "Reference",
    corridorSectionDescription_02: "The 3D corridor above is based on this concept by Abraham Wong Shih Yaw.",

    doorName: "3D Sci-Fi Door",
    doorSubHeader: "Practicing Texture Baking",
    doorImageDescription: "3D Rendering",
    doorDescription: "A low-poly 3D model of a sci-fi door",
    doorSectionHeader_01: "Description",
    doorSectionDescription_01: "This rendering shows a low-poly 3D model of a sci fi door." +
        "\nIt consists of a frame with four moving pieces totaling in 300 triangles." +
        "\nThe following texture maps are used: diffuse, specular, normal",

    // Shield
    shieldName: "3D Shield",
    shieldSubHeader: "Practicing Texture Baking",
    shieldFrontImageDescription: "3D Rendering front with partial wireframe",
    shieldBackImageDescription: "3D Rendering back with partial wireframe",
    shieldSideImageDescription: "3D Rendering side with partial wireframe",
    shieldReferenceImageDescription: "3D Reference",
    shieldDescription: "A low poly 3D model of a shield",
    shieldSectionHeader_01: "Description",
    shieldSectionDescription_01: "This rendering shows a low-poly 3D model of a shield with a skull." +
        "\nThe image has a partial overlay of the 3D mesh topology.",
    shieldSectionHeader_02: "Back",
    shieldSectionDescription_02: "The reference does not have a back so I came up with one.",
    shieldSectionHeader_03: "Side",
    shieldSectionDescription_03: "This picture shows the chocolate side.",
    shieldSectionHeader_04: "Reference",
    shieldSectionDescription_04: "The 3D shield shown above is based on this concept by Artyom Vlaskin.",

    // spider
    spiderName: "3D Mechanical Spider",
    spiderSubHeader: "Iterative modeling of own ideas",
    spiderFrontImageDescription: "3D Rendering Vorne",
    spiderBackImageDescription: "3D Rendering Hinten",
    spiderFrontWireframeImageDescription: "3D Rendering Vorne mit Topologie",
    spiderBackWireFrameImageDescription: "3D Rendering Hinten mit Topologie",
    spiderDescription: "A low poly 3D model of a mechanical spider",
    spiderSectionHeader_01: "Front",
    spiderSectionDescription_01: "This rendering shows a low-poly 3D model\of a mechanical spider." +
        "\nThis model is not based on any reference and came from my imagination." +
        "\nThe spider has a motor block The legs are hydraulically movable and animatable.",
    spiderSectionHeader_02: "Back",
    spiderSectionDescription_02: "In the rear view the gear transmission is visible." +
        "\nIt also shows that the engine block is suspended from chains.",
    spiderSectionHeader_03: "Front Topology",
    spiderSectionDescription_03: "The front has an overlay of the 3D mesh topology.",
    spiderSectionHeader_04: "Back Topology",
    spiderSectionDescription_04: "The back has an overlay of the 3D mesh topology.",

    // Staff
    staffName: "3D Rod",
    staffSubHeader: "Practicing 3D Modeling",
    staffImageDescription: "3D Rendering",
    staffReferenceImageDescription: "Reference",
    staffDescription: "A low poly 3D model of a rod",
    staffSectionHeader_01: "Description",
    staffSectionDescription_01: "This rendering shows a low-poly 3D model of a rod." +
        "\nThe image has a partial overlay of the 3D mesh topology." +
        "\nThe following texture maps are used: Diffuse, Normal",
    staffSectionHeader_02: "Reference",
    staffSectionDescription_02: "The 3D rod shown above is based on this concept by Roman Guro.",

    // Planets
    planetsName: "Planets",
    planetsSubHeader: "Trying more art styles",
    planetsPlanetImageDescription: "3D Rendering Planet",
    planetsPlanetsImageDescription: "3D Rendering Planets",
    planetsDescription: "Some low-poly 3D planets",
    planetsSectionHeader_01: "One planet",
    planetsSectionDescription_01: "Just a rendering of a low-poly 3D planet.",
    planetsSectionHeader_02: "More planets",
    planetsSectionDescription_02: "Just some more planets",

    // SymbolQuest
    symbolQuestName: "Symbol Quest: Riddle Challenge",
    symbolQuestSubHeader: "Mobile puzzle game",
    symbolQuestImageDescription: "Symbol Quest Ad",
    symbolQuestVideoImageDescription: "Symbol Quest Trailer",
    symbolQuestDescription: "Symbol Quest is a 2D Puzzle Game from 2015",
    symbolQuestSectionHeader_01: "Description",
    symbolQuestSectionDescription_01: "Symbol Quest: Riddle Challenge was released in 2015 by Red Orb Games on Android and iOs.",
    symbolQuestSectionHeader_02: "Gameplay",
    symbolQuestSectionDescription_02: "The player draws lines across the screen to reveal images." +
        "\nWhere lines overlap with the hidden subject, the subject is revealed." +
        "\nThe player has to guess the motif with a limited number of lines.",

    // TerribleTower
    terribleTowerName: "Terrible Tower",
    terribleTowerSubHeader: "A Mobile jump'n run game without floors",
    terribleTowerTitleScreenImageDescription: "Loading Screen",
    terribleTowerVideoImageDescription: "Terrible Tower Trailer",
    terribleTowerStoneAgeImageDescription: "Stone age",
    terribleTowerRuneAgeImageDescription: "Rune age",
    terribleTowerRomeAgeImageDescription: "Rome age",
    terribleTowerMedievalAgeImageDescription: "Middle age",
    terribleTowerIndustrialAgeImageDescription: "Industrial age",
    terribleTowerArtAgeImageDescription: "Art-deco age",
    terribleTowerAtomAgeImageDescription: "Atomic age",
    terribleTowerMatrixAgeImageDescription: "Matrix age",
    terribleTowerSciFiAgeImageDescription: "Scifi age",
    terribleTowerEndAgeImageDescription: "end times",
    terribleTowerMenuImageDescription: "Menu",
    terribleTowerDescription: "Terrible Tower is a 2D Roguelite Puzzle Platformer from 2014",
    terribleTowerSectionHeaderTrailer: "Trailer",
    terribleTowerSectionDescriptionTrailer: "The release Trailer.",
    terribleTowerSectionHeader_00: "Description",
    terribleTowerSectionDescription_00: "Terrible Tower was released in 2015 by Red Orb Games on Android and iOs.",
    terribleTowerSectionHeader_01: "Gameplay",
    terribleTowerSectionDescription_01: "The player must climb a magic tower." +
        "\nTo do this, he must jump through the bottom screen to reappear at the top screen. Magic!" +
        "\nThe tower consists of 10 ages with different dangers and starts in the Stone Age.",
    terribleTowerSectionHeader_02: "Runic Ages",
    terribleTowerSectionDescription_02: "The Runic Age glows magically and contains dangerous fire as well as magical projectiles.",
    terribleTowerSectionHeader_03: "Age of Rome.",
    terribleTowerSectionDescription_03: "In the Age of Rome, ballistae, morning stars and drop stones make the way difficult.",
    terribleTowerSectionHeader_04: "Middle Ages",
    terribleTowerSectionDescription_04: "In the Middle Ages, countless axes swing. Duck!",
    terribleTowerSectionHeader_05: "Industrial Age",
    terribleTowerSectionDescription_05: "The Industrial Age contains circular saws and hydraulic presses.",
    terribleTowerSectionHeader_06: "Art-deco age",
    terribleTowerSectionDescription_06: "Now circular saws are even flying and rotating flamethrowers as well as automatic guns are everywhere.",
    terribleTowerSectionHeader_07: "Atomic Age",
    terribleTowerSectionDescription_07: "The Atomic Age is the time of free radicals, toxic barrels and nuclear missiles.",
    terribleTowerSectionHeader_08: "Matrix",
    terribleTowerSectionDescription_08: "In the Matrix, lasers regularly block the way, bombs block the way, and everything is constantly moving!",
    terribleTowerSectionHeader_09: "Scifi Age",
    terribleTowerSectionDescription_09: "Rotating laser turrets everywhere and everything is moving all the time!",
    terribleTowerSectionHeader_10: "End Times",
    terribleTowerSectionDescription_10: "In the End Time, traps from all previous ages are present. Completely random!",
    terribleTowerSectionHeader_11: "Main Menu",
    terribleTowerSectionDescription_11: "The Main Menu allows you to buy upgrades, skins and view achievements and high scores.",

    // Bachelor
    bachelorThesis: "Bachelor Thesis",
    bachelorName: "Navigation in non-euclidean VR",
    bachelorSubHeader: "Completed studying applied informatics",
    bachelorStartImageDescription: "Starting Position for VR-Player",
    bachelorVideoImageDescription: "Video of non-euclidean navigation trial",
    bachelorHyperbolicRoomsImageDescription: "Example of Hyperbolic Spaces",
    bachelorImpossibleRooms3TurnsImageDescription: "Example of Elliptic Spaces",
    bachelorImpossibleRoomsAdvantagesImageDescription: "Example of saving distance",
    bachelorPortalImageDescription: "Overlapping rooms from player perspective",
    bachelorEuclideanImageDescription: "Euclidean VR environment",
    bachelorNonEuclideanImageDescription: "Non-Euclidean VR environment",
    bachelorComponentViewImageDescription: "Component Diagram",
    bachelorDescription: "The bachelor thesis for my studying of applied informatics",
    bachelorSectionHeader_01: "Description",
    bachelorSectionDescription_01: "This is the thesis for my degree in applied computer science." +
        "\nIt was investigated whether non-Euclidean VR environments are suitable\to reduce navigation times in unknown environments.",
    bachelorSectionHeader_02: "Experiment",
    bachelorSectionDescription_02: "20 subjects were given the task of finding 20 landmarks in a VR environment." +
        "\nThere was an euclidean and a non-euclidean VR environment and both were constructed in the same way." +
        "\nThe non-Euclidean environment had shorter walking distances through curvatures of space." +
        "\nProbands in the non-euclidean VR environment had no problems with spatial overlaps and were 40% faster on average.",
    bachelorSectionHeader_03: "Hyperbolic space curvature",
    bachelorSectionDescription_03: "Figure a) shows 5 interconnected rooms. The doors are marked with numbers." +
        "\nSuch a space is not possible in 3-dimensional space, since spaces would overlap." +
        "\nIt is only made possible by a hyperbolic space curvature as in b).",
    bachelorSectionHeader_04: "Elliptic space curvature",
    bachelorSectionDescription_04: "The spaces in a) can only be connected by an elliptic space curvature as shown in b)." +
        "\nThis shortens the distance between the spaces.",
    bachelorSectionHeader_05: "Distance saving",
    bachelorSectionDescription_05: "This illustration shows how a distance between two rooms can be shortened if they are allowed to overlap .",
    bachelorSectionHeader_06: "Distance saving from ego perspective",
    bachelorSectionDescription_06: "In the figure, the subject is looking at two doors." +
        "\nThe left one leads into a hallway and the right one into a garage. It is already obvious from this detail, that such a room layout should be impossible." +
        "\nIn this case, it is made possible by portals.",
    bachelorSectionHeader_07: "Euclidean VR environment",
    bachelorSectionDescription_07: "In this figure, the euclidean VR environment is shown from a bird's eye view.",
    bachelorSectionHeader_08: "Non-euclidean VR environment",
    bachelorSectionDescription_08: "In this figure, the non-euclidean VR environment is shown from the bird's eye view is shown." +
        "\nThe spaces are separated from each other so that they do not overlap and remain connected to each other by portals 'P'." +
        "\nThe colored lines indicate the paths between the rooms.",
    bachelorSectionHeader_09: "Component Diagram",
    bachelorSectionDescription_09: "In this diagram, the components are shown, that make the experiment possible." +
        "\nBefore I explain the diagram here I refer directly to my bachelor thesis.",

    // PenAndPaperVr
    penAndPaperVrName: "Pen and Paper VR",
    penAndPaperVrSubHeader: "A VR prototype for applied informatics studying",
    penAndPaperVrCharSheetImageDescription: "Character Sheet Preview",
    penAndPaperVrCharSheetEditedImageDescription: "Character Sheet Editing",
    penAndPaperVrEnvironmentAddedImageDescription: "Environment Creation",
    penAndPaperVrCubeImageDescription: "Tracked Dice",
    penAndPaperVrDescription: "A university project on the applicability of pen and paper in VR",
    penAndPaperVrSectionHeader_01: "Description",
    penAndPaperVrSectionDescription_01: "Players can create units and place them on a game grid." +
        "\nThe playing field can be moved using arrows on the table.",
    penAndPaperVrSectionHeader_02: "Character Sheets",
    penAndPaperVrSectionDescription_02: "Units have editable character sheets." +
        "\nA virtual keyboard is used for editing." +
        "\nThe character sheets can be saved and loaded.",
    penAndPaperVrSectionHeader_03: "Level",
    penAndPaperVrSectionDescription_03: "All sorts of junk can be placed on the playing field." +
        "\nElements outside the visible grid are automatically hidden.",
    penAndPaperVrSectionHeader_04: "Tracked Cube",
    penAndPaperVrSectionDescription_04: "On the premise we had access to tracking cameras." +
        "\nThis cube could be used to roll dice in real time in the VR environment.",

    // MachineLearning
    machineLearningPaper: "AgentsPaper",
    machineLearningName: "Machine Learning",
    machineLearningSubHeader: "Part of studying applied informatics",
    machineLearningVideoImageDescription: "Video of agents emulating rulesets",
    machineLearningRuleSelectionImageDescription: "Rule selection overview",
    machineLearningDescription: "Agents are assigned random rulesets and teams and fight for their survival.",
    machineLearningSectionHeader_01: "Description",
    machineLearningSectionDescription_01: "This is a snippet from one of my university projects on complex adaptive systems." +
        "\nAgents fight in teams for resources and their survival.",
    machineLearningSectionHeader_02: "Rules",
    machineLearningSectionDescription_02: "Each agent has a random set of rules." +
        "\nEach rule and turn has a cost." +
        "\nThese rules include e.g. fleeing when outnumbered or not walking into obstacles." +
        "\nThis picture shows how rules are handled from top to bottom." +
        "\nThe course was held in german so the following paper is as well.",

    // PimpTheLimb
    pimpTheLimbName: "Cannon Jump",
    pimpTheLimbSubHeader: "Prototyping a game idea",
    pimpTheLimbVideoImageDescription: "Video of cannon jump mechanic",
    pimpTheLimbV1ImageDescription: "1st design of cannon character",
    pimpTheLimbV2ImageDescription: "2nd design of cannon character",
    pimpTheLimbDescription: "A prototype in which you are a cannon.",
    pimpTheLimbSectionHeader_01: "Description",
    pimpTheLimbSectionDescription_01: "This video shows the mechanic." +
        "\nThe player can slightly roll left and right." +
        "\nShooting has a knockback and can be used to jump." +
        "\nRotating reloads ammunition." +
        "\nThe ammunition is displayed on the cannon.",
    pimpTheLimbSectionHeader_02: "Version 1",
    pimpTheLimbSectionDescription_02: "This is the first prototyped version." +
        "\nThis idea is based on Mount Your Friend but controlling four cannons was impractical.",
    pimpTheLimbSectionHeader_03: "Version 2",
    pimpTheLimbSectionDescription_03: "Due to simplification only one cannon is used." +
        "\nBut the character can now roll slightly to either side." +
        "\nThis idea was discontinued as level design is a nightmare.",

    // Portals
    portalGunName: "Portal Gun",
    portalGunSubHeader: "Prototyping a game idea",
    portalsVideoImageDescription: "Video of portal gun",
    portalGunDescription: "This is a prototype of a self made Portal Gun",
    portalGunSectionHeader_01: "Description",
    portalGunSectionDescription_01: "The player can shoot two projectiles to create linked Portals." +
        "\nOn Collision the projectiles find the best positioning and orientation for Portals." +
        "\nPortals allow for seamless transition of the player and props." +
        "\nThe only thing breaking the immersion are the shades due to lighting." +
        "\nThis was created using multiple cameras and toggling collision layers.",

    // Empfängnis
    empfaengnisName: "Empfängnis",
    empfaengnisSubHeader: "A book project with friends",
    empfaengnisImageDescription: "Book cover",
    empfaengnisDescription: "A fantasy novel I wrote with 2 friends back in school",
    empfaengnisSectionHeader_01: "Empfängnis",
    empfaengnisSectionDescription_01: "This fantasy novel was written page by page while taking turns." +
        "\nI passed my page to Patrick, Patrick to Kjeld and Kjeld to me." +
        "\nThis resulted in everybody lacking essential information and hilarious plot twists." +
        "\nIf you do not take life too seriously give it a read." +
        "\nSidenote: I was overruled on the name.",

    // StealthCommander
    stealthCommanderName: "Move units using curves",
    stealthCommanderSubHeader: "Prototyping controls for a game idea",
    stealthCommanderVideoImageDescription: "Video of curve based movement",
    stealthCommanderDescription: "A prototype for a curve based movement system using curve handles",
    stealthCommanderSectionHeader_01: "Description",
    stealthCommanderSectionDescription_01: "Units can be selected and commanded." +
        "\nMoving Units have their path displayed and each trajectory has a handle." +
        "\nMoving the handle will alter the path, thus creating a curve." +
        "\nThe maximum curvature is proportional the length of the path.",

    // GrimRepair
    grimRepairName: "Grim Repair",
    grimRepairSubHeader: "Game of Inno global game jam 2020",
    grimRepairVideoImageDescription: "Video of playthrough",
    grimRepairDescription: "Global Game Jam of 2020 with the topic 'Repair'",
    grimRepairSectionHeader_01: "Description",
    grimRepairSectionDescription_01: "In Grim Repair the Grim Reaper has killed all craftsman." +
        "\nNow it is your task to build machines from parts." +
        "\nThose machines then have to attack the Grim Reaper to stop him." +
        "\nIt turns out that the whole game was built on top of a even bigger Reaper.",

    // Catastrophic
    catastrophicName: "Catastrophic",
    catastrophicSubHeader: "Game of Inno global game jam 2019",
    catastrophicVideoImageDescription: "Video of playthrough",
    catastrophicDescription: "Global Game Jam of 2019 with the topic 'Home'",
    catastrophicSectionHeader_01: "Description",
    catastrophicSectionDescription_01: "In Catastrophic a cat is demolishing your home." +
        "\nYou are a robot with magnetic powers and the task to repair everything." +
        "\nCollect and shoot screwdrivers to repair things." +
        "\nBe aware that repairing things may attract more cats, screwdrivers, and weirdness." +
        "\nI just love fluid simulations.",

    // Homepage3D
    homepage3DName: "Made of Cubes",
    homepage3DSubHeader: "A 3D homepage",
    homepage3DLandingPageImageDescription: "Landing page",
    homepage3DVideoDescription: "Video of 3D Homepage",
    homepage3D3DFontImageDescription: "Custom 3D Font",
    homepage3D3DContract1ImageDescription: "Contact page",
    homepage3D3DContract2ImageDescription: "Contact page during animation",
    homepage3D3DPageImageDescription: "Portfolio",
    homepage3DDescription: "My previous homepage which is 100% made of 3D cubes",
    homepage3DSectionHeader_01: "Description",
    homepage3DSectionDescription_01: "I can't remember how I got the absurd idea to build a homepage 100% in 3D." +
        "\nbut hey it looks cool when cubes fly around." +
        "\nFunfact 1: All cubes used on the homepage are a clone of the shown loading symbol." +
        "\nFunfact 2: It needs a dedicated GPU to run smoothly and the application can't set it itself." +
        "\nThe homepage is no longer active so I recorded this short video.",
    homepage3DSectionHeader_02: "Custom Font",
    homepage3DSectionDescription_02: "I had the grandiose idea to create all the text from 3D cubes too." +
        "\nSo why not finish the wooden path and build your own low-poly font!",
    homepage3DSectionHeader_03: "Animate cubes",
    homepage3DSectionDescription_03: "It's also much cooler then when cubes fly around to display text." +
        "\nIt turns out that thousands of animations (tweens) for position, rotation, scaling and color become computationally intensive after all." +
        "\nTherefore, all animations on the page without exception are already computed when called.",
    homepage3DSectionHeader_04: "Dice form contact page",
    homepage3DSectionDescription_04: "The cubes are now flown to their positions and rotated." +
        "\nTo make Interactions possible ray casts of the mouse are used to color words." +
        "\nNon-existent cubes for longer texts are generated automatically.",
    homepage3DSectionHeader_05: "Portfolio",
    homepage3DSectionDescription_05: "Lastly, my portfolio must also be displayed." +
        "\nFor this, they will be displayed as images on the same cubes." +
        "\nWhen changing pages, the images are exchanged exactly when the objects are orthogonal to the camera." +
        "\nUnfortunately, these were not 90 degree angles because the camera is perspective." +
        "\nI also included videos in this 3D space on the cubes." +
        "\nIt was a nightmare because additional 2D cameras are needed." +
        "\nEspecially when zooming.",

    // Homepage2D
    homepage2DName: "Homepage 2D",
    homepage2DSubHeader: "Actually this homepage!",
    homepage2DImageDescription: "Landing page",
    homepage2DFrontendImageDescription: "Frontend packages",
    homepage2DColorPalettesImageDescription: "Custom color palettes",
    homepage2DMuiImageDescription: "Styling react components",
    homepage2DReduxImageDescription: "Redux store configuration",
    homepage2DContactPageImageDescription: "Code of Contact Page",
    homepage2DFrontendDevImageDescription: "Packages for compilation",
    homepage2DExampleProjectImageDescription: "Example Configuration for project",
    homepage2DProjectTypesImageDescription: "Project configuration interfaces",
    homepage2DDockerFileImageDescription: "Docker file of web-app",
    homepage2DeploymentImageDescription: "Deployment Packages",
    homepage2DUtilitiesImageDescription: "Utilitiy Packages",
    homepage2DMobileImageDescription: "Career Projects - Mobile View",
    homepage2DImageKitIoImageDescription: "Imagekit.io overview",
    homepage2DDescription: "Development of this Homepage",
    homepage2DSectionHeader_01: "Homepage 2D",
    homepage2DSectionDescription_01: "Describing my Homepage on my Hompage. Fun!\n" +
        "I update this homepage from time to time so some images are slightly outdated.",
    homepage2DSectionHeader_01_5: "Responsiveness",
    homepage2DSectionDescription_01_5: "All pages are responsive and work up to a resolution of 300x640.\n" +
        "Smaller devices should only be Tamagotchis.",
    homepage2DSectionHeader_02: "Rendering",
    homepage2DSectionDescription_02: "Using Material-UI to style elements and apply themes." +
        "\nI chose React as I am slowly building up my reusable components." +
        "\nRedux might be overkill for such a small project but I use this as template for other projects.",
    homepage2DSectionHeader_03: "Themes",
    homepage2DSectionDescription_03: "Material-UI allows for easy usage for themes." +
        "\nThus allowing for a bright and a dark mode <3",
    homepage2DSectionHeader_04: "Styling",
    homepage2DSectionDescription_04: "Material-UI also gives some handy styling.",
    homepage2DSectionHeader_05: "Redux Store",
    homepage2DSectionDescription_05: "The redux store gives us global state management." +
        "\ne.g. to display Toasts using the AlertState or updating the language selection using the languageState.",
    homepage2DSectionHeader_06: "Example: Contact Page",
    homepage2DSectionDescription_06: "Pages are so compact using those libraries." +
        "\nThe component contains type definitions for props passed into the component." +
        "\nAn internal state and functions to manage input." +
        "\nAnother function to send an email on submit." +
        "\nAnd lastly the Global State for e.g. Alerts & Styles is mapped onto the component.",
    homepage2DSectionHeader_07: "Compilation",
    homepage2DSectionDescription_07: "To avoid the Javascript hell Typescript is used." +
        "\nTypes are love." +
        "\nWebpack compiles the code into small bundle." +
        "\nDocker because Docker! Hurray!",
    homepage2DSectionHeader_08: "Project Config Example: Portals",
    homepage2DSectionDescription_08: "Every Project of this homepage is defined in a config." +
        "\nThis makes it easier to add new projects over time." +
        "\nThat block alone creates a card on the main page and also a complete page in a sub route." +
        "\nThis page is such a config too.",
    homepage2DSectionHeader_09: "Project Config Types",
    homepage2DSectionDescription_09: "A Project Page consists of all of these type definitions." +
        "\nSeveral are optional like videos, images, downloads, etc.",
    homepage2DSectionHeader_10: "Docker File",
    homepage2DSectionDescription_10: "There is not much to be said here." +
        "\nInstall packages, create a build and that build will contain a public index.html",
    homepage2DSectionHeader_11: "Deployment",
    homepage2DSectionDescription_11: "Code is on Github." +
        "\nDynadot is my domain provider." +
        "\nNetlify is used for automatic deployment & Hosting.",
    homepage2DSectionHeader_12: "Utility Libraries",
    homepage2DSectionDescription_12: "Imagekit.io allows uploading of images." +
        "\nThis way this homepage is being loaded faster as images are only downloaded on demand." +
        "\nand are automatically resized to the required size." +
        "\nEmailJs allows for very easy sending of emails.",
    homepage2DSectionHeader_13: "ImageKit Io",
    homepage2DSectionDescription_13: "This is a Screenshot of my Imagekit.io root containing all images used for this homepage.",

    // LaserEngraver
    laserEngraverDescription: "A laser engraver that I also used to print on Din A4",
    laserEngraverName: "Printing with Lasers",
    laserEngraverSubHeader: "No, not laser printing but like real lasers!",
    laserEngraverImageDescription_01: "Blue Din A4 sheet in laser in engraver",
    laserEngraverSectionHeader_01: "Description",
    laserEngraverSectionDescription_01: "My printer broke down again and I was looking for an alternative without ink problems." +
        "\nSo I ordered an AtomStack A5 Laser Engraver and modified it until I could engrave Din A4 sheets." +
        "\nSo how do I set it up & what did I modify?",

    laserEngraverImageDescription_02: "Laser engraver in wooden box - front view",
    laserEngraverSectionHeader_02: "Un-unboxing",
    laserEngraverSectionDescription_02: "I needed a solid foundation to minimize vibrations from affecting the laser engraving process." +
        "\nSo I added laminated wood on all sides and screwed down the laser engraver." +
        "\nThis way I also do not have to wear my safety goggles permanently." +
        "\nThe front can be opened for easier access & engraver removal." +
        "\nCables are run across the right wall to avoid them ending up in between the laser head.",

    laserEngraverImageDescription_03: "Laser engraver in wooden box - top view",
    laserEngraverSectionHeader_03: "Solid enough to serve as a chair",
    laserEngraverSectionDescription_03: "I also made the it so I could open the top." +
        "\nOn the top right I added ventilation to keep harming gases from accumulating in the box or the surrounding room. The air tastes less sweet this way." +
        "\nThe hose can be extended and hung out of a door or window and the ventilation can be turned on with a button." +
        "\nAll cables are run through a gap on the bottom of the front door.",

    laserEngraverImageDescription_04: "Laser head with air support",
    laserEngraverSectionHeader_04: "Air Support",
    laserEngraverSectionDescription_04: "I replaced one of those green pieces with a 3d printed one that allows to fit a hose into a nozzle." +
        "\nThis air support drastically improves the quality of the engraving as it removes burnt particles." +
        "\nOtherwise those would set onto the wood or get burnt by the laser and give those burnt marks around the the engraved area.",

    laserEngraverImageDescription_05: "Air compressor in wooden box",
    laserEngraverSectionHeader_05: "Air compressor",
    laserEngraverSectionDescription_05: "The pressured air comes from a separate compessor." +
        "\nIt has an air intake and an output in which I can put the air hose." +
        "\nCompressors are quite loud so I encased it in a wooden box with insulation materials to avoid vibration." +
        "\nIt helped a lot though it is still quite loud. How much heat do those build up? Well it is hot to touch after 30 minutes." +
        "\nI got a fire extinguisher next to it though.",

    laserEngraverImageDescription_06: "A board with laser engrave test runs",
    laserEngraverSectionHeader_06: "Testing",
    laserEngraverSectionDescription_06: "So much can be configured using a laser engraver." +
        "\nThe speed of the laser head, the intensity, how often it runs a path, what algorithm it uses to run a path." +
        "\nEven the angle matters as the laser lense is a rectangle and the laser head does not like diagonally as it requires moving on 2 axis." +
        "\nThe Name, those left 'T' and some 'Te' are engraved with air support." +
        "\nConfiguring things wrong might result in holes with a depth of 1-3cm. And this was not at full power or high duration.",

    laserEngraverImageDescription_07: "Micro-controller with a stopper on axis of laser engraver",
    laserEngraverSectionHeader_07: "Origin Finder",
    laserEngraverSectionDescription_07: "The head of the laser engraver does not know where it is." +
        "\nWhen resetting it to e.g. the top left corner it bounces into the wall for some while as there is no stop signal." +
        "\nI bought two micro-controllers and laser engraved small wooden bases to screw them onto." +
        "\nI added once to each axis and those stoppers are wired into the Atomstack A5." +
        "\nWith minor configuration in my Lightburn software the laser engraver now has a auto homing.",


    laserEngraverImageDescription_08: "An engraved carving knife",
    laserEngraverSectionHeader_08: "Engraving a present",
    laserEngraverSectionDescription_08: "A friend was leaving on a long journey so I decided to gift her a carving knife and a block of wood." +
        "\nThis was a great opportunity to engrave it with her name and some philosophical text." +
        "\nIt turned great for the first use case." +
        "\nWhy didn't I just take a screenshot?",

    laserEngraverImageDescription_09: "Svg of a pdf in Lightburn ui",
    laserEngraverSectionHeader_09: "Preparing documents for engraving",
    laserEngraverSectionDescription_09: "My printer was still broken down and I needed to revoke my new wallet just because I ordered the wrong one." +
        "\nSo to print the revocation I ran the pdf through and online pdf to svg converter and imported it into Lightburn." +
        "\nI decided to configure it to only engrave the borders of the texts as it turns out to be slightly easier to read and it is also way faster.",

    laserEngraverImageDescription_10: "An engraved Din A4 sheet of blue paper",
    laserEngraverSectionHeader_10: "Laser printing complete",
    laserEngraverSectionDescription_10: "The laser engraving took a bit more than 5 minutes and it turned out to be readable; which is sufficient." +
        "\nThe paper could not be white as reflective materials can not be engraved due to physics. I thought blue would be the least weird." +
        "\nI almost replaced the 'Papercuts' with 'Lasercuts' but it felt smarter to skip the copyright infringement." +
        "\nI got my money back and ordered another wallet which I use to this day happily.",

    // LampClock
    lampClockDescription: "A wooden lamp that uses led to display time and forecast rain, temperature",
    lampClockName: "Clock & Weather Led Lamp",
    lampClockSubHeader: "A fancy lamp with feature creep",
    lampClockImageDescription_01: "Wired backside of the led lamp",
    lampClockSectionHeader_01: "Description",
    lampClockSectionDescription_01: "I visited a Kjeld of mine and got to know his programmable led projects." +
        "\nI was amazed and I already love wood working. By now I also love micro controllers & led programming.",
    lampClockImageDescription_02: "Round, laminated piece of beech with 80cm diameter",
    lampClockSectionHeader_02: "The base",
    lampClockSectionDescription_02: "I found this piece of beech in the hardware store." +
        "\nI instantly thought that it would be great for a yin and yang lamp." +
        "\nWith pencil & thread I marked the holes on the sides and the big S in the center and from that line I used a Divider to mark a ~8cm diameter." +
        "\nThis will allow for more interesting led placement.",
    lampClockImageDescription_03: "The cut and polished beech board",
    lampClockSectionHeader_03: "Cutting & polishing",
    lampClockSectionDescription_03: "With a Jigsaw I cut out the rough shapes. I learned that Jigsaws do not like to go in small circles and that beech is a very hard wood that creates very fine dust." +
        "\nA lot of polishing, really a lot had to be done by hand and machine. I corrected imperfections with Chisel & colored wooden paste.",

    lampClockImageDescription_04: "Painting & Oiling - 2 Dark Layers applied",
    lampClockSectionHeader_04: "Painting & Oiling",
    lampClockSectionDescription_04: "I oiled & painted each side and noticed that the dark paint was not covering well." +
        "\nDue to the different laminated pieces and pre treatment the paint differed in opaqueness and stickyness." +
        "\nI painted the dark side 3 times, scrubbed off most of the paint due to it being unevenly applied and painted it 4 more times." +
        "\nEach time I let it dry for 12-72h based on stickyness. Next time I'll test this first. I turned out fine though.",

    lampClockImageDescription_05: "Mounted led strips on back of lamp",
    lampClockSectionHeader_05: "Mounting led-strips",
    lampClockSectionDescription_05: "I was unsure of the best way to mount leds as they had to be orthogonally mounted." +
        "\nI wanted a natural and less destructive/permanent solution in case of errors. I decided to drill holes for wooden pins and to use tension to attach the leds." +
        "\nThe leds also had a sticky back side which I thought would make attaching them easier but it did not." +
        "\nThe led strips were connected using plastics clamps as they looked to be an amazing solution." +
        "\nThis worked fine for now but more on this later.",

    lampClockImageDescription_06: "Power supply & Esp12e micro-controller on back of lamp",
    lampClockSectionHeader_06: "Connecting Power Supply & Micro Controller",
    lampClockSectionDescription_06: "To test the led strips I connected the Micro Controller and ran some single colors." +
        "\nThose micro controller boards are awesome! They support wifi and I can deploy code via WiFi or usb-c to usb cables." +
        "\nThey also allow debug output when connected via usb. Which is essentially essential." +
        "\nI noticed a brightness fall off on the leds. This was to be expected as my total led strip length was ~5m and I had a high led density." +
        "\nDuring soldering & connecting wires I burnt one micro controller and one usb-hub. Kjeld was impressed too!",
    lampClockImageDescription_07: "Diagram of Lamp wires",
    lampClockSectionHeader_07: "Wire & Led setup",
    lampClockSectionDescription_07: "The power Supply powers the micro controller and both ends of the total led strip to avoid a brightness falloff." +
        "\nThe led strips were connected in the shorted way possible and this becomes important when programming them later as individual led are accessed by their sequential position.",

    lampClockImageDescription_08: "Solder setup",
    lampClockSectionHeader_08: "Soldering iron, flux paste & copper wool",
    lampClockSectionDescription_08: "Kjeld gifted me his old solder setup which I used to solder led-strips to wires & the micro controller." +
        "\nI burnt my soldering iron tip twice but after using it for a few hours I got the hang of it.",

    lampClockImageDescription_09: "Wires soldered to led-strip",
    lampClockSectionHeader_09: "Soldering & cramping so many connectors",
    lampClockSectionDescription_09: "Those plastics clamp from earlier tend to corrode and scratch until led strips lose their connection and start to flicker." +
        "\nSo I soldered everything. This also took very long but felt very satisfying.",

    lampClockImageDescription_10: "Diagram of micro controller accessing weather api",
    lampClockSectionHeader_10: "Accessing weather api",
    lampClockSectionDescription_10: "Since sawing those holes into the beech I thought that it would be great to display some useful information in them." +
        "\nI decided to display a rain forecast in the left circle and a temperature forecast in the right circle." +
        "\nI tried accessing the openweather api directly and noticed that it returns waaaay too much data." +
        "\nThe absolute minimum amount of data I could fetch was still greater than the total RAM of the micro-controller.",

    lampClockImageDescription_11: "Code of a AWS Lambda minimizing weather api data",
    lampClockSectionHeader_11: "Serverless to the rescue!",
    lampClockSectionDescription_11: "On triggering the AWS Lambda it accesses the weather api and filters out unused data." +
        "\nAs long as there is no more than 1 request every 15 minutes the free version of the weather api is sufficient." +
        "\nAs Json is a bit too inefficient for the micro controller I chose to use an octet stream." +
        "\nIt contains all the temperatures for next 24 hours and then boolean values for the next 24 hours to determine whether to expect rain." +
        "\nI tried display a forecast of several days on the lamp but it got too hard to seperate visually so I stuck to 24 hours.",

    lampClockImageDescription_12: "Configuration of Led-strips positions",
    lampClockSectionHeader_12: "Mapping Led Indices",
    lampClockSectionDescription_12: "To program the led stripes I need to know their positions." +
        "As they are all connected sequentially I just need to know their individual lengths.",

    lampClockImageDescription_13: "Configuration of color modes",
    lampClockSectionHeader_13: "Configuring Color Animations",
    lampClockSectionDescription_13: "All led-strips result in 4 formations." +
        " \nThe right ring displays the temperature which was fetched from the Aws Lambda & Weather Api." +
        " \nThe outer ring / big ring displays the clock time which is provided via Wifi by the modem." +
        " \nThe 'S' formation in the center displays some random color animation." +
        " \nThe left ring displays the rain forecast which was fetched via lambda & weather api too" +
        " \nMy touch points with C++ were scarce and so I've spent quite some time fixing color animations." +
        " \nThis is mostly just mapping values onto leds, waiting for delays, interpolating some colors and most importantly looping colors along the led.stripes.",

    lampClockImageDescription_14: "Code of mapping weather types to 'is rain'",
    lampClockSectionHeader_14: "Minimizing weather api data",
    lampClockSectionDescription_14: "The weather api did not just tell me weather to expect rain or wear a jacket and so I mapped those conditions myself." + "" +
        "\nSo now I will wear a jacket when it rains, snows, drizzles or when there is a thunderstorm or tornado" +
        "\nMaybe I should add an emergency led-mode for those someday.",

    lampClockImageDescription_15: "Deployment config of pio",
    lampClockSectionHeader_15: "Code deployment onto micro controller",
    lampClockSectionDescription_15: "I used platformio to deploy code via wifi & usb. This is available as plugin for common Ide's." + "" +
        "\nBased on the type of micro controller I added some boilerplate and just had to click e.g. 'upload'",

    lampClockImageDescription_16: "Completed lamp front - off",
    lampClockSectionHeader_16: "Lamp off",
    lampClockSectionDescription_16: "It looks quite nice even when turned off" +
        "\nIt requires one cable for power and has a hidden usb cable for debugging on its edge." +
        "\nIt is hung onto the wall using hooks so it can be easily taken off.",

    lampClockImageDescription_17: "Completed lamp front - on",
    lampClockSectionHeader_17: "Lamp on",
    lampClockSectionDescription_17: "It turns out it is very hard to photograph this lamp." +
        "\nSo until I take a better photo you just got to believe me what is being displayed." +
        "\nThe blue color on the top is the minutes pointer and the orange pointer on the bottom is the hour pointer. So it is roughly 06:00 or 18:00." +
        "\nThe left ring has 4 sections á 6 hours to display orange for dry weather  and blue for rainy weather." +
        "\nThe right ring displays a color range from purple -> blue -> green -> yellow -> orange -> red that represent temperatures from ~-10 to 40 degrees celsius." +
        "\nTurns out it is warm during the day and cold at night." +
        "\nThis was a great on and off project over the last years and I am happy I polished & fine tuned it twice." +
        "\nIt now hangs on the wall behind the dinner table and has a button to turn it on.",

    // BoxOfCards V3
    boxOfCardsV3Name: "Box of Cards V3",
    boxOfCardsV3Description: "Migration of a card game to dedicated servers & horizontal scaling",
    boxOfCardsV3SubHeader: "Migrating a collaborative web card game to dedicated servers & horizontal scaling. For more information see V2 and V3.",
    boxOfCardsV3SectionImageDescription_01: "New Landing Page",
    boxOfCardsV3SectionHeader_01: "Box of Cards Beta Release!",
    boxOfCardsV3SectionDescription_01: "I am very proud that Box of Cards is now released." +
        "__LINEBREAK__" +
        "\nIt took me years of spare time developing it." +
        "\nThis could have been done way faster but I really desired to embrace several learning opportunities and new technologies on the way." +
        "__LINEBREAK__" +
        "\nThis page contains information on features of box of cards, why I switched from AWS to Digital Ocean and the final tech stack.",
    boxOfCardsV3SectionImageDescription_02: "Main Menu",
    boxOfCardsV3SectionHeader_02: "Games, Decks & Account",
    boxOfCardsV3SectionDescription_02: "This main menu is displayed after logging in." +
        "__LINEBREAK__" +
        "\n3rd party Logins via e.g. Discord unlock custom Decks & Account management." +
        "\nGuests can host games but not manage decks as I need a permanent identifier to assign decks to.",
    boxOfCardsV3SectionImageDescription_03: "A Gamelobby with the Decks tab active",
    boxOfCardsV3SectionHeader_03: "Gamelobby Deck Selection",
    boxOfCardsV3SectionDescription_03: "After clicking on 'Host Game' a new Gamelobby is created." +
        "\nThe host can then select and like decks on the active Decks tab.",
    boxOfCardsV3SectionImageDescription_04: "A Gamelobby with the Options tab active",
    boxOfCardsV3SectionHeader_04: "Gamelobby Option Selection",
    boxOfCardsV3SectionDescription_04: "The Options tab enables the host to customize game rules." +
        "\nThis includes e.g. whether a sentence is automatically being drawn or selected and whether the winner is being chosen by the cardinal or being voted by all.",
    boxOfCardsV3SectionImageDescription_05: "Gamelobby Invite Overlay",
    boxOfCardsV3SectionHeader_05: "Inviting Players",
    boxOfCardsV3SectionDescription_05: "This game is played with others. The host can copy and send join links to play mates." +
        "\nAI Players can also be added for their supreme humor or testing deck creations by yourself.",
    boxOfCardsV3SectionImageDescription_06: "Game with active Sentence Selection",
    boxOfCardsV3SectionHeader_06: "Sentence Selection",
    boxOfCardsV3SectionDescription_06: "This is a game in which sentences are being actively chosen." +
        "\nThe host selected the top left sentence  card and can now confirm it." +
        "\nThe info box at the bottom always tells players when and what to do." +
        "\nThe players are displayed at the top with their avatars. Here all players except the host are AIs." +
        "\nThe host avatar has tags which mark him as host and cardinal.",
    boxOfCardsV3SectionImageDescription_07: "Gamelobby with host selecting Answers",
    boxOfCardsV3SectionHeader_07: "Answer Selection",
    boxOfCardsV3SectionDescription_07: "In this round the host has to choose two answers from his five answers." +
        "\nHe chose 'Lots of Coffee' first and 'Their Bot Nets' second." +
        "\nThe Answer Options 'Lots of' and 'Their' are highlighted as the host selected those specifically." +
        "\nCurrently the AI Barlow is Cardinal and will decide the best contribution.",
    boxOfCardsV3SectionImageDescription_08: "GameLobby with Player presenting Answers",
    boxOfCardsV3SectionHeader_08: "Answer Presentation",
    boxOfCardsV3SectionDescription_08: "All submitted Answer-Stacks are presented by a player." +
        "\nNormally this would be done by the Cardinal but AIs can't present and thus a player has to. Submissions are anonymous and non-chronological to avoid picking best friends.",
    boxOfCardsV3SectionImageDescription_09: "Host presents winning Answer submission",
    boxOfCardsV3SectionHeader_09: "Winner Presentation",
    boxOfCardsV3SectionDescription_09: "Barlow liked the Answers submitted by the host and thus the host scored a point." +
        "\nScores are being displayed on top of the avatar if any points are earned." +
        "\nIf you like the result you can download an image of it as keepsake or share it on social media & messengers." +
        "__LINEBREAK__" +
        "\nThe ad placeholder on the bottom is the primary way to monetize Box of Cards and to pay server bills.",
    boxOfCardsV3SectionImageDescription_10: "Active History tab",
    boxOfCardsV3SectionHeader_10: "History",
    boxOfCardsV3SectionDescription_10: "The game stores results of previous rounds and provides access via the History tab." +
        "\nDue to the mobile view this tab is currently being hidden in the '...' menu-button." +
        "__LINEBREAK__" +
        "\nThe history can be downloaded too. Though only 12 cards may be downloaded at once to keep browser & server happy. If more than 12 cards are available a selection will appear to switch between parts of the history.",
    boxOfCardsV3SectionImageDescription_11: "Game in light mode and german",
    boxOfCardsV3SectionHeader_11: "Theme & Language",
    boxOfCardsV3SectionDescription_11: "Box of Cards automatically opens in light or dark mode based on your browser default." +
        "\nAdditionally you can play it in german or english. Decks are exempt from your language selection, so those won't translate by themselves.",
    boxOfCardsV3SectionImageDescription_12: "A Users Deck Management Page",
    boxOfCardsV3SectionHeader_12: "Deck Creation",
    boxOfCardsV3SectionDescription_12: "The most important part of Box of Cards are the custom decks." +
        "\nDecks contain general information like a name, description, language, a marker for rough content and of course sentences & answers.",
    boxOfCardsV3SectionImageDescription_13: "A User editing a Deck",
    boxOfCardsV3SectionHeader_13: "Deck Editing",
    boxOfCardsV3SectionDescription_13: "The left half contains the sentences of the deck and the right half the answers." +
        "\nFor test purposes selected Answers can be inserted into the selected Sentence using the 'Insert in X' buttons." +
        "\nSentences & Answers can be downloaded & uploaded separately.",
    boxOfCardsV3SectionImageDescription_14: "Deck Info Tab",
    boxOfCardsV3SectionHeader_14: "Deck Info",
    boxOfCardsV3SectionDescription_14: "Statistics and settings of the edited deck.",
    boxOfCardsV3SectionImageDescription_15: "Downloaded Sentences & Answers in Text Editor",
    boxOfCardsV3SectionHeader_15: "Deck Format",
    boxOfCardsV3SectionDescription_15: "To keep deck editing as simple as possible the answers & sentences are split into two downloadable files." +
        "\nEvery line contains one sentence or one answer." +
        "\nA Sentence can have up to 3 placeholders/underscores '_'." +
        "\nAnswers can have up to 3 options which allow exchangable text snippets '[A,the,]'.",
    boxOfCardsV3SectionImageDescription_16: "Login via 3rd Party using Discord",
    boxOfCardsV3SectionHeader_16: "Discord Login",
    boxOfCardsV3SectionDescription_16: "To track & manage as little user data as possible I only use 3rd party logins." +
        "\nThis is also the minimum amount of data I can fetch from Discord." +
        "__LINEBREAK__" +
        "\nThe Discord Developer Portal is amazing. It feels like being home <3.",
    boxOfCardsV3SectionImageDescription_17: "Summary of the Box of Cards Discord Server",
    boxOfCardsV3SectionHeader_17: "Box of Cards Discord Server",
    boxOfCardsV3SectionDescription_17: "I created a Discord Server to interact with the Box of Cards community." +
        "\nHere I will gather & respond feedback, provide changelogs & give players a place to socialize.",
    boxOfCardsV3SectionImageDescription_18: "Frequently asked Questions Page",
    boxOfCardsV3SectionHeader_18: "FAQ",
    boxOfCardsV3SectionDescription_18: "Nobody asked any of these questions yet." +
        "\nBut I guess most FAQ pages are created from guesses and expanded upon afterwards.",
    boxOfCardsV3SectionImageDescription_19: "Legal Notice Page",
    boxOfCardsV3SectionHeader_19: "Legal Stuff",
    boxOfCardsV3SectionDescription_19: "There is SO MUCH legal stuff to comply with and there are many partial overlaps too." +
        "\nIt feels impossible to avoid repetitive statements when complying with all of Europe, Great Britain, Germany, USA, California, Australia, etc.",
    boxOfCardsV3SectionImageDescription_20: "I cope with Memes",
    boxOfCardsV3SectionHeader_20: "Planning and AWS",
    boxOfCardsV3SectionDescription_20: "From this point onwards this will be technical till the end." +
        "__LINEBREAK__" +
        "\nMy professor for Software Engineering said: 'Planning is essential but plans are useless'. I repeat this often." +
        "__LINEBREAK__" +
        "\nInitial AWS cost calculations showed a very large margin for profit but reality was catching up." +
        "__LINEBREAK__" +
        "\nOn paper and in the documentation AWS Services provided the features I needed." +
        "\nBut sometimes the feature is just not working." +
        "\nThe core services like AWS Lambda, S3, DynamoDb, etc. are completely fine." +
        "\nBut as soon as you start using something a bit more exotic like Appsync or a Websocket Api Gateway there will be problems and workarounds are costly.",
    boxOfCardsV3SectionImageDescription_21: "A variation on the Java Meme",
    boxOfCardsV3SectionHeader_21: "Websockets on AWS",
    boxOfCardsV3SectionDescription_21: "My servers need to inform clients on game state updates and thus I need Websockets. Long polling is just not viable." +
        "__LINEBREAK__" +
        "\nThe Appsync documentation was meant to provide websocket subscription support but the limitations are so artificially severe that I had to look for an alternative." +
        "\nSo I connected my Websockets to the AWS Api Gateway and forwarded them to my AWS Lambda." +
        "\nSadly the Disconnect handling is only best effort and quite unreliable." +
        "\nI had no way to inform disconnected clients and the only way to solve this would have been Long Polling, yikes." +
        "\nThe websocket connection also automatically disconnects after 10 minutes and this can not be changed at all.",
    boxOfCardsV3SectionImageDescription_22: "I really enjoy clean architecture",
    boxOfCardsV3SectionHeader_22: "Open AWS Bugs",
    boxOfCardsV3SectionDescription_22: "I saw so many open bug reports from 2018 that I wonder whether anybody is supporting these services." +
        "__LINEBREAK__" +
        "\nThere are minor things like AWS Api Gateway stringifying my forwarded body and me having to convert back my integers." +
        "__LINEBREAK__" +
        "\nBut there is also the interaction between cloudformation stacks across regions." +
        "\nThese interactions are not avoidable as global Services like e.g. Cloudfront are only available in us-east-1 but I got my core services in eu-west-1." +
        "\nA deployment might work fine a few times and suddenly permissions are missing to update or delete a service." +
        "\nSuddenly you spend up to hours to manually add permissions and delete singular services just to get back to start.",
    boxOfCardsV3SectionImageDescription_23: "I learned to test services beforehand",
    boxOfCardsV3SectionHeader_23: "May AWS Appsync burn",
    boxOfCardsV3SectionDescription_23: "How bad can it really be?" +
        "__LINEBREAK__" +
        "\n Well the community reimplemented Appsync and Apollo using AWS Lambda." +
        "__LINEBREAK__" +
        "\nWhat were my problems with Appsync?" +
        "\nThere are several. AWS Appsync uses GraphQl but in a limited way and with proprietary annotations. Due to this most of the eco-system can not be used and the abundant boilerplate can not be generated." +
        "__LINEBREAK__" +
        "\nThere is a severe mismatch between supported protocols and protocol versions of Apollo & AWS Appsync." +
        "\nAppsync does not support the mqtt websocket protocol and Apollo is so far behind that they say to use some other standard." +
        "\nNothing remains compatible. Legacy protocols were deprecated and removed while modern standards are not yet supported." +
        "\nLuckily I could heavily downgrade Apollo to use a legacy protocol.",
    boxOfCardsV3SectionImageDescription_24: "Yes I need two Memes on this",
    boxOfCardsV3SectionHeader_24: "More on Appsync..",
    boxOfCardsV3SectionDescription_24: "The proprietary AWS-Scalar type is incompatible with HttpClients and Key-Value-Pairs are not supported at all." +
        "\nI had to wrap those Pairs in json and I really don't like nesting my data formats." +
        "__LINEBREAK__" +
        "\nAppsync subscriptions are a total mystery to me. I need one subscription per topic, I can only respond to a single user at a time, I can't know who those users are" +
        "\nand the data I send can only contain values for fields that were provided on the subscription request." +
        "\nThe last one is problematic as I can't provide values for fields that were previously not set due to being optional.",
    boxOfCardsV3SectionImageDescription_25: "I can't call this refactoring right?",
    boxOfCardsV3SectionHeader_25: "A dooming Decision",
    boxOfCardsV3SectionDescription_25: "I had seen this coming for a long time but it is fine for me as this was a project for learning new technologies from the get go." +
        "__LINEBREAK__" +
        "\nThe serverless architecture probably still allowed the Box of Cards to become profitable but there was almost no fun left and development administration felt needlessly clunky." +
        "__LINEBREAK__" +
        "\nI wanted to get rid of Appsync as without websocket subscriptions it was just a more expensive and more cumbersome Api Gateway." +
        "\nBut the Api Gateway was also unreliable for websockets and so I wanted to try an alternative via a small prototype. Because this time I don't trust the documentation.",
    boxOfCardsV3SectionImageDescription_26: "Foreshadowing",
    boxOfCardsV3SectionHeader_26: "Caching is your friend",
    boxOfCardsV3SectionDescription_26: "AWS Lambda reduced server costs but there was a lack of a cost efficient cache for my use case. As weird as it may sound but DynamoDb was just Overkill for most of my caching requirements." +
        "__LINEBREAK__" +
        "\nOne Megabyte of shared Lambda Cache would have been enough to reduce my DynamoDb calls by ~ 90% for thousands of simultaneous games." +
        "\nAWS Lambda have a limited shared cache as long as they are hot but this is seriously not meant for this purpose." +
        "__LINEBREAK__" +
        "\nSo what I need is basically a semi persistent Server. Then I could adjust the server count based on demand and so I tried that out.",
    boxOfCardsV3SectionImageDescription_27: "You may really try to change my mind",
    boxOfCardsV3SectionHeader_27: "Prototyping dedicated AWS instances",
    boxOfCardsV3SectionDescription_27: "I want Box of Cards to remain scalable even though it would probably run fine forever on a single server. Switching to dedicated instances would allow stable websocket connections and cost savings by replacing DynamoDb with in-memory cache." +
        "__LINEBREAK__" +
        "\nMost of my code is on AWS and so I will try it on AWS first." +
        "\nSo is there a way to have cheap and horizontally scalable node instances on AWS?" +
        "\nI tried using AWS Fargate as it is meant for exactly this and migrating my NodeJs Lambda onto a NodeJs Sever in Docker would be easy." +
        "__LINEBREAK__" +
        "\nThe Fargate-cluster ran fine and there was just one issue to solve: How do I target a specific instance?" +
        "\nThe documentation said that I could turn the Fargate instances public but that turned out to be wrong. Then it said I could use AWS CloudMap to access a public IP but it only returns a private one." +
        "__LINEBREAK__" +
        "\nI could only target the whole Fargate cluster but could I pass on data that would allow e.g. the Load Balancer to select a specific instance?" +
        "\nSticky Sessions allow keeping up the connection to a specific instance but sadly the initial connection is still chosen at random." +
        "\nFor a multiplayer game I require players of the same game to end up on the same instance." +
        "__LINEBREAK__" +
        "\nI could manually scale dedicated servers without fargate but AWS is frigging expensive and then you always need something costly extra like a Nat Gateway, a VPC Endpoint, etc.",
    boxOfCardsV3SectionImageDescription_28: "Back to simpler life",
    boxOfCardsV3SectionHeader_28: "Digital Ocean <3",
    boxOfCardsV3SectionDescription_28: "Wait didn't I run Box of Cards on Digital Ocean in V1?" +
        "\nPsssht!" +
        "__LINEBREAK__" +
        "\nBox of Cards V1 already ran okay-ish on Digital Ocean using Kubernetes but this was not using dedicated Servers but using a shared redis." +
        "__LINEBREAK__" +
        "\nSo why do I choose Digital Ocean this time?" +
        "\nThe traffic costs and nodes are way cheaper. The nodes can be public and I don't need any of: Load Balancer, Vpc Endpoint,Vpc Gateway, Nat Gateway." +
        "\nIt has everything I need and a wonderful UI." +
        "__LINEBREAK__" +
        "\nAWS is fine for bigger projects and if you stick to the core services though." +
        "\nThere gotta be a reason I suffered through the AWS Solution Architect Associate certification!",
    boxOfCardsV3SectionImageDescription_29: "All technologies used in the Web Client",
    boxOfCardsV3SectionHeader_29: "Web Client Tech",
    boxOfCardsV3SectionDescription_29: "GraphQl is no longer part of this but otherwise this is the same as in V2.",
    boxOfCardsV3SectionImageDescription_30: "Technologies for deploying the Web Client.",
    boxOfCardsV3SectionHeader_30: "Web Client Deployment Tech",
    boxOfCardsV3SectionDescription_30: "I automated deploying the web-client to AWS S3 and the generation of web certificates using AWS Cloudformation",
    boxOfCardsV3SectionImageDescription_31: "Technologies shared across Backend Nodes",
    boxOfCardsV3SectionHeader_31: "Backend Core Tech",
    boxOfCardsV3SectionDescription_31: "For further information on this Tech Stack have a look at my Ts-Cluster project.",
    boxOfCardsV3SectionImageDescription_32: "AWS & Digital Ocean Components",
    boxOfCardsV3SectionHeader_32: "Components",
    boxOfCardsV3SectionDescription_32: "This is also very similar to the Ts-Cluster project with minor additions." +
        "__LINEBREAK__" +
        "\nI added a MongoDb instance into the Registrar Droplet to store decks & user settings." +
        "\nThe Registrar Droplet has by default a lot of unused space and does not need that much RAM & CPU. This works because only the Registrar Droplet requires a database and the web client forwards decks to the Websocket Droplets." +
        "\nAutomated MongoDb backups are stored in Digital Ocean Spaces and used upon starting a Registrar." +
        "__LINEBREAK__" +
        "\nDroplets are started using Snapshots from the Digital Ocean Registry." +
        "__LINEBREAK__" +
        "\nFinally my Registrar manages horizontal Websocket Droplet scaling and creates/deletes dns records for dedicated server access using AWS Route 53." +
        "__LINEBREAK__" +
        "\nI really love the Digital Ocean Api. Overall there were only 2 minor issues and I can't even remember them.",
    boxOfCardsV3SectionImageDescription_33: "All tests in Webstorm in a single run",
    boxOfCardsV3SectionHeader_33: "Backend Tests",
    boxOfCardsV3SectionDescription_33: "The application has exclusively end-to-end tests." +
        "\nMost of the internal logic is quite simple, and I'm interested in whether the overall system works as expected." +
        "\nThe tests were incredibly helpful, especially during migrations between technologies.",
    boxOfCardsV3SectionImageDescription_34: "As a developer I use this Meme often",
    boxOfCardsV3SectionHeader_34: "Fun with Axios",
    boxOfCardsV3SectionDescription_34: "Axios a backbone of the world wide web." +
        "__LINEBREAK__" +
        "\nBecause of this it feels funny when you pass your baseUrl like 'https://boxof.cards' to an axios request and Axios just overrides it with 'http://localhost:8080'." +
        "__LINEBREAK__" +
        "\nIt took me hours to debug and understand the code behind this. There are multiple levels of default values for urls and it really just ignores your parameter." +
        "__LINEBREAK__" +
        "\nAll of this would not be a problem if talking to a single server and using the constructor baseUrl but I manage multiple Websocket Nodes." +
        "__LINEBREAK__" +
        "\nIt is also not sufficient to change the source code once as this is part of multiple generated Apis gluing my Services together." +
        "\nSo after Api-generation, a script is run to replace the troublesome code in the generated files.",
    boxOfCardsV3SectionImageDescription_35: "React Router, you okay?",
    boxOfCardsV3SectionHeader_35: "Major Updates everywhere",
    boxOfCardsV3SectionDescription_35: "I am glad that the react eco-system and Material UI slowed down." +
        "__LINEBREAK__" +
        "\nWhile developing Box of Cards I went through two major Updates for most libraries." +
        "\nAfter my final update I was quite surprised when react-router decided to remove an essential feature and provided no way to replace it." +
        "\nHow did I solve this? Well I did not. Not everything has to be solved." +
        "__LINEBREAK__" +
        "\nI could talk dozens of hours on the development of Box of Cards. Reach out to me if something interests you." +
        "__LINEBREAK__" +
        "\nThanks for reading. Have fun with Box of Cards and leave me some feedback on its Discord.",

    // Ts-cluster
    tsClusterName: "TS-Cluster",

    tsClusterDescription: "A horizontal cluster scaling for dedicated servers with NestJs and Digital Ocean",
    tsClusterSubHeader: "A horizontal cluster scaling for dedicated servers with NestJs and Websockets.",
    tsClusterSectionImageDescription_01: "Technologies used (DrawIo)",
    tsClusterSectionHeader_01: "Tech Stack",
    tsClusterSectionDescription_01: "All nodes are based on NestJs and therefore on NodeJs. It is written in Typescript and dockerized." +
        "\nFor the communication between the nodes (registrar node, websocket node, test node), HTTP clients are generated from the controller classes using Swagger and Nest-OpenApi." +
        "__LINEBREAK__" +
        "\nThe nodes are created and deleted via Digital Ocean as a cloud provider. My domains are in AWS and for HTTPS/SSL/CORS I have to register A-Records/Subdomains." +
        "\nSo after starting up a Digital Ocean Droplet, I also create an A-Record for a subdomain with the IP of the Droplet." +
        "__LINEBREAK__" +
        "\nBut why all this? I need horizontal cluster scaling with dedicated servers for other projects." +
        "\nBut surely that already exists? I thought so too, but I've tried various cloud providers. Many only offer that you get any node back. Sticky sessions for a load balancer only guarantee that you will be assigned the same node after the connection." +
        "__LINEBREAK__" +
        "\nBut for multiplayer games I want to use in-memory cache and therefore need to guarantee that all users connect to the same node." +
        "\nFor example, I have tried a lot with specialized services, Kubernetes, AWS Fargate with AWS CloudMap and the documentation claims that dedicated access is possible, but I have not been able to confirm this." +
        "__LINEBREAK__" +
        "\nThere are then some services and especially some big workarounds that would make this possible, but the costs are at least 5 - 20 times higher for the same resources." +
        "\nSo I prototyped a cluster scaling and then implemented it with this project.",
    tsClusterSectionImageDescription_02: "Backend component diagram (DrawIo)",
    tsClusterSectionHeader_02: "Components",
    tsClusterSectionDescription_02: "My domains and my websites are currently in AWS and my deployments there are done with AWS Cloudformation." +
        "\nI use the NPM package 'do-wrapper' for Digital Ocean Cluster scaling. Many functionalities are mapped, but I added some with Axios." +
        "\nI start up the registrar-droplet and because no websocket droplets exist yet, one is started up directly." +
        "__LINEBREAK__" +
        "\nThe end user downloads the web client and it will then request the registrar droplet endpoint https://registrarnode1@mydomain.de/get-websocket-url and get back a URL for the websocket droplet." +
        "\nDepending on the load, this can then be websocketnode1, websocketnode2, etc." +
        "__LINEBREAK__" +
        "\nCurrently droplets are only shut down if there are no more active sessions on them and at least one other droplet is underloaded." +
        "\nA new Droplet is started when all Droplets are overloaded. There is a websocket-droplet minimum of 1 and an absolute maximum of X to avoid going bankrupt overnight.",
    tsClusterSectionImageDescription_03: "Folder structure (Webstorm)",
    tsClusterSectionHeader_03: "Folder structure",
    tsClusterSectionDescription_03: "The project consists of several NestJs applications that end with ‘node’. There is also a folder with deployment scripts." +
        "\nIn '_common' is the code that all applications share, such as array & string utility functions." +
        "\nIn '_shared' are generated APIs, models and types." +
        "\nThe 'certificates' folder contains wildcard certificates that I use for HTTPS/CORS in the nestJs applications." +
        "\nAnd '_test' contains tests for each node and between the nodes. The '.env.*' files contain environment variables for different deployments & tests.",
    tsClusterSectionImageDescription_04: "UI Digital Ocean Container Registry",
    tsClusterSectionHeader_04: "Docker Images",
    tsClusterSectionDescription_04: "The Digital Ocean Droplets have to pull their Docker images from somewhere, so I also store them in Digital Ocean." +
        "\nThe NestJs applications are compiled in the 1st step of their Dockerfile and only the compiled applications are transferred to the 2nd step." +
        "\nSo unnecessary files are minimized and only necessary files like the finished application and certificates are copied." +
        "\nI need applications for different tests, and therefore there is e.g. the registrar image for beta and dev.",
    tsClusterSectionImageDescription_05: "UI Digital Ocean Snapshots",
    tsClusterSectionHeader_05: "Droplet Snapshots",
    tsClusterSectionDescription_05: "Digital Ocean offers to make exact copies of active droplets. These enable a faster startup of e.g. new websocket droplets, since the setup of the Debian OS is already completed." +
        "\nThis includes: Installing Docker, pulling images, initializing SSL, stopping unnecessary system processes and uninstalling system packages, etc..." +
        "__LINEBREAK__" +
        "\nTip: When creating a snapshot, no Docker containers should be active, otherwise they will be stopped and the name of the Docker container will already be unavailable when the Droplet is started." +
        "\nAlso all logs are seamlessly transferred and I thought for a while that my snapshot had a failed container." +
        "\nTldr: Containers should only be started in the snapshot.",
    tsClusterSectionImageDescription_06: "UI Domains in AWS Route53",
    tsClusterSectionHeader_06: "Domains",
    tsClusterSectionDescription_06: "These are the subdomains that are created when the cluster is started." +
        "\nIn this case, the subdomains are for a test that created sessions until 3 websocket nodes were active, and then sessions were terminated on websocketnode2 until this droplet was shut down and the subdomain was deleted." +
        "\nAny domain provider with a good API is sufficient for this.",
    tsClusterSectionImageDescription_07: "Tests (Webstorm)",
    tsClusterSectionHeader_07: "Tests",
    tsClusterSectionDescription_07: "Jest is used locally to test whether, for example, a registrar node starts websocket nodes via the Digital Ocean API." +
        "\nFor this, endpoints are mocked with Nock and endpoints are determined by the .env.* files." +
        "__LINEBREAK__" +
        "\nIn addition, there are tests that directly address the Digital Ocean Cloud. These tests can take 5-15 minutes as multiple droplets are booted and shut down by snapshots." +
        "\nSometimes a test fails due to IP address caching on my local operating system." +
        "\nThe subdomains are frequently reassigned during tests and this is not a behavior that will occur in live operation.",
    tsClusterSectionImageDescription_08: "UI Digital Ocean Droplets",
    tsClusterSectionHeader_08: "Droplets",
    tsClusterSectionDescription_08: "Registrar droplets and websocket-droplets need each other and cannot be tested on their own in a live cloud environment." +
        "\nTherefore I have additional test-droplets with which I can run simpler tests.",
    tsClusterSectionImageDescription_09: "",
    tsClusterSectionHeader_09: "Conclusion",
    tsClusterSectionDescription_09: "I have a registrar droplet and a websocket droplet on the lowest scaling. Together with Snapshot & Image Registry I pay less than 10 € per month for the minimum utilization." +
        "\nHowever, there is not much RAM left for active sessions. Of the 500 MB RAM, 400 - 450 are already used by the OS, Docker and the NestJs Docker container." +
        "\nSo I run the application directly with 1 GB RAM and increase the value as soon as it makes sense." +
        "__LINEBREAK__" +
        "\nI won't use vertical scaling for now, as I want to gain more direct experience with horizontal scaling with this project." +
        "\nI would like to tackle session migrations later. This will allow me to shut down droplets earlier and manage resources more efficiently." +
        "__LINEBREAK__" +
        "\nBut for now I'm very happy with the project. I'm looking forward to applying it to Box of Cards in the near future.",

    // BoxOfCards V2
    boxOfCardsV2Name: "Box of Cards V2",
    boxOfCardsV2Description: "Migration of a customizable card game to serverless",
    boxOfCardsV2SubHeader: "Migrating a collaborative web card game to serverless. For more info see V1 and V3.",
    boxOfCardsV2LandingPageImageDescription: "Landing page",
    boxOfCardsV2CardTutorialImageDescription: "Tutorial",
    boxOfCardsV2ComponentsImageDescription: "Architecture",

    boxOfCardsV2SectionImageDescription_01: "Box of Cards landing page",
    boxOfCardsV2SectionHeader_01: "Why V2?",
    boxOfCardsV2SectionDescription_01:
        "The previous version ran with Kubernetes and a Redis cluster." +
        "__LINEBREAK__" +
        "\nWhile the system worked in test runs, load tests showed that the synchronization of the nodes via Redis was a bottleneck." +
        "\nDespite automatic deployments, maintenance and especially logging proved to be insufficient." +
        "__LINEBREAK__" +
        "\nA project with migration parts to AWS Serverless was pending and so I decided to test this on Box of Cards." +
        "__LINEBREAK__" +
        "\nThis is possible because the card game does not require fast latencies and can also cope with occasional cold starts." +
        "\nFirst calculations showed that AWS serverless should work out in terms of costs, although the correct parameterization is difficult to estimate." +
        "\nAdditional findings on this later.",
    boxOfCardsV2SectionImageDescription_02: "Tutorial of the landing page",
    boxOfCardsV2SectionHeader_02: "Short tutorial",
    boxOfCardsV2SectionDescription_02:
        "There is now an interactive tutorial on the home page and some other pages." +
        "\nOne of two answers can be inserted into the sentence. Words in the first answer are interchangeable.",
    boxOfCardsV2SectionImageDescription_03: "Use technologies (DrawIo)",

    boxOfCardsV2SectionHeader_03: "Tech Stack",
    boxOfCardsV2SectionDescription_03: "The technologies used have changed significantly compared to V1." +
        "\nThe code was easy to migrate to AWS Lambda. I initially opted for AppSync (with Apollo and GraphQL) for the backend API because it enables websocket subscriptions." +
        " Only later did I realize that these subscriptions can only respond to their own topic. In addition, no MQTT protocol is supported." +
        " Because of this, I now need a websocket api gateway that maintains websocket connections and triggers Lambdas." +
        "__LINEBREAK__" +
        "\nThe problem is that this gateway and the sockets do not provide any cache and all links from socketID to userID must be persisted in the DynamoDB." +
        "\nAlso the Lambda Cache would not be suitable. I have tried many solutions, but in the end, increased DynamoDB costs remain." +
        "\nThis is particularly annoying because at least 1KB is always charged, even if I only read a few bytes." +
        "__LINEBREAK__" +
        "\nFor the authentication I disconnected from Google-Firestore and tried a few things." +
        "\nAWS Cognito is out because it has compatibility issues with AWS Cloudformation and setting up OAuth was a nightmare." +
        "\nAfterwards I tried Keycloak and although I am a big fan of the interface and documentation, it remains overkill for my purposes." +
        "\nNow there is a 3rd party login via Discord and others will follow later." +
        "__LINEBREAK__" +
        "\nThe rest went very well. The website is in S3. GameStates and decks are persisted in DynamoDB." +
        "\nThe entire application is deployed with AWS Cdk (Cloudformation). There is an AWS root account with domains and permissions and 3 accounts underneath for dev, beta and live." +
        "__LINEBREAK__" +
        "\nAll tests are Jest end-to-end tests on a dev environment. On the beta environment I test with friends." +
        "\nChatGPT is now a good time saver when writing tests and analyzing bugs.",


    boxOfCardsV2SectionImageDescription_04: "Backend component diagram (DrawIo)",
    boxOfCardsV2SectionHeader_04: "Components",
    boxOfCardsV2SectionDescription_04: "As a developer, I can deploy all stacks and test data with Cloudformation with one command." +
        "\nAs an end user, I call up the domain and the DNS entries stored in Route 53 are used to resolve to Cloudfront." +
        " Cloudfront then forwards to the S3 in which the static web application is located. Cloudfront usually returns the now downloaded web page now accesses AWS Route53 entries and Cloudfront again for the backend, but is forwarded to the AWS Api gateway for websockets and to AWS AppSync for HTTP requests." +
        "\nCaching in Cloudfront shortens these paths." +
        "__LINEBREAK__" +
        "\nAs a developer, I usually only access Cloudformation for deployment and Cloudwatch for logging and alerts." +
        "\nOccasionally I still look at data in DynamoDB when debugging.",
    boxOfCardsV2SectionImageDescription_05: "Start page in a newer design",
    boxOfCardsV2SectionHeader_05: "UI adjustments",
    boxOfCardsV2SectionDescription_05: "The original design didn't feel polished yet, so I tried out some other styles." +
        "\nDrop shadows can be used to create nice pop effects and these are now applied to many interactive elements." +
        "\nResponsiveness still works on very low resolutions like 300 x 640.",
    boxOfCardsV2SectionImageDescription_06: "Game lobby under revision",
    boxOfCardsV2SectionHeader_06: "UI - Work in Progress",
    boxOfCardsV2SectionDescription_06: "This is how it looks from time to time when core components have been revised but other components have not yet been updated.",
    boxOfCardsV2SectionImageDescription_07: "Game lobby after the revision",
    boxOfCardsV2SectionHeader_07: "UI - Work after Progress",
    boxOfCardsV2SectionDescription_07: "This is what it will look like when the GameLobby component has been tidied up. It's not final yet, but definitely better than before.",
    boxOfCardsV2SectionImageDescription_08: "Active game in mobile view",
    boxOfCardsV2SectionHeader_08: "Responsiveness challenge",
    boxOfCardsV2SectionDescription_08: "There are many tabs on the game page, and displaying them in several rows doesn't look good and also causes problems with the maximum height." +
        "\nTherefore, a menu is used here to summarize tabs on narrow screen widths.",
    boxOfCardsV2SectionImageDescription_09: "Active test game in desktop view",

    boxOfCardsV2SectionHeader_09: "History and Layout Tests",
    boxOfCardsV2SectionDescription_09: "The best cards of the last rounds can be viewed in the History tab." +
        "\nFirst I used grids, but they weren't flexible enough. So I switched to flex boxes.",
    boxOfCardsV2SectionImageDescription_10: "Active test game with long texts",
    boxOfCardsV2SectionHeader_10: "Responsiveness to the limit!",
    boxOfCardsV2SectionDescription_10: "At first I had scrollable cards, but since cards themselves are in a scrollable container, this makes the operation error-prone." +
        "\nNow cards have a minimum size and scale in height with their content. This means that Flex-Box alone is no longer sufficient, as the row size must be based on the largest element." +
        "\nGamestate-dependent, the upper or lower card container is also given more height. In this GameState, the winner is to be selected, so the upper container has more height available." +
        "\nThe remaining height or minimum height goes to the lower container.",
    boxOfCardsV2SectionImageDescription_11: "Dynamic window sizes for active game",
    boxOfCardsV2SectionHeader_11: "Responsiveness in action",

    boxOfCardsV2SectionDescription_11: "The responsive behavior is made possible by a variety of design decisions." +
        "\nSwapping elements into tabs, hiding the tab container, merging the navbar elements into a burger menu and the flex behavior of the card container." +
        "\nThere is now a lot of logic in the card containers in particular, as CSS does not enable this level of responsiveness." +
        "\nThe problem is that it is not known in advance how much space a text requires and how many line breaks and thus text rows there are." +
        "__LINEBREAK__" +
        "\nAfter rendering the elements, I display the dimensions of the containers and then use the window sizes, map sizes and which map container has priority to determine the optimal layout." +
        "\nEven if 5 cards would fit next to each other in some places, I prefer to display them in 2 rows." +
        "\nAll this can make for minimal flickering as it requires 2 renders and heights change, but without writing a completely custom text renderer, it doesn't get any better." +
        "__LINEBREAK__" +
        "\nI think it's pretty.",
    boxOfCardsV2SectionImageDescription_12: "Chat and avatars in game lobby",

    boxOfCardsV2SectionHeader_12: "Avatars",
    boxOfCardsV2SectionDescription_12: "Single names are pretty boring and I have to abbreviate longer names for responsiveness." +
        "\nIn addition, I need space-saving buttons to remove players and a place where I can display player-related info icons." +
        "__LINEBREAK__" +
        "\nAvatar buttons are the optimal solution here. I can display: is host, is cardinal, is ready, is expected and can be thrown out.",
    boxOfCardsV2SectionImageDescription_13: "AI player and dark mode in active game",
    boxOfCardsV2SectionHeader_13: "AI player",
    boxOfCardsV2SectionDescription_13: "AI players all look like robots and are at least as funny as real players thanks to excellent AI." +
        "\nIt would be nice if they could syntactically match answer cards to the sentence correctly, but there are no cheap APIs or good open source solutions for this yet." +
        "__LINEBREAK__" +
        "\nKIs can be added or removed at any time and the gamestate fixes itself by making decisions retroactively." +
        "\nI added them primarily because testing with 2 browser windows is tedious." +
        "__LINEBREAK__" +
        "\nThe dark mode is now also integrated.",
    boxOfCardsV2SectionImageDescription_14: "Backend scripts in package.json",

    boxOfCardsV2SectionHeader_14: "Backend scripts",
    boxOfCardsV2SectionDescription_14: "I like to have all my scripts in one place; in this case in the package.json." +
        "\nThere are now tools that abstract such scripts better, but so far I haven't liked any of them." +
        "\nThese are mostly deployment scripts for the backend and the web application. There are so many scripts due to the different runtime environments.",
    boxOfCardsV2SectionImageDescription_15: "AWS Lambda Concurrency UI",
    boxOfCardsV2SectionHeader_15: "Lambda Quota",
    boxOfCardsV2SectionDescription_15: "By default, only 10 Lambdas can run in parallel. I noticed this because my end-to-end tests failed randomly at some point." +
        " Increases must be requested with longer waiting times.",
    boxOfCardsV2SectionImageDescription_16: "Todos for jest backend tests",
    boxOfCardsV2SectionHeader_16: "Even more tests",

    boxOfCardsV2SectionDescription_16: "I can hardly express how much time my tests have saved me." +
        "\nI have written functions that bring my GameState into a certain state so that I can then run it in a targeted manner. This reduces my test sizes enormously." +
        "\nAll objects and their fields are based on indices such as: userName1, userName2, etc.. This allows me to test everything at any scale." +
        "__LINEBREAK__" +
        "\nBased on this, there are functions that allow me to create a game, add players, start the game and reach a certain gamestate." +
        "\nThis allows the test to focus on testing, for example, the selection of a hand card and the transition to the next gamestate.",
    boxOfCardsV2SectionImageDescription_17: "A sentence filled with answers",
    boxOfCardsV2SectionHeader_17: "Bugs",
    boxOfCardsV2SectionDescription_17: "There are a lot of very entertaining bugs. The first answer was always selected for all fields.",
    boxOfCardsV2SectionImageDescription_18: "Collage of most Test Suit issues",
    boxOfCardsV2SectionHeader_18: "Many, many tests",
    boxOfCardsV2SectionDescription_18: "There are now thousands of tests, and if I run them all at once, there are still a handful that fail." +
        "\nTwo tests either don't clean up sufficiently or don't clean up in time, and as a result subsequent tests fail, but then clean up well again." +
        "\nIndividually, the tests work properly and there are at least todos on them.",
    boxOfCardsV2SectionImageDescription_19: "AWS Cloudformation UI of the game object",
    boxOfCardsV2SectionHeader_19: "Cloudformation UI",
    boxOfCardsV2SectionDescription_19: "This is what the application looks like in the AWS UI for Cloudformation.",
    boxOfCardsV2SectionImageDescription_20: "AWS DynamoDB UI on",
    boxOfCardsV2SectionHeader_20: "DynamoDB UI",
    boxOfCardsV2SectionDescription_20: "Being able to analyze objects interactively helped a lot when debugging the errors." +
        "\nHowever, I am not convinced by DymamoDb per se. The syntax is error-prone and the available clients for DynamoDB make it neither easier nor safer.",
    boxOfCardsV2SectionHeader_21: "Conclusion",
    boxOfCardsV2SectionDescription_21: "Serverless is a wonderful technology, but due to the way it is offered by AWS, it is only suitable for my use case to a limited extent." +
        " I often ended up in a dead end because an essential AWS feature still has an open ticket from 2018." +
        "\nThis is taking on such abstruse proportions that the community has recreated Appsync and Apollo in AWS Lambda." +
        "\nThe core services like AWS S3, DynamoDb, Lambda Cloudfront, Route53 work well. I will avoid many other services." +
        "__LINEBREAK__" +
        "I will no longer run larger applications serverless in the future." +
        "I'm looking forward to building something with dedicated servers and in-memory caches again. A project that ties me less to cloud providers with proprietary solutions.",


    // BoxOfCards V1
    boxOfCardsV1Name: "Box of Cards V1",
    boxOfCardsV1SubHeader: "A collaborative web card game on Kubernetes",
    boxOfCardsV1LandingPageImageDescription: "Landing page",
    boxOfCardsV1DeckSelectionImageDescription: "Deck selection",
    boxOfCardsV1DeckEditorImageDescription: "Deck editor",
    boxOfCardsV1MultiplayerLobbyImageDescription: "Multiplayer lobby",
    boxOfCardsV1GameLobbyImageDescription: "Game lobby",
    boxOfCardsV1WebAppImageDescription: "Active game",
    boxOfCardsV1ComponentsAllImageDescription: "Architecture",
    boxOfCardsV1ComponentWebAppImageDescription: "Providing Web-client",
    boxOfCardsV1ComponentBackendWebAppImageDescription: "Backend architecture",
    boxOfCardsV1ComponentRedisImageDescription: "Redis architecture",
    boxOfCardsV1ComponentRabbitMqDescription: "RabbitMq architecture",
    boxOfCardsV1ComponentGoogleCloudImageDescription: "Google Cloud authentication",
    boxOfCardsV1ComponentKubeCtlGetAllImageDescription: "Cluster overview in terminal",
    boxOfCardsV1ComponentDigitalOceanKubernetesImageDescription: "Cluster overview in Digital Ocean",
    boxOfCardsV1WebClientImageDescription: "Web-client architecture",
    boxOfCardsV1BackendServicesImageDescription: "Backend services architecture",
    boxOfCardsV1PackagesImageDescription: "Backend packages",
    boxOfCardsV1GoogleCloudFunctionsImageDescription: "Google Cloud packages",
    boxOfCardsV1RabbitMqImageDescription: "RabbitMq configuration",
    boxOfCardsV1GitWorkflowImageDescription: "Github Actions",
    boxOfCardsV1ShellScriptImageDescription: "Deployment script management",
    boxOfCardsV1GameTestsImageDescription: "Successfull tests",
    boxOfCardsV1TimeoutHandlerImageDescription: "Example test output",
    boxOfCardsV1OldDesign1ImageDescription: "1st design of active game",
    boxOfCardsV1OldDesign2ImageDescription: "2nd design of active game",
    boxOfCardsV1FirstLandingPageImageDescription: "1st design of landing page",
    boxOfCardsV1SecondLandingPageImageDescription: "2nd design of landing page",
    boxOfCardsV1LoginDesignsImageDescription: "Iterative design phase",
    boxOfCardsV1LogoAttemptImageDescription: "2nd logo approach",
    boxOfCardsV1LandingPageDesignsImageDescription: "3rd logo approach",
    boxOfCardsV1GameDesign1ImageDescription: "3rd design of active game",
    boxOfCardsV1PeopleChooseFontImageDescription: "Iterative font testing",
    boxOfCardsV1FontNoUmlautsImageDescription: "Font editor",
    boxOfCardsV1FontDoesNotLikeBordersImageDescription: "Problematic Font Borders",
    boxOfCardsV1ColorDifferenceOfMyMonitorsImageDescription: "Display Color Offset",
    boxOfCardsV1ObstacleTypesImageDescription: "Test failure",
    boxOfCardsV1ObstaclesZeitplanungImageDescription: "Comedic intervention",
    boxOfCardsV1Description:
        "A customizable card game to tell stories with friends and an overkill tech stack",

    boxOfCardsV1WebappSectionHeader_01: "A long time ago",
    boxOfCardsV1WebappSectionDescription_01:
        "This is the original landing page. At lot has been done since. See V2 and V3 newer changes.",
    boxOfCardsV1WebappSectionHeader_02: "Choose Decks",
    boxOfCardsV1WebappSectionDescription_02:
        "The Host can decide to use one or combine multiple decks for the new session.",
    boxOfCardsV1WebappSectionHeader_03: "Create Decks",
    boxOfCardsV1WebappSectionDescription_03:
        "The Player can create his own decks and test them directly." +
        "\nSentences contain Answer placeholders using '_'." +
        "\nAnswers can have dropdown values by adding them comma separated into square brackets [one, two].",
    boxOfCardsV1WebappSectionHeader_04: "Multiplayer Lobby",
    boxOfCardsV1WebappSectionDescription_04:
        "Public games can be joined and seen by anyone." +
        "\nI admit I am lazy when choosing names for testing.",
    boxOfCardsV1WebappSectionHeader_05: "Game Lobby",
    boxOfCardsV1WebappSectionDescription_05:
        "The host may set the Game settings in the Game Lobby." +
        "\nHe also has to approve players wanting to join." +
        "\nOnce all players are ready the game may begin.",
    boxOfCardsV1WebappSectionHeader_06: "Game",
    boxOfCardsV1WebappSectionDescription_06:
        "Based on the settings a sentence is chosen and Players submit their Answers for voting." +
        "\nIn this case they may submit up to two Answers." +
        "\nThere already played a round and thus have a completed Card in their history at the top.",
    boxOfCardsV1ArchitectureSectionHeader_00: "Overengineered to the limit",
    boxOfCardsV1ArchitectureSectionDescription_00:
        "I started this project as I wanted to try out lots of new technologies." +
        "\nAll of this could have been done in an express server on a Raspberry Pi." +
        "\nBut a wise person once said: Give a man a fish and he eats for a day." +
        "\nGive a man a Fishing-Boat-Industry and he will never see a fish again.",
    boxOfCardsV1ArchitectureSectionHeader_01: "Components",
    boxOfCardsV1ArchitectureSectionDescription_01:
        "Now what did I choose if a node.js server would have been sufficient?" +
        "\nWell what update a kubernetes cluster containing microservices!" +
        "\nAnd what do they do? I will tell ya!",
    boxOfCardsV1ArchitectureSectionHeader_02: "Web Client",
    boxOfCardsV1ArchitectureSectionDescription_02:
        "The Web-Client is being compiled and then served by an express Server." +
        "\nThe express Server is run inside a docker container." +
        "\nAnd the docker container is deployed using a kubernetes deployment." +
        "\nLastly a domain points towards a load-balancer service which points to the express server.",
    boxOfCardsV1ArchitectureSectionHeader_03: "Backend",
    boxOfCardsV1ArchitectureSectionDescription_03:
        "Three services which handle the games multiplayer logic." +
        "\nThe MultiplayerLobby serves available GameLobbies." +
        "\nThe GameLobby handles, well.... the Games lobby." +
        "\nOnce the host clicks the start button inside the GameLobby all players migrate onto a Game Server.",
    boxOfCardsV1ArchitectureSectionHeader_04: "Redis Cluster",
    boxOfCardsV1ArchitectureSectionDescription_04:
        "Redis is being used to cache data which is required across those backend services." +
        "\nFor example it stores which player is assigned to which Game or GameLobby." +
        "\nThis avoids players being in multiple games or being unable to reconnect.",
    boxOfCardsV1ArchitectureSectionHeader_05: "RabbitMq Broker",
    boxOfCardsV1ArchitectureSectionDescription_05:
        "The broker allows us to loosely couple client sessions with backend services and thus enable scaling." +
        "\nWhen a client connects via the domain he has to use websockets (WebStomp protocol) because HTML~~~." +
        "\nThe backend services are express servers and thus use the AMQP protocol.",
    boxOfCardsV1ArchitectureSectionHeader_06: "Google Cloud",
    boxOfCardsV1ArchitectureSectionDescription_06:
        "Why on earth do I also use a google cloud additionally to kubernetes?" +
        "\nWell my initial plan was to use firebase to manage gamestate but my calculations resulted in ... bankruptcy." +
        "\nI still use google cloud functions to manage authentications and store decks though." +
        "\nNo need to implement authentication by myself." +
        "\nCloud Functions are realllly fun.",
    boxOfCardsV1ArchitectureSectionHeader_07: "My Cluster Overview",
    boxOfCardsV1ArchitectureSectionDescription_07:
        "These are all the services and config files of my running cluster, though some persistent volumes are not being displayed." +
        "\nThere is only one pod of each service as I am running on the cheapest Node plan available." +
        "\nWhy the restarts? The Broker takes some time to get up and I have yet to add readiness probes.",
    boxOfCardsV1ArchitectureSectionHeader_08: "Digital Ocean Dashboard",
    boxOfCardsV1ArchitectureSectionDescription_08:
        "Nothing fancy, just my cluster and the two load-balancers pointing at it." +
        "\nOne for fetching the web client and one for accessing the broker for multiplayer interaction." +
        "\nWhy can't this be one loadbalancer? Well I tried quite some stuff but due to port requirements across services it won't work.",
    boxOfCardsV1TechStackSectionHeader_00: "Tech Stacks",
    boxOfCardsV1TechStackSectionDescription_00: "What libraries did I use? Did I use libraries? Let's find out!",
    boxOfCardsV1TechStackSectionHeader_01: "Web App",
    boxOfCardsV1TechStackSectionDescription_01:
        "Most of the content is in the Client, thus I use some frontend libraries to make it look nice." +
        "\nMaterial Ui as a solid design base, React for reusable components and Redux to manage states globally." +
        "\nTypescript to avoid the javascript hell, webpack to make the build more compact and docker to deploy." +
        "\nImagekit.io is compatible with React and allows the outsourcing of images into the cloud, thus reducing load time." +
        "\nThe server is just one file to serve it all and  proxy some requests to the Google Cloud.",
    boxOfCardsV1TechStackSectionHeader_02: "Backend Services",
    boxOfCardsV1TechStackSectionDescription_02:
        "These services all share the same core components." +
        "\nThe green boxes are npm packages that github worfklows create from my other repositories." +
        "\nOther than that I use jest for unit testing." +
        "\nThe broker package lets those services talk to the RabbitMq broker." +
        "\nTypes allow for consistent sending and receiving of data." +
        "\nTestData and MockProvider are dev dependencies to avoid redundancy in unit tests." +
        "\nThen there is CheckAlive which just checks whether a player is still connected." +
        "\nAnd lastly my wrapper for Redis interaction GameRedis.",
    boxOfCardsV1TechStackSectionHeader_03: "Backend Packages",
    boxOfCardsV1TechStackSectionDescription_03:
        "This is the tech stack of my packages." +
        "\nThe Broker supports RabbitMq with stomp.js via websockets and AMQP via CloudAMQP." +
        "\nThe GameRedis uses my more generic RedisClient package, which uses packages for redis cluster interaction." +
        "\nAll those other packages are just the core.",
    boxOfCardsV1TechStackSectionHeader_04: "Google Cloud Functions",
    boxOfCardsV1TechStackSectionDescription_04:
        "The Cloud Functions run on node.js and use a firebase package to interact with the firestore." +
        "\nThe firestore stores decks and verification links as well as some basic account data.",
    boxOfCardsV1TechStackSectionHeader_05: "RabbitMq",
    boxOfCardsV1TechStackSectionDescription_05:
        "RabbitMq is configured using only kubernetes config files and has plugins so that server and client can talk with the broker.",
    boxOfCardsV1DeploymentSectionHeader_00: "Deployment",
    boxOfCardsV1DeploymentSectionDescription_00: "Well now we got all this kababl but how do we form a cloud out of it?" +
        "\nDevOps and Pipelines to the rescue.",
    boxOfCardsV1DeploymentSectionHeader_01: "Github Workflow",
    boxOfCardsV1DeploymentSectionDescription_01:
        "Just store a git workflow file in the repository and bam we can define jobs." +
        "\nJobs can be dependent on one another, check out commits and even install plugins themselves." +
        "\nThis awesome magic. I love them!" +
        "\nI use a job to get the package versions and check whether they have updated in the current commit." +
        "\nIf so, rebuild docker images." +
        "\nIf anything got rebuilt, delete stuff from my digital ocean cluster and deploy it anew." +
        "\nYes my workflow talks with digital ocean!" +
        "\nAnd all of this in just ~300 lines of config (without empty lines).",
    boxOfCardsV1DeploymentSectionHeader_02: "The Toolbox",
    boxOfCardsV1DeploymentSectionDescription_02:
        "A good friend gave me a nice template for a shell-script and it made testing things so much easier." +
        "\nI extended it over time and it allows me to switch between my local cluster and the digital ocean cluster." +
        "\nIf I do not want to use the github action to redeploy a pod I can just use this to redeploy all, or just a single service." +
        "\nI think Helm does something similar so that will be the next thing to check out." +
        "\nI also deployed a cluster using Terraform but found it to be overkill for this project." +
        "\nYes it seems I have a limit for overengineering",
    boxOfCardsV1TestsSectionHeader_01: "Unit Tests",
    boxOfCardsV1TestsSectionDescription_01:
        "Green numbers on a Unit Test provide one of the best feelings." +
        "\nThere are over 400 unit tests in this project and some dozen integration tests." +
        "\nI still have some logical branches to be covered and the web client has no unit tests whatsoever.",
    boxOfCardsV1TestsSectionHeader_02: "Unit Test Output",
    boxOfCardsV1TestsSectionDescription_02:
        "This is the output of my TimeoutHandler package." +
        "\nYes I am showing this minor package because my bigger packages are not that covered but psssht!",
    boxOfCardsV1DesignSectionHeader_00: "Origins",
    boxOfCardsV1DesignSectionDescription_00:
        "In the following sections I will post parts of the plans and designs I made on the way." +
        "\nI remember my professor on Software Design repeating: 'Planning is essential. Plans are useless.'",
    boxOfCardsV1DesignSectionHeader_01: "1. Game Board",
    boxOfCardsV1DesignSectionDescription_01:
        "I concept everything in draw.io as I found that tool to be the least annoying." +
        "\nThe bottom left shows my first idea for a game board." +
        "\nIt was not flexible enough for resolutions and game options.",
    boxOfCardsV1DesignSectionHeader_02: "2. Game Board",
    boxOfCardsV1DesignSectionDescription_02:
        "\nThis design is more flexible and rounding makes it seem easier",
    boxOfCardsDesignSectionHeader_03: "Page Transitions",
    boxOfCardsDesignSectionDescription_03:
        "\nWith everything in one document I can also concept page transitions.",
    boxOfCardsDesignSectionHeader_04: "Gameloop",
    boxOfCardsDesignSectionDescription_04:
        "It ain't pretty but it was sufficient to create the game-states." +
        "\nOn game start the game-states are linked based on the game options in the game lobby." +
        "\ne.g. for selecting a sentence there is a GS1GetRandomSentenceGameState and a GS1SelectingSentenceGameState." +
        "\nBoth share the base class GetSentenceGameStateBase to avoid redundancy.",
    boxOfCardsDesignSectionHeader_05: "UML client board",
    boxOfCardsDesignSectionDescription_05:
        "To get a rough overview of what components will be required I like to start out creating class diagrams." +
        "\nIt feels like solving a Sodoku except it really is exciting.",
    boxOfCardsDesignSectionHeader_06: "Sequencing",
    boxOfCardsDesignSectionDescription_06:
        "The web client and services communicate via the Broker using Queues to subscribe on and publish to." +
        "\nSeveral messages have to be exchanged using different queues to e.g. create a game lobby.",
    boxOfCardsV1DesignSectionHeader_07: "First Page",
    boxOfCardsV1DesignSectionDescription_07:
        "This was my first page running in localhost." +
        "\nHilarious what it once looked like.",
    boxOfCardsV1DesignSectionHeader_08: "Maybe use a scribble design?",
    boxOfCardsV1DesignSectionDescription_08:
        "I tried really hard to make a hand drawn look possible but giving good usage feedback was just too hard." +
        "\nThere seems to be a reason that web pages are always so clean.",
    boxOfCardsV1DesignSectionHeader_09: "Concepting Designs",
    boxOfCardsV1DesignSectionDescription_09:
        "In Affinity Designer I concepted several design ideas." +
        "\nEven though some looked really nice it was rough getting all components fitting one another.",
    boxOfCardsV1DesignSectionHeader_10: "Designing Logos",
    boxOfCardsV1DesignSectionDescription_10:
        "This was my second approach at a logo." +
        "\nI am too ashamed to show my first version and even these hands are... stolen from the wilds of the internet." +
        "\nI really like it but it was impossible to make a good looking icon out of it.",
    boxOfCardsV1DesignSectionHeader_11: "Designing the logo",
    boxOfCardsV1DesignSectionDescription_11:
        "I started watching logo concepting videos on side and found one using a box consisting of letters." +
        "\nI was able to adapt it using the letters B, O and C and add in some card." +
        "\nReally happy with the result. Things started coming together.",
    boxOfCardsV1DesignSectionHeader_12: "Designing the Game Board",
    boxOfCardsV1DesignSectionDescription_12:
        "I started focussing on making the ui responsive." +
        "\nA fixed height History at the top, a Hand at the bottom, Sentence and Info Left and a body to fill up the remaining space." +
        "\nI made the optional stuff like Chat, Player-List and Options hide-able." +
        "\nIt turned out that those component headers were a nightmare in responsive design so I moved them into the components to only be displayed when they are empty.",
    boxOfCardsV1DesignSectionHeader_13: "Testing Fonts",
    boxOfCardsV1DesignSectionDescription_13: "I had some friends rate fonts for this application." +
        "\nThey chose 4 and 11 and so I proceeded with 4 as I liked it most of them.",
    boxOfCardsV1ObstaclesSectionHeader_00: "How many obstacles could there be?",
    boxOfCardsV1ObstaclesSectionDescription_00:
        "Well I never counted but lets say curses existed!" +
        "\nSpecial mentions to: scrollbars, table implementations, checking negated enums, cors, caching, caching, " +
        "git being case insensitive, Google Agones, package dependency conflicts, react-router v5->v6, " +
        "\nweird behaving cluster regions and github telling me I reached 9500 of my 2000 build minutes with a 56$ balance on my 0$ limit." +
        "\nIt was their bug though.",
    boxOfCardsV1ObstaclesSectionHeader_01: "Umlauts!",
    boxOfCardsV1ObstaclesSectionDescription_01:
        "In the german language there are umlauts (ä,ö, etc.) and it turns out the font I chose did not have those so...." +
        "\nI added them myself! " +
        "\nI guess that is fine as I bought this font and otherwise: psssht.",
    boxOfCardsV1ObstaclesSectionHeader_02: "Font Borders",
    boxOfCardsV1ObstaclesSectionDescription_02:
        "The font also had some lines repeated for... reasons I guess." +
        "\nIt was fine until I added a border which turned out weird." +
        "\nSo I edited those out." +
        "\nI knew the font editor by now.",
    boxOfCardsV1ObstaclesSectionHeader_03: "Display Settings",
    boxOfCardsV1ObstaclesSectionDescription_03:
        "What is this you ask? Modern art? Yes probably." +
        "\nIt is also the color difference of both my monitors and I was incapable to get them any closer." +
        "\nI decided to resolve this issue by not caring at all and moving on.",
    boxOfCardsV1ObstaclesSectionHeader_04: "Debugging Unit Tests",
    boxOfCardsV1ObstaclesSectionDescription_04:
        "Well some error messages are at first confusing and then they get weird." +
        "\nI use Typescript so the types are set but when passing data along a number can still be a string even though the compiler thinks it is a number." +
        "\nNananananananana Javascriiiipt",
    boxOfCardsV1ObstaclesSectionHeader_05: "How long did this journey take?",
    boxOfCardsV1ObstaclesSectionDescription_05:
        "Well I don't know but in all repositories together there are 1000 + commits." +
        "\nI got some nice templates though and some stuff left to cleanup" +
        "\nWhat is left to be done?" +
        "\nQuality of Life, more unit tests, login with google, etc." +
        "\nAh and I somehow forgot to add a user account management... nobody needs that." +
        "\nI just love development <3",

    // Career Projects
    today: 'Today',

    boxOfCardsV3CareerHeader: "Release of Box of Cards Beta",
    boxOfCardsV3CareerSubHeader: "Web Game",
    boxOfCardsV3CareerDescription: "Migration of a collaborative web game to a more cost-effective architecture and cloud.\n" +
        "Necessary cost savings through horizontally scaling dedicated servers and efficient caching.",
    boxOfCardsV3CareerBulletPoint1: "Implementation of dedicated game servers in a droplet cluster.",
    boxOfCardsV3CareerBulletPoint2: "Horizontal scaling of droplets based on real-time metrics.",
    boxOfCardsV3CareerBulletPoint3: "Automated Docker image, snapshot & SSL certificate generation.",
    boxOfCardsV3CareerBulletPoint4: "Compliance with global data protection and consumer protection regulations.",
    boxOfCardsV3CareerBulletPoint5: "Management of Google Analytics & Google AdSense.",
    boxOfCardsV3CareerBulletPoint6: "Extensive test coverage through ~1400 end-to-end tests.",

    hrisHeader: "Managing employees and company assets",
    hrisSubHeader: "HRMS & IT Asset Management",
    hrisDescription: "A company portal for management of:\n" +
        "contacts, employments, finances, assurances, benefits, equipment, tracked hardware distribution and more.",
    hrisBulletPoint1: "Automated deployment using AWS CDK",
    hrisBulletPoint2: "Role based access for HR & employees",
    hrisBulletPoint3: "Automated documentation generation",
    hrisBulletPoint4: "Automated history for DSGVO conformity",
    hrisBulletPoint5: "Automated backups",
    hrisBulletPoint6: "Automated email notifications",

    kotlinRecommendationAppHeader: "AI Evaluation on Android",
    kotlinRecommendationAppSubHeader: "Android App PoC",
    kotlinRecommendationAppDescription: "You enter your idea and an AI evaluates your idea and gives feedback.\n" +
        "This project was a gap filler to gain knowledge on Kotlin.",

    boxOfCardsV2CareerHeader: 'Revision of a multiplayer Web App (v2)',
    boxOfCardsV2CareerSubHeader: 'Web Game',
    boxOfCardsV2CareerDescription:
        'The app is functional but with the current architecture there are issues with initial costs, scaling costs, maintenance effort and GCP documentation.\n' +
        'Therefore, a serverless migration from NodeJs in Kubernetes to AWS Lambda and from Redis to DynamoDB.\n' +
        'In addition, Google Authentication will be replaced by oAuth via third-party providers such as e.g. Discord.\n' +
        'Due to the websocket support, GraphQl will be used as Api in the future and RabbitMq will be dropped.\n' +
        'Various Ui designs have been prototyped and therefore the UI will be overhauled.',
    boxOfCardsV2CareerBulletPoint1: 'Migration to serverless in AWS',
    boxOfCardsV2CareerBulletPoint2: 'Communication via GraphQl',
    boxOfCardsV2CareerBulletPoint3: 'Deployment of architecture and code via AWS-Cdk',
    boxOfCardsV2CareerBulletPoint4: 'Deployment of the web app via CloudFront',
    boxOfCardsV2CareerBulletPoint5: 'Revision of the UI design',

    charityHeader: 'CRM for charitable organization',
    charitySubHeader: 'Charity B2C',
    charityDescription: 'Development of an application to manage and distribute donated goods to the needy',
    charityBulletPoint1: 'Appointment booking',
    charityBulletPoint2: 'Customer management',
    charityBulletPoint3: 'Goods management',
    charityBulletPoint4: 'Email notifications',
    charityBulletPoint5: 'Localization',
    charityBulletPoint6: 'Api connections',

    agricultureHeader: 'CRM + ERP for medium-sized traders',
    agricultureSubHeader: 'Agriculture & Preprocessing B2B',
    agricultureDescription: 'New development of a historical, monolithic system based on Microsoft Access.\n' +
        'The replacing system is modular, integrated & closed.',
    agricultureBulletPoint1: 'Determination & optimization of business processes',
    agricultureBulletPoint2: 'Backend with .NET, Entity Framework & PostgreSQL',
    agricultureBulletPoint3: 'TextControl enables automated generation of contracts & invoices',
    agricultureBulletPoint4: 'Test coverage with Moq & XUnit',
    agricultureBulletPoint5: 'Web application through React, MUI & Datagrid, Typescript & RTK-Query',
    agricultureBulletPoint6: 'Automated backend api & http client generation through RTK codegen',
    agricultureBulletPoint7: 'Pipeline deployment through Azure DevOps',

    eCommerceHeader: 'Automation E-mail & Marketing',
    eCommerceSubHeader: 'E-Commerce B2C & B2B',
    eCommerceDescription: 'Development at a leading German catalog & online store. \n' +
        'Monthly sending of emails & push messages in the 3-digit million range. \n' +
        'Management & further development of various services for connection, enrichment & control of customer events.\n' +
        'Due to decades of prior development & platform changes, many technologies were in use.',
    eCommerceBulletPoint1: 'Connection & enrichment of events for email dispatch',
    eCommerceBulletPoint2: 'Automation of account data management for GDPR',
    eCommerceBulletPoint3: 'Templating engine integration for personalized control',
    eCommerceBulletPoint4: 'Cloud optimization through parallelization & batching',
    eCommerceBulletPoint5: 'Further development of Angular web client for managing push shipping',
    eCommerceBulletPoint6: 'Replacement of legacy systems',
    eCommerceBulletPoint7: 'Expansion & test runs of Disaster Recovery & Alarming',
    eCommerceBulletPoint8: 'Automated testing across multiple teams',

    bookingHeader: 'Webapp for office space management',
    bookingSubHeader: 'SaaS B2C',
    bookingDescription: 'Booking and management of seats, rooms & equipment for employees',
    bookingBulletPoint1: 'Cloud architecture (Infrastructure as Code)',
    bookingBulletPoint2: 'CI/CD (Automatic Deployment)',
    bookingBulletPoint3: 'Backend development',
    bookingBulletPoint4: 'UI conception',
    bookingBulletPoint5: 'Frontend development',

    awsSolutionArchitectHeader: 'AWS Certified Solutions Architect',
    awsSolutionArchitectSubHeader: 'Certificate',
    awsSolutionArchitectDescription: 'I still had time before the next project so I went straight to it.\n' +
        "I recommend a bachelor's degree for basic knowledge, previous experience with AWS, a month's time and lots of coffee.",


    awsCloudPractitionerHeader: 'AWS Certified Cloud Practitioner',
    awsCloudPractitionerSubHeader: 'Certificate',
    awsCloudPractitionerDescription: 'A good start to gain experience with certifications.\n' +
        'Can be done in 1-3 days, depending on your level of knowledge',

    boxOfCardsV1CareerHeader: 'Multiplayer Web App (v1)',
    boxOfCardsV1CareerSubHeader: 'Web Game',
    boxOfCardsV1CareerDescription: 'Implementation of a card-based board game in the browser.\n' +
        'Users can create their own decks, combine them and play with each other in different modes.\n' +
        'Communication takes place via http / websockets via RabbitMq with NodeJs containers in Kubernetes.\n ' +
        'These manage matchmaking, game creation and active play.\n' +
        'Player data is stored in Redis, whereas account data & decks are persisted in Google Firestore.\n' +
        'All applications run as Docker images and can be selectively redeployed with one click using GitHub actions.',
    boxOfCardsV1CareerBulletPoint1: 'Conception of the game design',
    boxOfCardsV1CareerBulletPoint2: 'Conception of UI',
    boxOfCardsV1VCareerBulletPoint3: 'Conception of the architecture',
    boxOfCardsV1CareerBulletPoint4: 'Implementation (frontend, backend, databases, authentication)',
    boxOfCardsV1CareerBulletPoint5: '(Automatic) Deployment',

    fundingHeader: 'Funding & Prototypes',
    fundingSubHeader: 'Pc Games',
    fundingDescription: 'My biggest hobby is game development and this picked up again towards the end of my depression.\n' +
        "I developed several prototypes but didn't get any funding.\n" +
        'After Box of Cards, I will continue the color-based 2D-platformer, as it already has tests, a level editor, a pitch deck, 60 pages of GDD, etc.\n' +
        "This one is not listed in my projects yet but I'm so looking forward to it!",

    diagnosisAdhdHeader: 'Diagnosis ADHD',
    diagnosisAdhdSubHeader: 'Health',
    diagnosisAdhdDescription: 'Asperger autism could not fully explain my peculiarities but together with ADHD the picture became coherent.\n' +
        'Above all, the combination of both ensured that it was not recognized for 30 years.\n' +
        'Symptoms from one field masked symptoms from the other field.\n' +
        "I would like to point out that I am very straightforward with all this and people almost never notice anything if I don't mention it.",

    diagnosisAspergersHeader: 'Diagnosis Asperger autism',
    diagnosisAspergersSubHeader: 'Health',
    diagnosisAspergersDescription: 'During my behavioral therapy, I also pursued the topic of autism, as it had always been on my mind (literally).\n' +
        'I got my diagnosis very promptly and it explains a lot and it turned out that most of my contacts are also in the neurodiverse spectrum.\n' +
        "Some even thought I already had my autism diagnosis and just didn't want to talk about it." +
        "I also like to talk about it and can only recommend therapies to everyone.",

    depressionHeader: 'Burnout & Depression',
    depressionSubHeader: 'Health',
    depressionDescription: 'There is so much to tell and so little space so feel free to talk to me directly.\n' +
        "In short, I've been living too many years above my limit.\n" +
        'My body was physically telling me that after too much work, poor working conditions and family burdens, it was time to take a break.\n' +
        'It was one of the best times. I learned a lot about myself and others and have been helping others wherever I can ever since.\n' +
        'This is such an important topic and it should not be hidden to give it acceptance in society.',

    memoreHeader: 'Redesign of a platform for game modules',
    memoreSubHeader: 'Serious Games B2B',
    memoreDescription: 'The client has a platform for therapeutic, motion-controlled computer games for seniors.\n' +
        'These games are delivered on a dedicated console.\n' +
        'The code base has been renewed to allow for more compact and cheaper hardware.\n' +
        'Additionally, modular updates have been enabled through deployment pipelines',
    memoreBulletPoint1: 'Conception of the architecture',
    memoreBulletPoint2: 'Test-Driven Implementation',
    memoreBulletPoint3: 'New development of the gamestate system',
    memoreBulletPoint4: 'Implementation of individual gestures according to therapeutic specifications',
    memoreBulletPoint5: 'Documentation',
    memoreBulletPoint6: 'Performance optimization ~300%',
    memoreBulletPoint7: 'More accurate motion tracking',
    memoreBulletPoint8: 'DevOps',

    bachelorFinishHeader: 'Applied Informatics - HAW Hamburg',
    bachelorFinishSubHeader: 'Bachelor Complete',
    bachelorFinishDescription: 'The whole studying was really great.',

    bachelorThesisHeader: 'Navigation in non-Euclidean VR',
    bachelorThesisSubHeader: 'VR-Research',
    bachelorThesisDescription: 'VR environments enable novel navigation possibilities, since simulated worlds do not have to follow the laws we are used to.\n' +
        'It was investigated whether non-Euclidean (curved) spaces enable more time-efficient locomotion.\n' +
        'Two 3D environments were built for the implementation, with one environment having portals and shortened paths.\n' +
        'The portals were not noticeable to the user even when walking through them and were located in the doors between the rooms.\n' +
        'The study showed that non-Euclidean spaces enable an average of 40% more efficient movement',
    bachelorThesisBulletPoint1: 'Basic research',
    bachelorThesisBulletPoint2: 'Conception & implementation of the VR application',
    bachelorThesisBulletPoint3: 'Conception & implementation of the experiment with 20 test persons',
    bachelorThesisBulletPoint4: 'Statistical evaluation',

    memoreCareHeader: 'Web app for managing a medical console application',
    memoreCareSubHeader: 'Serious Games B2B',
    memoreCareDescription: 'The client has a platform for therapeutic, movement-controlled computer games for seniors.\n' +
        'Fitness is individual and a Wep app is needed to configure the games, data collection & data visualization.\n' +
        'Players, caregivers, admins have different accesses and data is stored anonymously',
    memoreCareBulletPoint1: 'Survey of the use cases',
    memoreCareBulletPoint2: 'Project management',
    memoreCareBulletPoint3: 'Conception of the web application, backend services & databases',
    memoreCareBulletPoint4: 'Implementation',
    memoreCareBulletPoint5: 'Documentation',

    magentoHeader: 'Web store modules',
    magentoSubHeader: 'E-Commerce B2B',
    magentoDescription: 'Web store modules for customers were developed for a Hamburg-based e-commerce company.\n' +
        'New e-shops were designed and existing ones expanded.\n' +
        'In addition, various modules were created such as interactive maps, visualized product configuration & automated document creation',
    magentoBulletPoint1: 'Conception',
    magentoBulletPoint2: 'Implementation',
    magentoBulletPoint3: 'Integration',

    synonymServiceHeader: 'Synonym service for search optimization',
    synonymServiceSubHeader: 'E-Commerce B2B',
    synonymServiceDescription: 'In languages there is a multitude of words with similar meanings.\n' +
        'To ensure that users always have the best search experience, synonyms should also be included in the search.\n' +
        'A synonym database was created for this purpose and equipped with a web app to manage the search trees entered.',
    synonymServiceBulletPoint1: 'Conception',
    synonymServiceBulletPoint2: 'Interactive visualization & maintenance of the search trees',

    bachelorStartHeader: 'Applied Informatics - HAW Hamburg',
    bachelorStartSubHeader: 'Bachelor Start',
    bachelorStartDescription: 'While studying 3D & Animation I already drifted towards programming.\n' +
        'I learned a lot on my own and with support of my colleagues and decided to switch completely.',

    racingHeader: '2D Racing',
    racingSubHeader: 'Mobile Game',
    racingDescription: 'Level based 1-Click Racing Game',
    racingBulletPoint1: 'Game Design',
    racingBulletPoint2: 'Level Design',
    racingBulletPoint3: 'Scripting',

    puzzleHeader: '2D Puzzle',
    puzzleSubHeader: 'Mobile Game',
    puzzleDescription: 'Uncover symbols with placeable lines and guess their names with given letters.',
    puzzleBulletPoint1: 'Realize 700+ levels',
    puzzleBulletPoint2: 'App/Playstore Optimization',
    puzzleBulletPoint3: 'Scripting',

    jumpnRunHeader: "2D Jump'n run",
    jumpnRunSubHeader: 'Mobile Game',
    jumpnRunDescription: 'A rogue-light in trap-strewn tower.\n' +
        'The player climbs this by jumping through the bottom of the screen and appearing at the top. Collectable coins & unlockable power ups',
    jumpnRunBulletPoint1: 'Realize 150+ levels in 10 ages with 30+ trap types',
    jumpnRunBulletPoint2: '~ 100 Achievements',
    jumpnRunBulletPoint3: 'Scripting',
    jumpnRunBulletPoint4: 'App/Playstore Optimization',

    saeFinishHeader: 'Diploma Complete',
    saeFinishSubHeader: '3D & Animation - SAE Hamburg',
    saeFinishDescription: 'I would have liked to put more time into the studying as I had to work three days a week in retail to finance myself.\n' +
        'I made great connections which are very active to this day.',

    brawlerHeader: '3D Coop Couch Brawler',
    brawlerSubHeader: 'Pc Game',
    brawlerDescription: 'Representing my past university with a 3D game for the Gamescom.\n' +
        'Superheroes with unique abilities together protect a city from hordes of enemies.\n' +
        'The city is completely destructable and shall not be harmed in the defense.',
    brawlerBulletPoint1: '3D-Modeling',
    brawlerBulletPoint2: 'Texturing',
    brawlerBulletPoint3: 'Animation',

    saeStartHeader: 'Diploma Start',
    saeStartSubHeader: ' 3D & Animation - SAE Hamburg',
    saeStartDescription: "I've always been a gamer.\n" +
        "I was already onto web-programming, creation of Warcraft 3 mods & 3D Modeling so this step felt natural.",

    abiturHeader: 'Abitur',

    start: 'Start',

    // Skills
    websockets: 'Websockets',
    redux: 'Redux',
    jest: 'Jest',
    redis: 'Redis',
    kubernetes: 'Kubernetes',
    gcp: 'GCP',
    firebase: 'Firebase',
    affinityDesigner: 'Affinity Designer',
    affinityPhoto: 'Affinity Photo',
    nuget: 'Nuget',
    git: 'Git',
    sensorTower: 'SenorTower',
    appAnnie: 'AppAnnie',
    aso: 'ASO',
    unity3D: 'Unity3D',
    vite: 'Vite',
    java: 'Java',
    typescript: 'Typescript',
    nodeJs: 'NodeJs',
    digitalOcean: 'Digital Ocean',
    nextJs: 'NextJs',
    prisma: 'Prisma',
    react: 'React',
    rtk: 'RTK',
    postgreSQL: 'PostgreSQL',
    azure: 'Azure',
    dotNet: '.NET',
    entityFramework: 'Entity Framework',
    swagger: 'Swagger',
    xUnit: 'XUnit',
    moq: 'Moq',
    mui: 'MaterialUi',
    muiDatagrid: 'Mui DataGrid',
    yup: 'Yup',
    rtkQuery: 'RTK Query',
    scrum: 'Scrum',
    businessProcessReengineering: 'Business Process Engineering',
    textControl: 'TextControl (Automated Pdf Generation & Signature)',
    figma: 'Figma',
    miro: 'Miro',
    aws: 'AWS',
    awsCdk: 'CDK',
    awsEc2: 'EC2',
    awsFargate: 'Fargate',
    awsEcr: 'ECR',
    awsS3: 'S3',
    awsDynamoDb: 'DynamoDb',
    awsLambda: 'Lambda',
    awsSns: 'SNS',
    awsSqs: 'SQS',
    awsCloudwatch: 'Cloudwatch',
    awsCloudFront: 'Cloudfront',
    awsCloudformation: 'Cloudformation',
    awsCognito: 'Cognito',
    awsEcs: 'ECS',
    awsAurora: 'Aurora',
    awsRoute53: 'Route53',
    apiGateway: 'ApiGateway',
    appsync: 'Appsync',
    graphql: "GraphQl",
    apollo: "Apollo",
    terraform: 'Terraform',
    keycloak: 'Keycloak',
    githubCiCd: 'Github CI/CD',
    gitlabCiCd: 'Gitlab CI/CD',
    docker: 'Docker',
    rabbitMq: 'RabbitMq',
    kafka: 'Kafka',
    hibernate: 'Hibernate',
    springIntegration: 'Spring Integration',
    jUnit: 'JUnit',
    maven: 'Maven',
    angularMaterial: 'Angular Material',
    yarn: 'Yarn',
    liquidJs: 'LiquidJs',
    emarsys: 'Emarsys',
    confluence: 'Confluence',
    springBoot: 'Spring Boot',
    azureAd: 'Azure AD',
    ruby: 'Ruby',
    prolog: 'Prolog (AAAAAHHHHHHHH)',
    c: 'C',
    assembler: 'Assembler',
    cSharp: 'C#',
    databases: 'Databases',
    broker: 'Broker',
    automation: 'Automation',
    algorithms: 'Algorithms',
    softwareDevelopment: 'Software Development',
    softwareArchitecture: 'Software Architecture',
    distributedSystems: 'Distributed Systems',
    itSecurity: 'IT Security',
    vr: 'VR',
    machineLearning: 'Machine Learning',
    nUnit: 'NUnit',
    Nuget: 'Nuget',
    jira: 'Jira',
    motionTracking: 'Motion Tracking',
    jenkins: 'Jenkins',
    excel: 'Excel',
    lateX: 'LateX',
    aspNetCore: 'AspNet Core',
    mySQL: 'MySQL',
    linux: 'Linux',
    apache: 'Apache',
    php: 'PHP',
    magento: 'Magento (AAAAAHHHHHHHH)',
    jQuery: 'JQuery',
    symfony: 'Symfony',
    javascript: 'Javascript',
    android: 'Android',
    iOs: 'iOS',
    adobePhotoshop: 'Adobe Photoshop',
    autodeskMaya: 'Autodesk Maya',
    zBrush: 'ZBrush',
    mudbox: 'Mudbox',
    adobeIllustrator: 'Adobe Illustrator',
    rigging: 'Rigging',
    threeDAnimation: '3D Animation',
    substancePainter: 'Substance Painter',
    nDo: 'NDO',
    dDo: 'DDO',
    kotlin: 'Kotlin',
    material: 'Material',
    chatGpt: 'ChatGPT',
    sharepoint: "Sharepoint",
    microsoftGraphApi: "Microsoft Graph Api",

    // Quotes
    quotes: [
        /*1*/    "Give a human a fish and he eats for a day.\nGive a human a barrel of fish and he eats for a week.",
        /*2*/    "If you look into the abyss then the abyss also looks out of you into you.",
        /*3*/    "But do you know why I love Cini Minis so much?",
        /*4*/    "Super powers exist!\nThey are just not that good. Like freckles or allergies.",
        /*5*/    "The debugger is documentation enough",
        /*6*/    "I like very enthusiastic walks.",
        /*7*/    "I love software architecture.",
        /*8*/    "There is no crypto mining going on in the background.",
        /*9*/    "Did you you leave your stove on?",
        /*10*/    "Why is there no spread with bread topping?",
        /*11*/    "Butter, butter, butter, butter.",
        /*12*/    "Are enemies the friends we did not find along the way?",
        /*13*/    "Does existence make more sense than nonexistence?",
        /*14*/    "What happened to those tomatoes?",
        /*15*/    "People tend to be neither Kjeld nor snowmen",
    ],
    quoterPrefix: [
        "",
        "~ ",
        "by ",
    ],
    quoter: [
        "Tim Fehrmann",
        "T. Fehrmann",
        "T.F.",
        "Tim F.",
        "Tim"
    ],
};

const DE: IBaseStrings = {
    //App Names
    AppName: "Start",

    // Languages
    Language: "Sprache",
    english: "Englisch",
    german: "Deutsch",

    // Pages
    Contact: "Kontakt",
    LegalNotice: "Impressum",

    // Utility
    DarkMode: "Dunkel",
    BrightMode: "Hell",
    SUBMIT: "SENDEN",
    Download: 'Herunterladen',
    GoogleDrive: 'Google Drive',
    To: 'Zu',

    // Legal Notice
    firstName: "Tim",
    secondName: "Fehrmann",
    myCity: "Hamburg",
    addressLine1: "Postal Address",
    addressLine2: "Kjeld Schmidt",
    addressLine3: "Rochusstraße 54",
    addressLine4: "50827 Cologne",
    companyName: "Germany",

    // Contact
    contactMeInfo: "Schreib mir und ich antworte",
    Name: "Name",
    EnterName: "Name eingeben",
    Email: "Email",
    EnterEmail: "Email eingeben",
    Message: "Nachricht",
    Subject: "Thema",
    EnterSubject: "Thema eingeben",
    TypeYourMessageHere: "Schreibe deine Nachricht hier",
    sendingEmailSuccessful: "Email erfolgreich versendet",

    // Team
    teamMember01Name: "Tim Fehrmann",

    // Home
    personal: "Persönliches",
    career: "Karriere",

    // Projects
    personalProjectsDescription: "Dies sind einige Projekte aus meiner Freizeit.",
    careerProjectsDescription: "Dies sind einige Projekte aus meinen Anstellungen.",
    Gameplay: "Spielablauf",
    Trailer: "Trailer",

    // Dino
    dinoKingName: "Dino King",
    dinoKingSubHeader: "Prototyp eines mobile Spiels",
    dinoKingImageDescription: "Aktives Spiel",
    dinoKingDinosImageDescription: "Dinos!",
    dinoKingThumbnailDescription: "Wirf Schinken um dich gegen die hungrigen Dinos zu wehren!",
    dinoKingSectionDescription_01: "In Dino King wehrt sich ein Neandertaler gegen Dinosaurier." +
        "\nDinos werden durch das werfen von Fleischkeulen abgewehrt." +
        "\nDer Spieler malt mit seinem Finger die Flugbahn des Schinkens und versucht so lange wie möglich nicht gefressen zu werden.",
    dinoKingSectionHeader_02: "Gegner",
    dinoKingSectionDescription_02: "Die unaufhörlichen Horden von Dinosauriern. Sind sie nicht süß? Sie sind so süß. Gib es zu!",

    // Skyblock
    skyBlockName: "Sky Block",
    skyBlockSubHeader: "Test des Pigart Stils",
    skyBlockImageDescription: "3D Rendering",
    skyBlockDescription: "Eine lowpoly Landschaft im pigart Stil",
    skyBlockSectionHeader_01: "Beschreibung",
    skyBlockSectionDescription_01: "Eine schön gerenderte 3D-Landschaft im Pigart-Stil.",

    // Corridor
    corridorName: "3D Korridor",
    corridorSubHeader: "Übungen der 3D-Modellierung mit Referenz",
    corridorImageDescription: "3D Rendering",
    corridorReferenceImageDescription: "3D Referenz",
    corridorDescription: "Ein High-Poly 3D-Modell eines Korridors",
    corridorSectionHeader_01: "Beschreibung",
    corridorSectionDescription_01: "Dieses Rendering zeigt ein high-poly 3D-Modell eines Sci Fi Korridors.",
    corridorSectionHeader_02: "Referenz",
    corridorSectionDescription_02: "Der oben abgebildete 3D-Korridor basiert auf diesem Konzept von Abraham Wong Shih Yaw.",

    // Door
    doorName: "3D Sci-Fi Door",
    doorSubHeader: "Übungen zu Normal und Texture Maps",
    doorImageDescription: "3D Rendering",
    doorDescription: "Ein low-poly 3D-Modell einer SciFi Tür",
    doorSectionHeader_01: "Beschreibung",
    doorSectionDescription_01: "Dieses Rendering zeigt ein low-poly 3D-Modell einer Sci-Fi Tür." +
        "\nEs besteht aus einem Rahmen mit vier beweglichen Teilen und insgesamt 300 Tris." +
        "\nDie folgenden Texture-Maps werden verwendet: Diffuse, Specular, Normal",

    // Shield
    shieldName: "3D Schild",
    shieldSubHeader: "Übungen zu Normal Maps",
    shieldFrontImageDescription: "3D Rendering Vorne mit Topologie",
    shieldBackImageDescription: "3D Rendering Hinten mit Topologie",
    shieldSideImageDescription: "3D Rendering Seite mit Topologie",
    shieldReferenceImageDescription: "3D Referenz",
    shieldDescription: "Ein Low-Poly 3D-Modell eines Schildes",
    shieldSectionHeader_01: "Beschreibung",
    shieldSectionDescription_01: "Dieses Rendering zeigt ein low-poly 3D-Modell eines Schildes mit einem Totenschädel." +
        "\nDas Bild besitzt ein partielles Overlay der 3D-Mesh Topologie.",
    shieldSectionHeader_02: "Rückseite",
    shieldSectionDescription_02: "Die Referenz besitzt keine Rückseite; daher habe ich mir eine ausgedacht.",
    shieldSectionHeader_03: "Seite",
    shieldSectionDescription_03: "Dieses Bild zeigt die Schokoladenseite.",
    shieldSectionHeader_04: "Referenz",
    shieldSectionDescription_04: "Das oben abgebildete 3D-Schild basiert auf diesem Konzept von Artyom Vlaskin.",

    // Spider
    spiderName: "3D Mechanische Spinne",
    spiderSubHeader: "Iterative Modellierung eigener Ideen",
    spiderFrontImageDescription: "3D Rendering Vorne",
    spiderBackImageDescription: "3D Rendering Hinten",
    spiderFrontWireframeImageDescription: "3D Rendering Vorne mit Topologie",
    spiderBackWireFrameImageDescription: "3D Rendering Hinten mit Topologie",
    spiderDescription: "Ein Low-Poly 3D-Modell einer mechanischen Spinne",
    spiderSectionHeader_01: "Vorderseite",
    spiderSectionDescription_01: "Dieses Rendering zeigt ein low-poly 3D-Modell einer mechanischen spinne." +
        "\nDiesem Modell liegt keine Referenz zugrunde und entsprang meiner Fantasie." +
        "\nDie Spinne besitzt einen Motorblock Die Beine sind hydraulisch beweglich und animierbar.",
    spiderSectionHeader_02: "Rückseite",
    spiderSectionDescription_02: "In der Rückseitenansicht wird das Zahnradgetriebe sichtbar." +
        "\nzudem wird ersichtlich, dass der Motorblock an Ketten hängt.",
    spiderSectionHeader_03: "Vorderseite Topologie",
    spiderSectionDescription_03: "Die Front besitzt ein Overlay der 3D-Mesh Topologie.",
    spiderSectionHeader_04: "Rückseite Topologie",
    spiderSectionDescription_04: "Die Rückseite besitzt ein Overlay der 3D-Mesh Topologie.",

    // Staff
    staffName: "3D Stab",
    staffSubHeader: "Übung zur 3D Modellierung mit Referenz",
    staffImageDescription: "3D Rendering",
    staffReferenceImageDescription: "Referenz",
    staffDescription: "Ein Low-Poly 3D-Modell eines Stabs",
    staffSectionHeader_01: "Beschreibung",
    staffSectionDescription_01: "Dieses Rendering zeigt ein low-poly 3D-Modell eines Stabs." +
        "\nDas Bild besitzt ein partielles Overlay der 3D-Mesh Topologie." +
        "\nDie folgenden Texture-Maps werden verwendet: Diffuse, Normal",
    staffSectionHeader_02: "Referenz",
    staffSectionDescription_02: "Der oben abgebildete 3D-Stab basiert auf diesem Konzept von Roman Guro.",

    // Planets
    planetsName: "Planeten",
    planetsSubHeader: "Weitere 3D-Stile ausprobieren",
    planetsPlanetImageDescription: "3D Rendering Planet",
    planetsPlanetsImageDescription: "3D Rendering Planeten",
    planetsDescription: "Ein paar low-poly 3D Planeten",
    planetsSectionHeader_01: "Ein Planet",
    planetsSectionDescription_01: "Einfach nur ein Rendering eines low-poly 3D Planeten.",
    planetsSectionHeader_02: "Mehr Planeten",
    planetsSectionDescription_02: "Mehr Planeten halt",

    // SymbolQuest
    symbolQuestName: "Symbol Quest: Riddle Challenge",
    symbolQuestSubHeader: "Mobile Puzzle game",
    symbolQuestImageDescription: "Symbol Quest Werbung",
    symbolQuestVideoImageDescription: "Symbol Quest Trailer",
    symbolQuestDescription: "Symbol Quest ist ein 2D Puzzle Game von 2015",
    symbolQuestSectionHeader_01: "Beschreibung",
    symbolQuestSectionDescription_01: "Symbol Quest: Riddle Challenge wurde 2015 von Red Orb Games auf Android und iOs veröffentlicht.",
    symbolQuestSectionHeader_02: "Spielablauf",
    symbolQuestSectionDescription_02: "Um Bilder aufzudecken zieht der Spieler Linien über den Bildschirm." +
        "\nDort wo Linien sich mit dem versteckten Motiv überlagern wird dieses aufgedeckt." +
        "\nDer Spieler soll mit einer begrenzten Linienanzahl das Motiv erraten.",

    // TerribleTower
    terribleTowerName: "Terrible Tower",
    terribleTowerSubHeader: "Ein mobile Jump'n run game ohne Böden",
    terribleTowerTitleScreenImageDescription: "Ladebildschirm",
    terribleTowerVideoImageDescription: "Terrible Tower Trailer",
    terribleTowerStoneAgeImageDescription: "Steinzeit",
    terribleTowerRuneAgeImageDescription: "Runenzeitalter",
    terribleTowerRomeAgeImageDescription: "Römisches Zeitalter",
    terribleTowerMedievalAgeImageDescription: "Mittelalter",
    terribleTowerIndustrialAgeImageDescription: "Industrielles Zeitalter",
    terribleTowerArtAgeImageDescription: "Art-deko Zeitalter",
    terribleTowerAtomAgeImageDescription: "Atomares Zeitalter",
    terribleTowerMatrixAgeImageDescription: "Matrix Zeitalter",
    terribleTowerSciFiAgeImageDescription: "Scifi Zeitalter",
    terribleTowerEndAgeImageDescription: "Endzeit",
    terribleTowerMenuImageDescription: "Menü",
    terribleTowerDescription: "Terrible Tower ist ein 2D Roguelite Puzzle Platformer von 2014",
    terribleTowerSectionHeaderTrailer: "Trailer",
    terribleTowerSectionDescriptionTrailer: "The Release-Trailer.",
    terribleTowerSectionHeader_00: "Beschreibung",
    terribleTowerSectionDescription_00: "Terrible Tower wurde 2015 von Red Orb Games auf Android und iOs veröffentlicht.",
    terribleTowerSectionHeader_01: "Spielablauf",
    terribleTowerSectionDescription_01: "Der Spieler muss einen magischen Turm erklimmen." +
        "\nHierzu muss er durch den unteren Bildschirmrand springen um am oberen Bildschirmrand wieder aufzutauchen. Magie!" +
        "\nDer Turm besteht aus 10 Zeitaltern mit unterschiedlichen Gefahren und beginnt in der Steinzeit",
    terribleTowerSectionHeader_02: "Runenzeitalter",
    terribleTowerSectionDescription_02: "Das Runenzeitalter leuchtet magisch und enthält gefährliche Feuer sowie magische Geschosse.",
    terribleTowerSectionHeader_03: "Zeitalter Roms",
    terribleTowerSectionDescription_03: "Im römischen Zeitalter erschweren Ballisten, Morgensterne und Fallsteine den Weg.",
    terribleTowerSectionHeader_04: "Mittelalter",
    terribleTowerSectionDescription_04: "Im Mittelalter schwingen unzählige Äxte. Ducken!",
    terribleTowerSectionHeader_05: "Industriezeitalter",
    terribleTowerSectionDescription_05: "Das Industriezeitalter enthält Kreissägen und hydraulische Pressen.",
    terribleTowerSectionHeader_06: "Art-deco Zeitalter",
    terribleTowerSectionDescription_06: "Nun fliegen die Kreissägen sogar schon und rotierende Flammenwerfer sowie automatische Geschütze sind überall.",
    terribleTowerSectionHeader_07: "Atomzeitalter",
    terribleTowerSectionDescription_07: "Das Atomzeitalter ist die Zeit von freien Radikalen, giftigen Fässern und Atomraketen.",
    terribleTowerSectionHeader_08: "Matrix",
    terribleTowerSectionDescription_08: "In der Matrix versperren Laser regelmäßig den Weg und Bomben den Weg. Und alles bewegt sich ständig!",
    terribleTowerSectionHeader_09: "Scifi Zeitalter",
    terribleTowerSectionDescription_09: "Rotierende Laser-Geschütztürme überall und alles bewegt sich ständig!",
    terribleTowerSectionHeader_10: "Endzeit",
    terribleTowerSectionDescription_10: "In der Endzeit sind Fallen aus allen vorherigen Zeitaltern vorhanden. Komplett willkürlich!",
    terribleTowerSectionHeader_11: "Hauptmenü",
    terribleTowerSectionDescription_11: "Das Hauptmenü ermöglicht das Kaufen von Upgrades, Skins und die Einsicht von Erfolgen sowie Highscores.",

    // Bachelor
    bachelorThesis: "Bachelorarbeit",
    bachelorName: "Navigation in non-euclidean VR environments",
    bachelorSubHeader: "Der Abschluss meines Studiums der angwandten Informatik",
    bachelorStartImageDescription: "Startposition für VR-Spieler",
    bachelorVideoImageDescription: "Video der nicht-euklidischen Navigation",
    bachelorHyperbolicRoomsImageDescription: "Beispiel hyperbolischer Räume",
    bachelorImpossibleRooms3TurnsImageDescription: "Beispiel elliptischer Räume",
    bachelorImpossibleRoomsAdvantagesImageDescription: "Beispiel zur Wegersparnis",
    bachelorPortalImageDescription: "Überlagerende Räume aus Spielerperspektive",
    bachelorEuclideanImageDescription: "Euklidische VR-Umgebung",
    bachelorNonEuclideanImageDescription: "Nicht-euklidische VR-Umgebung",
    bachelorComponentViewImageDescription: "Komponenten-Diagram",
    bachelorDescription: "Dies ist die Abschlussarbeit für mein Studium der angewandten Informatik",
    bachelorSectionHeader_01: "Beschreibung",
    bachelorSectionDescription_01: "Dies ist die Abschlussarbeit für mein Studium der angewandten Informatik." +
        "\nEs wurde untersucht ob sich nicht-euklidische VR-Umgebungen eignen um Navigationszeiten in unbekannten Umgebungen zu verkürzen.",
    bachelorSectionHeader_02: "Experiment",
    bachelorSectionDescription_02: "20 Probanden hatten die Aufgabe 20 Landmarken in einer VR-Umgebung zu finden." +
        "\nEs gab eine euklidische sowie eine nicht-euklidische VR-Umgebung und beide waren gleich aufgebaut." +
        "\nDie nicht-euklidische Umgebungb besaß kürzere Laufwege durch Krümmungen des Raumes." +
        "\nProbanden in der nicht-euklidischen VR-Umgebung hatten keine Probleme mit räumlichen Überlagerungen und waren im Schnitt 40% schneller.",
    bachelorSectionHeader_03: "Hyperbolische Raumkrümmung",
    bachelorSectionDescription_03: "In Abbildung a) sind 5 miteinander verbundene Räume abgebildet. Die Türen sind mit Zahlen markiert." +
        "\nEin solcher Raum ist im 3-dimensionalem Raum nicht möglich, da sich Räume überlagern würden." +
        "\nEr wird nur durch eine hyperbolische Raumkrümmung wie in b) ermöglicht.",
    bachelorSectionHeader_04: "Elliptische Raumkrümmung",
    bachelorSectionDescription_04: "Die Räume in a) sind nur durch eine elliptische Raumkrümmung miteinander zu verbinden wie sie in b) gezeigt wird." +
        "\nHierdurch wird die Strecke zwischen den Räumen verkürzt.",
    bachelorSectionHeader_05: "Streckenersparnis",
    bachelorSectionDescription_05: "Diese Abbildung zeigt wie eine Wegstrecke zwischen zwei Räumen verkürzt werden kann wenn diese sich überlagern dürfen.",
    bachelorSectionHeader_06: "Streckenersparnis aus Egoperspektive",
    bachelorSectionDescription_06: "In der Abbildung blickt ein Proband auf zwei Türen." +
        "\nDie linke führt in einen Flur und die rechte in eine Garage. Es ist aus diesem Ausschnitt schon ersichtlich, dass ein solches Raumlayout unmöglich sein sollte." +
        "\nIn diesem Fall wird es durch Portale ermöglicht.",
    bachelorSectionHeader_07: "Euklidische VR-Umgebung",
    bachelorSectionDescription_07: "In dieser Abbildung wird die euklidische VR-Umgebung aus der Vogelperspektive gezeigt.",
    bachelorSectionHeader_08: "Nicht-euklidische VR-Umgebung",
    bachelorSectionDescription_08: "In dieser Abbildung wird die nicht-euklidische VR-Umgebung aus der Vogelperspektive gezeigt." +
        "\nDie Räume sind voneinander separiert damit sie sich nicht überlagern und bleiben durch Portale 'P' miteinander verbunden." +
        "\nDie farbigen Linien geben die Wege zwischen den Räumen an.",
    bachelorSectionHeader_09: "Komponentendiagramm",
    bachelorSectionDescription_09: "In dieser Abbildung sind die Komponenten abgebildet, die das Experiment ermöglichen." +
        "\nBevor ich das Diagramm hier erläutere verweise ich direkt auf meine Bachelorarbeit.",

    // PenAndPaperVr
    penAndPaperVrName: "Pen and Paper VR",
    penAndPaperVrSubHeader: "Ein VR-Prototyp aus meinem Informatik Studium",
    penAndPaperVrCharSheetImageDescription: "Charakter Vorschau",
    penAndPaperVrCharSheetEditedImageDescription: "Character Editierung",
    penAndPaperVrEnvironmentAddedImageDescription: "Erstellung der Landschaft",
    penAndPaperVrCubeImageDescription: "Würfel-Tracking",
    penAndPaperVrDescription: "Ein Hochschulprojekt über die Anwendbarkeit von Pen and Paper in VR",
    penAndPaperVrSectionHeader_01: "Beschreibung",
    penAndPaperVrSectionDescription_01: "Spieler können Einheiten erschaffen und auf einem Spielfeldraster platzieren." +
        "\nDas Spielfeld kann durch Pfeile auf dem Tisch bewegt werden kann.",
    penAndPaperVrSectionHeader_02: "Charakterbögen",
    penAndPaperVrSectionDescription_02: "Die Einheiten besitzen editierbare Charakterbögen." +
        "\nZur Bearbeitung wird eine virtuelle Tastatur verwendet." +
        "\nDie Charakterbögen können gespeichert und geladen werden.",
    penAndPaperVrSectionHeader_03: "Level",
    penAndPaperVrSectionDescription_03: "Auf dem Spielfeld kann allerlei Unrat platziert werden." +
        "\nElemente außerhalb des sichtbaren Rasters werden automatisch ausgeblendet.",
    penAndPaperVrSectionHeader_04: "Getrackter Würfel",
    penAndPaperVrSectionDescription_04: "In der Hochschule hatten wir Zugang zu Tracking-Kameras." +
        "\nMit diesem Würfel konnte in echtzeit in der VR-Umgebung gewürfelt werden.",

    // MachineLearning
    machineLearningPaper: "AgentenAusarbeitung",
    machineLearningName: "Maschinelles Lernen",
    machineLearningSubHeader: "Bestandteil meines Informatik Studiums",
    machineLearningVideoImageDescription: "Video von Agenten die Regeln ausführen",
    machineLearningRuleSelectionImageDescription: "Übersicht zur Regelauswahl",
    machineLearningDescription: "Agenten werden zufällige Regelsätze und Teams zugewiesen und kämpfen um ihr Überleben",
    machineLearningSectionHeader_01: "Beschreibung",
    machineLearningSectionDescription_01: "Dies ist ein Ausschnitt aus einem meiner Universitätsprojekte über komplexe, adaptive Systeme." +
        "\nAgenten kämpfen in Teams um Ressourcen und ihr Überleben.",
    machineLearningSectionHeader_02: "Beschreibung",
    machineLearningSectionDescription_02: "Jeder Agent hat einen zufälligen Satz von Regeln. Jede Regel und jeder Zug hat Kosten." +
        "\nZu diesen Regeln gehört z.B. zu fliehen, wenn man in der Unterzahl ist oder nicht gegen Hindernisse zu laufen." +
        "\nDieses Bild zeigt wie Regeln von oben nach unten gehandhabt werden." +
        "\nDer Kurs wurde in deutscher Sprache abgehalten und daher ist auch die folgende Ausarbeitung auf deutsch.",

    // PimpTheLimb
    pimpTheLimbName: "Kanonensprung",
    pimpTheLimbSubHeader: "Prototyp einer Spielidee",
    pimpTheLimbVideoImageDescription: "Video der Kanonensprung Mechanik",
    pimpTheLimbV1ImageDescription: "1. Design des Kanonen-Charakters",
    pimpTheLimbV2ImageDescription: "2. Design des Kanonen-Charakters",
    pimpTheLimbDescription: "Ein Prototyp in dem eine Kanone gespielt wird",
    pimpTheLimbSectionHeader_01: "Beschreibung",
    pimpTheLimbSectionDescription_01: "Dieses Video zeigt die Grundmechanik." +
        "\nDer Spieler kann leicht nach links und rechts rollen." +
        "\nDas Schießen hat einen Rückstoß und kann zum Springen genutzt werden." +
        "\nMunition wird durch Drehungen nachgeladen." +
        "\nDie Munition wird auf der Kanone angezeigt.",
    pimpTheLimbSectionHeader_02: "Version 1",
    pimpTheLimbSectionDescription_02: "Dies ist die erste Version." +
        "\nDiese Idee basiert auf Mount Your Friend." +
        "\nVier Kanonen sind jedoch unbedienbar.",
    pimpTheLimbSectionHeader_03: "Version 2",
    pimpTheLimbSectionDescription_03: "Durch eine Vereinfachung wird nur noch eine Kanone verwendet." +
        "\nDafür kann die Figur leicht zu den Seiten rollen." +
        "\nDiese Idee wurde aufgegeben da das Leveldesign ein Albtraum ist.",

    // Portals
    portalGunName: "Portalkanone",
    portalGunSubHeader: "Prototyp einer Spielidee",
    portalsVideoImageDescription: "Video einer Portal-Pistole",
    portalGunDescription: "Ein Prototyp einer selbstgebauten Portalpistole",
    portalGunSectionHeader_01: "Beschreibung",
    portalGunSectionDescription_01: "Der Spieler kann zwei Projektile verschießen, die zwei verbundene Portale erzeugen." +
        "\nBeim Aufprall finden Projektile die beste Positionierung und Ausrichtung für Portale." +
        "\nPortale ermöglichen einen nahtlosen Übergang von Spielern und Objekten." +
        "\nDie Immersion wird nur durch die Schatten der Beleuchtung unterbrochen." +
        "\nFür die Umsetzung wurden mehrere Kameras und Kollisionsebenen verwendet.",

    // Empfängnis
    empfaengnisName: "Empfängnis",
    empfaengnisSubHeader: "Ein Buchprojekt mit Freunden",
    empfaengnisImageDescription: "Buch Cover",
    empfaengnisDescription: "Ein Fantasy-Roman, den ich mit 2 Freunden während der Schulzeit geschrieben habe",
    empfaengnisSectionHeader_01: "Empfängnis",
    empfaengnisSectionDescription_01: "Dieser Fantasy-Roman wurde Seite für Seite geschrieben, während wir uns abwechselten." +
        "\nIch habe meine Seite an Patrick weitergegeben, Patrick an Kjeld und Kjeld an mich." +
        "\nDas führte dazu, dass jedem Autor Informationen fehlten und urkomische Wendungen enstanden." +
        "\nWenn du das Leben nicht zu ernst nimmst, solltest du es lesen." +
        "\nNebenbemerkung: Ich wurde wegen des Namens überstimmt.",

    // StealthCommander
    stealthCommanderName: "Einheiten auf Kurven bewegen",
    stealthCommanderSubHeader: "Prototyp einer Steuerung für eine Spielidee",
    stealthCommanderVideoImageDescription: "Video zur kurvenbasierten Bewegung",
    stealthCommanderDescription: "Ein Prototyp für ein kurvenbasiertes Bewegungssystem",
    stealthCommanderSectionHeader_01: "Beschreibung",
    stealthCommanderSectionDescription_01: "Einheiten können ausgewählt und befehligt werden." +
        "\nSich bewegende Einheiten haben ihren Pfad angezeigt und jeder Pfad hat einen Griff." +
        "\nDas Bewegen des Griffs verändert den Pfad, wodurch eine Kurve entsteht." +
        "\nDie maximale Krümmung ist proportional zur Länge des Pfad.",

    // GrimRepair
    grimRepairName: "Grim Repair",
    grimRepairSubHeader: "Spiel für den Inno Global Game Jam 2020",
    grimRepairVideoImageDescription: "Video eines Spieldurchlaufs",
    grimRepairDescription: "Global Game Jam von 2020 mit dem Thema 'Reparatur'",
    grimRepairSectionHeader_01: "Beschreibung",
    grimRepairSectionDescription_01: "In Grim Repair hat der Grim Reaper alle Handwerker getötet." +
        "\nJetzt ist es deine Aufgabe Maschinen zusammenzubauen." +
        "\nDiese Maschinen müssen dann den Grim Reaper angreifen, um ihn aufzuhalten." +
        "\nEs stellt sich heraus, dass das ganze Spiel auf einem noch größeren Grim Reaper aufgebaut wurde.",

    // Catastrophic
    catastrophicName: "Catastrophic",
    catastrophicSubHeader: "Spiel für den Inno Global Game Jam 2019",
    catastrophicVideoImageDescription: "Video eines Spieldurchlaufs",
    catastrophicDescription: "Global Game Jam of 2019 mit dem Thema 'Zuhause'",
    catastrophicSectionHeader_01: "Beschreibung",
    catastrophicSectionDescription_01: "In Catastrophic demoliert eine Katze dein Zuhause." +
        "\nDu bist ein Roboter mit magnetischen Kräften und hast die Aufgabe alles zu reparieren." +
        "\nSammle und schieße Schraubenzieher um Dinge zu reparieren." +
        "\nBeachte, dass das Reparieren von Dingen weitere Katzen, Schraubenzieher und Verrücktheiten anziehen kann." +
        "\nIch liebe einfach Fluid-Simulationen.",

    // Homepage3D
    homepage3DName: "Made of Cubes",
    homepage3DSubHeader: "Eine 3D Homepage",
    homepage3DLandingPageImageDescription: "Startseite",
    homepage3DVideoDescription: "Video der 3D Homepage",
    homepage3D3DFontImageDescription: "Eigener 3D Font",
    homepage3D3DContract1ImageDescription: "Kontaktseite",
    homepage3D3DContract2ImageDescription: "Kontaktseite während Animation",
    homepage3D3DPageImageDescription: "Portfolio",
    homepage3DDescription: "Meine vorherige Homepage die zu 100% aus 3D Würfeln besteht",
    homepage3DSectionHeader_01: "Beschreibung",
    homepage3DSectionDescription_01: "Ich kann mich nicht daran erinnern wie ich auf die absurde Idee kam eine Homepage zu 100% in 3D zu bauen." +
        "\nAber hey es sieht cool aus wenn Würfel umherfliegen." +
        "\nFunfact 1: Alle auf der Homepage verwendeten Würfel sind Klone des abgebildeten Ladesymbols." +
        "\nFunfact 2: Für flüssige FPS ist eine dedizierte GPU erforderlich, und die Anwendung kann diese nicht selbst zuweisen." +
        "\nDie Homepage selber ist nicht mehr aktiv also habe ich ein kurzes Video aufgenommen.",
    homepage3DSectionHeader_02: "Eigener Font",
    homepage3DSectionDescription_02: "Ich hatte die grandiose Idee auch den gesamten Text aus 3D Würfeln zu erstellen." +
        "\nAlso warum den Holzweg nicht zuende gehen und einen eigenen low-poly Font bauen!",
    homepage3DSectionHeader_03: "Würfel animieren",
    homepage3DSectionDescription_03: "Es ist dann auch noch sehr viel cooler wenn Würfel umherfliegen um Text darzustellen." +
        "\nEs stellt sich heraus, dass tausende Animationen (Tweens) für Position, Rotation, Skalierung und Farbe dann doch rechenintensiv werden" +
        "\nDaher werden ausnahmslos alle Animationen auf der Seite bereits beim Aufruf berechnet.",
    homepage3DSectionHeader_04: "Würfel formen Kontaktseite",
    homepage3DSectionDescription_04: "Die Würfel sind nun an ihre Positionen geflogen und gedreht." +
        "\nDamit Interaktionen möglich werden werden Raycasts der Maus verwendet um Wörter einfärben zu können." +
        "\nNicht vorhandene Würfel für längere Texte werden automatisch generiert.",
    homepage3DSectionHeader_05: "Portfolio",
    homepage3DSectionDescription_05: "Zuletzt müssen auch noch meine Projekte angezeigt werden." +
        "\nHierfür werden diese als Bilder auf den gleichen Würfel angezeigt." +
        "\nBeim Seitenwechsel werden die Bilder genau dann ausgetauscht wenn die Objekte orthogonal zur Kamera sind." +
        "\nDas waren leider keine 90 Grad Winkel weil die Kamera perspektivisch ist." +
        "\nIch habe auch Videos in diesem 3D Raum auf den Würfeln eingebunden." +
        "\nEs war ein Alptraum, da zusätzliche Kameras benötigt werden." +
        "\nVor allem beim Zoomen.",

    // Homepage2D
    homepage2DName: "Homepage 2D",
    homepage2DSubHeader: "Genau diese Homepage!",
    homepage2DImageDescription: "Startseite",
    homepage2DFrontendImageDescription: "Frontend Pakete",
    homepage2DColorPalettesImageDescription: "Eigene Farbpaletten",
    homepage2DMuiImageDescription: "Styling react Komponenten",
    homepage2DReduxImageDescription: "Redux store Konfiguration",
    homepage2DContactPageImageDescription: "Code der Kontaktseite",
    homepage2DFrontendDevImageDescription: "Pakete zur Kompilierung",
    homepage2DExampleProjectImageDescription: "Beispiel zur Project Konfiguration",
    homepage2DProjectTypesImageDescription: "Interfaces der Projekt Konfiguration",
    homepage2DDockerFileImageDescription: "Docker file der Webanwendung",
    homepage2DeploymentImageDescription: "Deployment Pakete",
    homepage2DUtilitiesImageDescription: "Weitere Pakete",
    homepage2DImageKitIoImageDescription: "Imagekit.io Übersicht",
    homepage2DMobileImageDescription: "Karriere Projekte - Mobile Ansicht",
    homepage2DDescription: "Entwicklung dieser Homepage",
    homepage2DSectionHeader_01: "Homepage 2D",
    homepage2DSectionDescription_01: "Beschreibung meiner Homepage auf meiner Homepage. Fun!\n" +
        "Ab und zu aktualisiere ich diese Homepage also sind nicht stets alle Bilder aktuell.",
    homepage2DSectionHeader_01_5: "Mobile Auflösungen",
    homepage2DSectionDescription_01_5: "Alle Seiten sind responsive und funktionieren bis zu einer Auflösun von 300x640.\n" +
        "Kleinere Geräte sollten nur noch Tamagotchis sein.",
    homepage2DSectionHeader_02: "Rendering",
    homepage2DSectionDescription_02: "Ich verwende Material-UI zum Stylen von Elementen und für Themes." +
        "\nIch habe mich für React entschieden, da ich langsam meine wiederverwendbaren Komponenten aufbaue." +
        "\nRedux ist eventuell übertrieben für so ein kleines Projekt, aber ich verwende es auch als Vorlage für andere Projekte.",
    homepage2DSectionHeader_03: "Themes",
    homepage2DSectionDescription_03: "Material-UI ermöglicht eine einfache Verwendung für Themes." +
        "\nDamit gibt es einen hellen und einen dunklen Modus <3",
    homepage2DSectionHeader_04: "Styling",
    homepage2DSectionDescription_04: "Styling mit Material-UI",
    homepage2DSectionHeader_05: "Redux Store",
    homepage2DSectionDescription_05: "Der Redux-Store ermöglicht es uns den State global zu verwalten." +
        "\nFür die Anzeige von Toasts unter Verwendung des AlertState oder die Aktualisierung der Sprachauswahl unter Verwendung des languageState.",
    homepage2DSectionHeader_06: "Beispiel: Kontakt-Seite",
    homepage2DSectionDescription_06: "Aufgrund der benutzten Bibliotheken sind die Seiten schön kompakt." +
        "\nDie Komponente enthält Typdefinitionen für props, die an die Komponente übergeben werden." +
        "\nSie enthält zudem einen internen State und Funktionen zur Verwaltung von Eingaben." +
        "\nUnd zuletzt wird der globale State, z. B. für Alerts und Styles, auf die Komponente abgebildet.",
    homepage2DSectionHeader_07: "Kompilierung",
    homepage2DSectionDescription_07: "Um die Javascript-Hölle zu vermeiden wird Typescript verwendet." +
        "\nIch liebe Typescript." +
        "\nWebpack kompiliert den Code in ein kleines Paket." +
        "\nDocker weil Docker! Hurra!",
    homepage2DSectionHeader_08: "Projektbeispiel: Portale",
    homepage2DSectionDescription_08: "Jedes Projekt dieser Homepage is in einer Config definiert." +
        "\nDas macht es einfacher,im Laufe der Zeit neue Projekte hinzuzufügen." +
        "\nDieser Block allein erstellt ein Kartenelement auf der Hauptseite und auch eine komplette Unterseite." +
        "\nDiese Seite ist auch eine solche Konfiguration.",
    homepage2DSectionHeader_09: "Projekt-Konfigurationsarten",
    homepage2DSectionDescription_09: "Eine Projektseite besteht aus all diesen Typdefinitionen." +
        "Einige sind optional wie z.B. Videos, Bilder, Downloads usw.",
    homepage2DSectionHeader_10: "Docker-Datei",
    homepage2DSectionDescription_10: "Hier gibt es nicht viel zu sagen." +
        "\nPakete installieren, einen Build erstellen, der Build enthält dann die public index.html.",
    homepage2DSectionHeader_11: "Deployment",
    homepage2DSectionDescription_11: "Der Code liegt auf Github." +
        "\nDynadot ist mein Domain-Provider." +
        "\nNetlify wird für die automatische Bereitstellung und das Hosting verwendet.",
    homepage2DSectionHeader_12: "Nützliche Bibliotheken",
    homepage2DSectionDescription_12: "Imagekit.io ermöglicht das Hochladen von Bildern." +
        "\nDamit wird diese Homepage schneller geladen, da Bilder nur bei Bedarf heruntergeladen werden." +
        "\nBilder werden zudem automatisch auf die gewünschte Größe angepasst." +
        "\nEmailJs ermöglicht einen sehr einfachen Versand von E-Mails.",
    homepage2DSectionHeader_13: "ImageKit Io",
    homepage2DSectionDescription_13: "Dies ist ein Screenshot meines Imagekit.io Ornders, der alle Bilder dieser Homepage enthält.",

    // LaserEngraver
    laserEngraverDescription: "Ein Lasergravurgerät mit dem ich auf Din A4 gedruckt habe",
    laserEngraverName: "Drucken mit Lasern",
    laserEngraverSubHeader: "Nein kein Laserdruck sondern echte Laser!",
    laserEngraverImageDescription_01: "Blaues Din A4 Papier im Lasergravurgerät",
    laserEngraverSectionHeader_01: "Beschreibung",
    laserEngraverSectionDescription_01: "Mein Drucker gab den Geist auf und ich habe nach einer Alternative ohne Toner Probleme gesucht." +
        "\nAlso habe ich ein Atomstack A5 bestellt und ihn modifiziert um auf Din A4 Paper zu gravieren." +
        "\nAlso wie habe ich ihn konfiguriert und modifiziert?",

    laserEngraverImageDescription_02: "Lasergravurgerät in Holzkiste - Frontansicht",
    laserEngraverSectionHeader_02: "Verschachtelung",
    laserEngraverSectionDescription_02: "Das Fundament muss gut sein damit die Vibration nicht die Lasergravur beeinflusst." +
        "\nAlso habe ich laminiertes Holz auf allen Seiten angebracht und das Lasergravurgerät festgeschraubt." +
        "\nDies ist auch praktisch, da ich so nicht permanent eine Schutzbrille tragen muss." +
        "\nDie Front kann für eine leichtere Entnahme geöffnet werden." +
        "\nDie Kabel verlaufen an der rechten Wand damit sie nicht an den Lasergravurkopf geraten.",

    laserEngraverImageDescription_03: "Lasergravurgerät in Holzkiste - Vogelansicht",
    laserEngraverSectionHeader_03: "Wird auch als Stuhl verwendet",
    laserEngraverSectionDescription_03: "Die Oberseite kann zusätzlich geöffnet werden." +
        "\nIn der rechten, oberen Ecke habe ich eine Ventilation angebracht, um giftige Gase abzusaugen. Die Luft schmeckt so weniger süß." +
        "\nDer Ventilationsschlauch ist ausziehbar und wird aus dem Fenster gehangen. Die Ventilation ist über einen Schalter aktivierbar." +
        "\nAlle Kabel verlassen die Kiste über ein Loch in der Unterseite der Vordertür.",

    laserEngraverImageDescription_04: "Lasergravurkopf mit Luftunterstützung",
    laserEngraverSectionHeader_04: "Luftunterstützung",
    laserEngraverSectionDescription_04: "Ich habe eines dieser grünen Teile durch einen 3D gedruckten Adapter für einen Luftschlauch ersetzt." +
        "\nDie Luftunterstützung verbessert die Qualität der Lasergravur drastisch indem sie Schmutzpartikel wegpustet." +
        "\nAndernfalls würden sich die Schmutzpartikel absetzen oder vom Laser verbrannt werden und dunke Flecken hinterlassen.",

    laserEngraverImageDescription_05: "Luftkompressor in einer Holzkiste",
    laserEngraverSectionHeader_05: "Luftkompressor",
    laserEngraverSectionDescription_05: "The pressured air comes from a separate compessor." +
        "\nDer Luftkompressor hat eine Luftaufnahme und Ausgabe. Ich kann einen Schlauch in den Luftausgang stecken." +
        "\nKompressoren sind recht laut und daher habe ich eine Holzkiste drum herum gebaut und reduziere die Vibration mit Dämmmaterial." +
        "\nEs hat sehr geholfen die Lautstärke zu reduzieren aber er ist immernoch recht laut. Gibt es so eigentlich Probleme mit der Hitzeentwicklung? Nach 30 Minuten ist er sehr heiß." +
        "\nZumindest habe ich einen Feuerlöscher daneben stehen.",

    laserEngraverImageDescription_06: "Ein Holzbrett mit Testläufen der Lasergravur",
    laserEngraverSectionHeader_06: "Testläufe",
    laserEngraverSectionDescription_06: "Soviel kann an einem Lasergravurgerät konfiguriert werden." +
        "\nDie Geschwindigkeit des Lasergravurkopfes, the Intensität, wie oft ein Pfad abgelaufen wird und welcher Algorithmus den Pfad bestimmt." +
        "\nAuch der Winkel ist relevant, da die Fokuslinse rechteckig ist. Zudem sind Diagonale Pfade knifflig, da dies 2 Achsen involviert." +
        "\nDer Name, das 'T' und einige der 'Te' wurden mit Luftunterstützung graviert." +
        "\nEine fehlerhafte Konfiguration resultierte in 1-3cm tiefen löchern und diese waren nicht einmal auf voller Intensität oder einer hohen Dauer.",

    laserEngraverImageDescription_07: "Mikro-Controller mit Stopper auf einer Achse",
    laserEngraverSectionHeader_07: "Ursprungs-Finder",
    laserEngraverSectionDescription_07: "Der Lasergravurkopf weiß nicht wo er sich befindet." +
        "\nBeim Zurücksetzen fährt der Kopf für eine Weile gegen beide Begrenzungen, da kein Stoppsignal existiert." +
        "\nIch habe 2 Mikro-Controller gekauft und habe Holzflächen gelasert mit denen ich sie auf den beiden Achsen angebracht habe." +
        "\nDie Stopper werden nun vom Lasergravurkopf beim Zurücksetzen ausgelöst und senden ein Signal an den Atomstack A5." +
        "\nMit geringfügiger Konfiguration in der Lightburn Software funktioniert nun der Ursprungsfinder.",

    laserEngraverImageDescription_08: "Ein graviertes Schnitzmesser",
    laserEngraverSectionHeader_08: "Geschenkgravur",
    laserEngraverSectionDescription_08: "Einer meiner Freunde machte sich auf eine lange Reise und ich schenkte ihr ein ein Schnitzmesser und einen Block Holz." +
        "\nDies war eine optimale Möglichkeit für eine Lasergravur des Namens und einem philosophischen Text." +
        "\nDas Ergebnis ist sehr gut geworden für den ersten Anwendungsfall." +
        "\nWarum habe ich hier eigentlich keinen Screenshot gemacht?",

    laserEngraverImageDescription_09: "Svg eines Pdf im Lightburn Ui",
    laserEngraverSectionHeader_09: "Dokumente zur Lasergravur vorbereiten",
    laserEngraverSectionDescription_09: "Mein Drucker ist immernoch kaputt und ich musste eine Widerrufsbelehrung ausdrucken, da ich die falsche Geldbörse bestellt habe." +
        "\nUm sie zu drucken habe ich das Dokument in einem Online-Konvertierer von Pdf nach Svg konvertiert und daraus in der Lightburn Software Gravurpfade erstellt." +
        "\nIch habe es so konfiguriert, dass nur die Ränder der Texte gelasert werden. Hierdurch ist es etwas leichter zu lesen und ging sehr viel schneller.",

    laserEngraverImageDescription_10: "Ein blaues, graviertes Stück Din A4 Papier",
    laserEngraverSectionHeader_10: "Lasergravur abgeschlossen",
    laserEngraverSectionDescription_10: "Die Lasergravur dauerte etwas mehr als 5 Minuten und es ist lesbar; das ist ausreichend." +
        "\nDas Papier darf nicht weiß sein, da es aus physikalischen Gründen nicht lasergravierbar wäre. Ich dachte mir ein helles blau wäre am wenigsten merkwürdig." +
        "\nBeinahe hätte ich noch 'Papercuts' mit 'Lasercuts' ersetzt aber wollte dann doch eine Urheberrechtsverletzung vermeiden." +
        "\nIch habe mein Geld zurückerhalten und benutze bis heute die nachbestellte Geldbörse.",

    // LampClock
    lampClockDescription: "Eine hölzerne Lampe die mit Led's die Uhrzeit anzeigt und Temperatur sowie Regen vorhersagt",
    lampClockName: "Led Uhr mit Wettervorhersage",
    lampClockSubHeader: "Eine fetzige Lampe mit feature creep",
    lampClockImageDescription_01: "Verkabelte Rückseite der Lampe",
    lampClockSectionHeader_01: "Beschreibung",
    lampClockSectionDescription_01: "Als ich einen befreundeten Kjeld besuchte zeigte er mir seine Led-Projekte." +
        "\nIch war verzaubert und liebe so schon Holzarbeiten. Inzwischen liebe ich auch Mikro-Controller und Led-Programmierung.",
    lampClockImageDescription_02: "Ein rundes, laminiertes Stück Buche mit 80 cm Durchmesser",
    lampClockSectionHeader_02: "Die Basis",
    lampClockSectionDescription_02: "Ich habe dieses Stück Buche im Baumarkt gefunden." +
        "\nIch dachte mir sofort, dass es gut für eine Yin und Yang Lampe geeignet wäre." +
        "\nMit Bleistift und Faden habe ich die seitlichen Löcher sowie die 'S'-Form in der Mitte markiert. Von dort aus habe ich mit einem Zirkel Abstände von ~8cm markiert." +
        "\nDiese Aussparungen werden interessantere Led Einlassungen ermöglichen.",
    lampClockImageDescription_03: "Das gesägte und geschliffene Buchenbrett",
    lampClockSectionHeader_03: "Sägen und Schleifen",
    lampClockSectionDescription_03: "Mit einer Stichsäge habe ich die groben Formen ausgesägt. Hierbei lernte ich, dass Stichsägen sich wirklich nicht gerne in kleinen Kreisen bewegen und dass Buche nicht nur sehr hart ist sondern auch sehr staubt." +
        "\nAnschließend war eine enorme Menge an Schleifarbeit nötig. Kleinere Makel habe ich mit dem Stemmeisen und Holzpaste ausgeglichen.",

    lampClockImageDescription_04: "Buchenbrett nach 2 mal dunkel Lackieren",
    lampClockSectionHeader_04: "Painting und Oiling",
    lampClockSectionDescription_04: "Ich habe eine Seite geölt und eine schwarz lackiert und merkte dass der Lack nicht gut deckt." +
        "\nDurch die Laminierung und die unterschiedlichen Holzstücke variiert die Deckkraft und Klebrigkeit." +
        "\nIch habe die dunkle Seite 3 mal lackiert und weil sie sehr uneben war habe ich sie runtergeschliffen und noch 4 mal lackiert." +
        "\nJedes mal habe ich sie abhängig von der Klebrigkeit 12-72h trocknen lassen. Nächstes mal teste  ich das vorab. Das Endergebnis sieht aber gut aus.",

    lampClockImageDescription_05: "Led-Streifen auf der Rückseite",
    lampClockSectionHeader_05: "Led-Streifen anbringen",
    lampClockSectionDescription_05: "Ich war unsicher was die beste Möglichkeit wäre Led-Streifen orthogonal anzubringen." +
        "\nIch wollte eine natürliche / nicht-destruktive Anbringung um Fehler rückgängig machen zu könnens. Ich entschied mich Löcher für Holzstifte zu böhren und Led-Streifen zu spannen." +
        "\nDie Led-Streifen haben eine klebrige Rückseite und ich dachte es würde die Anbringung erleichtern; tat es nicht." +
        "\nDie Led-Streifen wurden mit Plastik-Klammern verbunden, da sie vielversprechend wirkten." +
        "\nDies funktionierte zunächst gut aber mehr dazu später.",

    lampClockImageDescription_06: "Netzteil und Esp12e Mikro-Controller auf der Rückseite",
    lampClockSectionHeader_06: "Netzteil und Mikro-Controller anschließen",
    lampClockSectionDescription_06: "Zum Testen habe ich den Mikro-Controller angeschlossen und einzelne Farben angezeigt." +
        "\nDiese Mikro-Controller sind super! Sie unterstützen WiFi und Code kann darüber oder über usb-c Kabel deployed werden." +
        "\nÜber den usb-Anchluss wird auch Debugging ermöglicht. Ohne hätte das Projekt nicht funktioniert." +
        "\nIch bemerkte einen Helligkeitsabfall bei den Led's. Dies war zu erwarten, da die Streifen zusammen ~5m lang sind und eine Hohe Led-Dichte haben." +
        "\nBeim löten und krimpen der Led-Streifen und Kabel ist mir ein Mikro-Controller und ein usb-hub durchgebrannt. Kjeld war auch beeindruckt!",

    lampClockImageDescription_07: "Diagram der Lampen Verkabelung",
    lampClockSectionHeader_07: "Kabel und Led-Schaltung",
    lampClockSectionDescription_07: "Das Netzteil liefert den Strom zum Mikro-Controller und separat zu beiden Enden des ganzen Led-Streifens damit die Helligkeit nicht abfällt." +
        "\nDie Led-Streifen wurden durch die kürzesten Wege miteinander verbunden. Durch die sequentielle Schaltung ergeben sich die Led-Positionen für die spätere Programmierung.",

    lampClockImageDescription_08: "Löt Aufbau",
    lampClockSectionHeader_08: "Lötstation, Flux und Kupferwolle",
    lampClockSectionDescription_08: "Kjeld schenkte mir seine alte Lötstation und mit der habe ich Kabel, Led-Streifen und Mikro-Controller verlötet." +
        "\nIch habe 2 mal die Spitze des Lötkolbens verbrannt aber nach ein paar Stunden lief es einwandfrei.",

    lampClockImageDescription_09: "Kabel an Led-Streifen gelötet",
    lampClockSectionHeader_09: "Soviele Verbindungen gekrimpt und gelötet",
    lampClockSectionDescription_09: "Diese Plastikverbindungen von früher neigen dazu zu rosten und zu zerkratzen. Dadurch geht die Verbindung verloren und überall herrscht Wackelkontakt." +
        "\nAlso habe ich alles fest verlötet. Das hat sehr lange gedauert aber war auch sehr zufriedenstellend.",

    lampClockImageDescription_10: "Diagramm vom Mikro-Controller und der Wetter-Api",
    lampClockSectionHeader_10: "Zugriff auf die Wetter-Api",
    lampClockSectionDescription_10: "Seit ich die Löcher in das Buchenbrett gesägt habe dachte ich mir, dass es ein guter Ort für die Anzeige nützlicher Information sei." +
        "\nIch beschloss eine Regenvorhersage im linken Keis und eine Temperaturvorhersage im rechten Kreis anzuzeigen." +
        "\nIch habe versucht die Wetter-Api direkt anzusprechen aber sie gibt viel zu viele Daten zurück." +
        "\nDas absolute Minimum an Daten, das ich abrufen konnte war immernoch größer als der gesamte RAM des Mikro-Controllers.",

    lampClockImageDescription_11: "Code der AWS Lambda zur Minimierung der Wetter Daten",
    lampClockSectionHeader_11: "Serverless zur Rettung!",
    lampClockSectionDescription_11: "Beim Auslösen der AWS Lambda greift diese auf die Wetter-Api zu und filtert redundante Daten heraus." +
        "\nSolange nicht mehr als eine Anfrage alle 15 Minuten eingeht bleibe ich im Gratiskontingent der Wetter-Api" +
        "\nDa Json zu ineffizient zur Datenübermittlung ist verwende ich Octet-Streams." +
        "\nEr enthält alle Temperaturwerte für die nächsten 24h und zusätzlich ob es in jeder Stunde regnen wird." +
        "\nIch habe versucht mehrtägige Vorhersagen anzuzeigen aber dafür sind die Leds nicht granular genug und ich belasse es bei 24h.",

    lampClockImageDescription_12: "Konfiguration der Led-Streifen Positionen",
    lampClockSectionHeader_12: "Zuweisung der Led-Indizes",
    lampClockSectionDescription_12: "Zur Programmierung der Led's muss ich die Position jeder Leuchte wissen." +
        "Alle Led's sind sequentiell miteinander verbunden und daher ergeben sich aus den Längen der Led-Streifen die Positionen.",

    lampClockImageDescription_13: "Konfiguration der Farb-Modi",
    lampClockSectionHeader_13: "Konfiguration der Farb-Animationen",
    lampClockSectionDescription_13: "Die Led-Streifen ergeben 4 Formen." +
        " \nDer rechte Ring zeigt den Temperaturverlauf an der von der Aws Lambda und Wetter-Api abgerufen wurde." +
        " \nDer äußere Ring zeigt die Uhrzeit an die durch das Modem bereitgestellt wird." +
        " \nDie 'S'-Form in der Mitte spielt eine zufällige Farbanimation." +
        " \nDer linke Ring zeigt die Regenvorhersage und benutzt die gleichen Wetter-Daten wie oben." +
        " \nMeine Berührungspunkte mit C++ waren bis hierhin spärlich daher verbrachte ich einige Zeit mit Fehlerbehebung bei den Farb-Animationen." +
        " \nGroßteils war es die Zuweisung von Farben, das abwarten von Pausen, das Interpolieren von Farben und das loopen über die Led-Streifen.",

    lampClockImageDescription_14: "Code zur Zuordnung zu 'es regnet'",
    lampClockSectionHeader_14: "Minimierung der Wetter-Api Daten",
    lampClockSectionDescription_14: "Die Wetter-Api hat mir nicht nur mitgeteilt ob ich eine Jacke tragen sollte und daher habe ich Werte auf 'es regnet' abgebildet." +
        "\nNun trage ich eine Jacke wenn es regnet, schneit, tröpfelt, stürmt oder ein Tornado ansteht." +
        "\nVielleicht sollte ich eines Tages noch einen Notfall Modus hinzufügen.",

    lampClockImageDescription_15: "Deployment Konfiguration für Pio",
    lampClockSectionHeader_15: "Code Deployment auf den Mikro-Ccontroller",
    lampClockSectionDescription_15: "Ich habe mit PlatformIo den Code via Wifi und usb deployed. Das Plugin gibt es für gängige Ide's." +
        "\nBasierend auf der Art des Mikro-Controllers habe ich Boilerplate hinzugefügt und konnte auf 'Upload' klicken.",

    lampClockImageDescription_16: "Fertige Lampe - aus",
    lampClockSectionHeader_16: "Lampe aus",
    lampClockSectionDescription_16: "Sie sieht auch ausgeschaltet sehr gut aus." +
        "\nDie Lampe hat ein Kabel für den Strom und ein am Rand verstecktes usb-Kabel fürs Debugging." +
        "\nSie ist mit Haken an der Wand eingehangen und jederzeit abnehmbar.",

    lampClockImageDescription_17: "Fertige Lampe - an",
    lampClockSectionHeader_17: "Lampe an",
    lampClockSectionDescription_17: "Es stellt sich heraus, dass diese Lampe sehr schwer zu fotografieren ist." +
        "\nBis ich also ein besseres Foto aufgenommen habe müsste ihr mir glauben was da so dargestellt wird.." +
        "\nDie blaue Farbe am oberen Rand ist der Minutenzeiger und die orangene Farbe am unteren Rand ist der Stundenzeiger. Es ist also ~06:00. oder ~18:00." +
        "\nDer linke Ring hat 4 Bereiche á 6h und zeigt orange für trockenes Wetter und blau für Regen." +
        "\nDer rechte Ring zeigt einen Temperaturverlauf von Lila-> Blau -> Grün -> Gelb -> Orange -> Rot mit einer Weite von ~-10 bis 40 Grad Celsius." +
        "\nErkenntnis: tagsüber ist es großteils warm und nachts ist es kalt." +
        "\nDies war ein Projekt an dem ich gerne nebenbei über die Jahre gewerkelt habe und bin froh, dass ich mich noch 2 mal an den Feinschliff gemacht habe." +
        "\nDie Lampe hängt nun an der Wand hinter dem Esszimmertisch und hat einen Schalter um sie anzumachen.",

    // BoxOfCards V3
    boxOfCardsV3Name: "Release Box of Cards V3",
    boxOfCardsV3Description: "Migration eines Kartenspiels zu dedizierten Servern und horizontaler Skalierung",
    boxOfCardsV3SubHeader: "Miration eines Kartenspiels zu dedizierten Servern und horizontaler Skalierung. Für mehr Infos siehe V1 und V2",
    boxOfCardsV3SectionImageDescription_01: "Neue Startseite",
    boxOfCardsV3SectionHeader_01: "Box of Cards Beta Release!",
    boxOfCardsV3SectionDescription_01: "Ich bin sehr stolz darauf, dass Box of Cards nun veröffentlicht ist." +
        "__LINEBREAK__" +
        "\nÜber mehrere Jahre hinweg habe ich in meiner Freizeit daran gewerkelt." +
        "\nEs hätte viel schneller gehen können, aber ich wollte verschiedene Lernmöglichkeiten und neue Technologien auf dem Weg ausprobieren." +
        "__LINEBREAK__" +
        "\nDiese Seite enthält Informationen zu den Features von Box of Cards, warum ich von AWS zu Digital Ocean gewechselt bin und den finalen Tech-Stack.",
    boxOfCardsV3SectionImageDescription_02: "Hauptmenü",
    boxOfCardsV3SectionHeader_02: "Spiele, Decks & Konto",
    boxOfCardsV3SectionDescription_02: "Dieses Hauptmenü wird nach dem Login angezeigt." +
        "__LINEBREAK__" +
        "\nLogins über Drittanbieter wie z.B. Discord schalten benutzerdefinierte Decks & die Account-Verwaltung frei." +
        "\nGäste können Spiele erstellen, aber keine Decks verwalten, da ich eine dauerhafte Kennung benötige, um Decks zuzuordnen.",
    boxOfCardsV3SectionImageDescription_03: "Eine Spiellobby mit aktivem Decks-Tab",
    boxOfCardsV3SectionHeader_03: "Spiellobby Deck-Auswahl",
    boxOfCardsV3SectionDescription_03: "Nach dem Klick auf 'Spiel erstellen' wird eine neue Spiellobby erstellt." +
        "\nDer Host kann dann Decks im aktiven Decks-Tab auswählen und liken.",
    boxOfCardsV3SectionImageDescription_04: "Eine Spiellobby mit aktivem Optionen-Tab",
    boxOfCardsV3SectionHeader_04: "Spiellobby Optionen-Auswahl",
    boxOfCardsV3SectionDescription_04: "Über den Optionen-Tab kann der Host die Spielregeln anpassen." +
        "\nDazu gehört z.B. ob automatisch ein Satz gezogen oder manuell ausgewählt wird. Und ob der Gewinner vom Kardinal bestimmt oder von allen gewählt wird.",
    boxOfCardsV3SectionImageDescription_05: "Spiellobby Einladungs-Overlay",
    boxOfCardsV3SectionHeader_05: "Spieler Einladen",
    boxOfCardsV3SectionDescription_05: "Dieses Spiel wird mit anderen gespielt. Der Host kann Beitrittslinks kopieren und an Mitspieler senden." +
        "\nKI-Spieler können ebenfalls für ihren überragenden Humor hinzugefügt werden, oder um Deck-Kreationen selbst zu testen.",
    boxOfCardsV3SectionImageDescription_06: "Spiel mit aktiver Satzauswahl",
    boxOfCardsV3SectionHeader_06: "Satz Auswählen",
    boxOfCardsV3SectionDescription_06: "Dies ist ein Spiel, in dem Sätze aktiv ausgewählt werden." +
        "\nDer Host hat die Satzkarte oben links ausgewählt und kann diese nun bestätigen." +
        "\nDie Infobox unten informiert die Spieler immer, wann und was zu tun ist." +
        "\nDie Spieler werden oben mit ihren Avataren angezeigt. Hier sind alle Spieler außer dem Host KIs." +
        "\nDer Host-Avatar hat Tags, die ihn als Host und Kardinal kennzeichnen.",
    boxOfCardsV3SectionImageDescription_07: "Spiellobby mit Host, der Antworten auswählt",
    boxOfCardsV3SectionHeader_07: "Antworten auswählen",
    boxOfCardsV3SectionDescription_07: "In dieser Runde muss der Host zwei Antworten aus seinen fünf Antworten auswählen." +
        "\nEr wählte zuerst 'Lots of Coffee' und dann 'Their Bot Nets'." +
        "\nDie Antwortoptionen 'Lots of' und 'Their' sind hervorgehoben, da der Host diese speziell ausgewählt hat." +
        "\nAktuell ist die KI Barlow Kardinal und wird den besten Beitrag auswählen.",
    boxOfCardsV3SectionImageDescription_08: "Spiellobby mit Spieler, der Antworten präsentiert",
    boxOfCardsV3SectionHeader_08: "Antworten Präsentieren",
    boxOfCardsV3SectionDescription_08: "Alle eingereichten Antwortstapel werden von einem Spieler präsentiert." +
        "\nNormalerweise würde dies der Kardinal dies übernehmen, aber KI-Kadinäle können nicht präsentieren, und daher springt ein Spieler ein. Die Einreichungen sind anonym und nicht chronologisch, um zu vermeiden, dass man die besten Freunde auswählt.",
    boxOfCardsV3SectionImageDescription_09: "Host präsentiert gewinnende Antworteinreichung",
    boxOfCardsV3SectionHeader_09: "Gewinner Präsentieren",
    boxOfCardsV3SectionDescription_09: "Barlow mochte die vom Host eingereichten Antworten und so erhielt der Host einen Punkt." +
        "\nPunktstände werden oberhalb des Avatars angezeigt, wenn Punkte erzielt wurden." +
        "\nWenn dir das Ergebnis gefällt, kannst du ein Bild davon als Andenken herunterladen oder in sozialen Medien & Chat-Diensten teilen." +
        "__LINEBREAK__" +
        "\nDer Werbeplatzhalter unten ist die Haupteinnahmequelle von Box of Cards und zahlt die Serverkosten.",
    boxOfCardsV3SectionImageDescription_10: "Aktiver Verlauf-Tab",
    boxOfCardsV3SectionHeader_10: "Verlauf",
    boxOfCardsV3SectionDescription_10: "Das Spiel speichert Ergebnisse früherer Runden und bietet Zugriff über den Verlauf-Tab." +
        "\nAufgrund der mobilen Ansicht ist dieser Tab derzeit im '...'-Menü-Button versteckt." +
        "__LINEBREAK__" +
        "\nDer Verlauf kann ebenfalls heruntergeladen werden. Allerdings können nur 12 Karten auf einmal heruntergeladen werden, um Browser & Server zu entlasten. Wenn mehr als 12 Karten verfügbar sind, erscheint eine Auswahl, um zwischen Teilen des Verlaufs zu wechseln.",
    boxOfCardsV3SectionImageDescription_11: "Spiel im hellen Modus und auf Deutsch",
    boxOfCardsV3SectionHeader_11: "Farbmodus & Sprache",
    boxOfCardsV3SectionDescription_11: "Box of Cards öffnet sich automatisch im hellen oder dunklen Modus basierend auf deiner Browser-Voreinstellung." +
        "\nZusätzlich kannst du es auf Deutsch oder Englisch spielen. Decks sind von deiner Sprachauswahl ausgenommen, diese werden also nicht automatisch übersetzt.",
    boxOfCardsV3SectionImageDescription_12: "Deck-Verwaltungsseite eines Benutzers",
    boxOfCardsV3SectionHeader_12: "Deck-Erstellung",
    boxOfCardsV3SectionDescription_12: "Das Wichtigste an Box of Cards sind die individuellen Decks der Spieler." +
        "\nDecks enthalten allgemeine Informationen wie Name, Beschreibung, Sprache, eine Markierung für rauen Inhalt und natürlich Sätze & Antworten.",
    boxOfCardsV3SectionImageDescription_13: "Ein Benutzer bearbeitet ein Deck",
    boxOfCardsV3SectionHeader_13: "Deck-Bearbeitung",
    boxOfCardsV3SectionDescription_13: "Die linke Hälfte enthält die Sätze des Decks und die rechte Hälfte die Antworten." +
        "\nZu Testzwecken können ausgewählte Antworten in den ausgewählten Satz eingefügt werden, indem man die Buttons 'Insert in X' verwendet." +
        "\nSätze & Antworten können separat heruntergeladen & hochgeladen werden.",
    boxOfCardsV3SectionImageDescription_14: "Deck-Info-Tab",
    boxOfCardsV3SectionHeader_14: "Deck-Info",
    boxOfCardsV3SectionDescription_14: "Statistiken und Einstellungen des bearbeiteten Decks.",
    boxOfCardsV3SectionImageDescription_15: "Heruntergeladene Sätze & Antworten im Text-Editor",
    boxOfCardsV3SectionHeader_15: "Deck-Format",
    boxOfCardsV3SectionDescription_15: "Um die Deck-Bearbeitung so einfach wie möglich zu halten, sind die Antworten & Sätze in zwei herunterladbare Dateien aufgeteilt." +
        "\nJede Zeile enthält einen Satz oder eine Antwort." +
        "\nEin Satz kann bis zu 3 Platzhalter/Unterstriche '_' haben." +
        "\nAntworten können bis zu 3 Optionen haben, die austauschbare Textschnipsel ermöglichen '[Ein,Der,]'.",
    boxOfCardsV3SectionImageDescription_16: "Login über Drittanbieter mit Discord",
    boxOfCardsV3SectionHeader_16: "Discord-Login",
    boxOfCardsV3SectionDescription_16: "Um so wenig Benutzerdaten wie möglich zu verwalten, verwende ich nur Logins von Drittanbietern." +
        "\nDies ist auch die minimale Datenmenge, die ich von Discord abrufen kann." +
        "__LINEBREAK__" +
        "\nDas Discord Developer Portal ist großartig. Es fühlt sich an wie zu Hause <3.",
    boxOfCardsV3SectionImageDescription_17: "Zusammenfassung des Box of Cards Discord-Servers",
    boxOfCardsV3SectionHeader_17: "Box of Cards Discord-Server",
    boxOfCardsV3SectionDescription_17: "Ich habe einen Discord-Server erstellt, um mit der Box of Cards-Community zu kommunizieren." +
        "\nHier sammel ich Feedback, beantworte Fragen, poste Changelogs & gebe Spielern einen Ort zum Socializen.",
    boxOfCardsV3SectionImageDescription_18: "Häufig gestellte Fragen-Seite",
    boxOfCardsV3SectionHeader_18: "FAQ",
    boxOfCardsV3SectionDescription_18: "Noch hat niemand eine dieser Fragen gestellt." +
        "\nAber ich vermute, die meisten FAQ-Seiten werden aus Vermutungen erstellt und später erweitert.",
    boxOfCardsV3SectionImageDescription_19: "Impressum-Seite",
    boxOfCardsV3SectionHeader_19: "Rechtliches",
    boxOfCardsV3SectionDescription_19: "Es gibt SO VIELE rechtliche Dinge zu beachten und viele partielle Überschneidungen." +
        "\nEs erscheint unmöglich, wiederholende Angaben zu vermeiden, wenn man alle Vorschriften aus Europa, Großbritannien, Deutschland, USA, Kalifornien, Australien usw. einhalten will.",
    boxOfCardsV3SectionImageDescription_20: "Ich bewältige das mit Memes",
    boxOfCardsV3SectionHeader_20: "Planung und AWS",
    boxOfCardsV3SectionDescription_20: "Ab hier wird es technisch bis zum Ende." +
        "__LINEBREAK__" +
        "\nMein Professor für Software Engineering sagte: 'Planen ist essenziell, aber Pläne sind nutzlos'. Das wiederhole ich oft." +
        "__LINEBREAK__" +
        "\nAnfängliche AWS-Kostenberechnungen zeigten eine sehr große Gewinnspanne, aber die Realität holte auf." +
        "__LINEBREAK__" +
        "\nAuf dem Papier und in der Dokumentation boten AWS-Services die Features, die ich brauchte." +
        "\nAber manchmal funktioniert eine Funktion einfach nicht." +
        "\nDie Kerndienste wie AWS Lambda, S3, DynamoDB usw. sind völlig in Ordnung." +
        "\nAber sobald man etwas Exotischeres wie Appsync oder ein Websocket Api Gateway verwendet, gibt es Probleme, und Umgehungslösungen sind kostspielig.",
    boxOfCardsV3SectionImageDescription_21: "Eine Variation des Java-Memes",
    boxOfCardsV3SectionHeader_21: "Websockets auf AWS",
    boxOfCardsV3SectionDescription_21: "Meine Server müssen Clients über Spielstandsaktualisierungen informieren, daher benötige ich Websockets. Long Polling ist einfach nicht praktikabel." +
        "__LINEBREAK__" +
        "\nDie Appsync-Dokumentation sollte Websocket-Subscriptions ermöglichen, aber die Einschränkungen sind so limiterend, dass ich nach einer Alternative suchen musste." +
        "\nAlso verband ich meine Websockets mit dem AWS Api Gateway und leitete sie an meine AWS Lambda weiter." +
        "\nLeider ist die Disconnect-Behandlung nur Best-Effort und ziemlich unzuverlässig." +
        "\nIch hatte keine Möglichkeit, getrennte Clients zu informieren, und der einzige Weg, dies zu lösen, wäre Long Polling gewesen, yikes." +
        "\nDie Websocket-Verbindung wird außerdem nach 10 Minuten automatisch getrennt, und dies ist unveränderlich.",
    boxOfCardsV3SectionImageDescription_22: "Saubere Architektur ist 1 Beste",
    boxOfCardsV3SectionHeader_22: "Offene AWS-Bugs",
    boxOfCardsV3SectionDescription_22: "Ich habe so viele offene Fehlerberichte von 2018 gesehen, dass ich mich frage, ob überhaupt jemand diese Dienste fortentwickelt." +
        "__LINEBREAK__" +
        "\nEs gibt Kleinigkeiten wie im AWS Api Gateway, das meinen weitergeleiteten request-body Felder in Strings umwandelt, und ich muss dann wieder Zahlen daraus machen." +
        "__LINEBREAK__" +
        "\nAber da ist auch die Interaktion zwischen Cloudformation-Stacks unterschiedlicher Regionen" +
        "\nDiese Interaktionen sind nicht vermeidbar, da globale Dienste wie z.B. Cloudfront nur in us-east-1 verfügbar sind, während ich meine Kerndienste in eu-west-1 habe." +
        "\nEin Deployment funktioniert vielleicht ein paar Mal gut aber plötzlich fehlen Berechtigungen zum Aktualisieren oder Löschen eines Dienstes." +
        "\nAuf einmal verbringt man bis zu Stunden damit, manuell Berechtigungen hinzuzufügen und einzelne Dienste zu löschen, nur um wieder zum Anfang zurückzukehren.",
    boxOfCardsV3SectionImageDescription_23: "Ich habe gelernt, Services vorher zu testen",
    boxOfCardsV3SectionHeader_23: "Möge AWS Appsync brennen",
    boxOfCardsV3SectionDescription_23: "Wie schlimm kann es wirklich sein?" +
        "__LINEBREAK__" +
        "\n Nun, die Community hat Appsync und Apollo mit AWS Lambda neu implementiert." +
        "__LINEBREAK__" +
        "\nWas waren meine Probleme mit Appsync?" +
        "\nEs gibt mehrere. AWS Appsync verwendet GraphQL, aber in begrenzter Weise und mit proprietären Annotations. Dadurch kann der Großteil des Ökosystems nicht genutzt werden, und der umfangreiche Boilerplate-Code kann nicht generiert werden." +
        "__LINEBREAK__" +
        "\nEs gibt eine erhebliche Diskrepanz zwischen unterstützten Protokollen und Protokollversionen von Apollo & AWS Appsync." +
        "\nAppsync unterstützt das MQTT-Websocket-Protokoll nicht, und Apollo hängt so weit zurück, dass sie empfehlen, einen anderen Standard zu verwenden." +
        "\nNichts bleibt kompatibel. Legacy-Protokolle wurden veraltet und entfernt, während moderne Standards noch nicht unterstützt werden." +
        "\nGlücklicherweise konnte ich Apollo stark downgraden, um ein Legacy-Protokoll zu verwenden.",
    boxOfCardsV3SectionImageDescription_24: "Ja, ich brauche zwei Memes dazu",
    boxOfCardsV3SectionHeader_24: "Noch mehr zu Appsync...",
    boxOfCardsV3SectionDescription_24: "Der proprietäre AWS-Scalar-Typ ist mit HttpClients nicht kompatibel, und Key-Value-Pairs werden überhaupt nicht unterstützt." +
        "\nIch musste diese Pairs in JSON verpacken, und somit meine Datenformate zu verschachteln." +
        "__LINEBREAK__" +
        "\nAppsync-Subscriptions sind für mich ein völliges Rätsel. Ich brauche ein Abo pro Topic, ich kann nur einem einzigen Benutzer gleichzeitig antworten, ich kann nicht wissen, wer diese Benutzer sind," +
        "\nund die Daten, die ich sende, können nur Werte für Felder enthalten, die in der Subscription-Anfrage angegeben wurden." +
        "\nDas letzte ist problematisch, da ich keine Werte für Felder bereitstellen kann, die zuvor nicht gesetzt wurden, weil sie optional waren.",
    boxOfCardsV3SectionImageDescription_25: "Kann ich das noch Refactoring nennen?",
    boxOfCardsV3SectionHeader_25: "Eine verhängnisvolle Entscheidung",
    boxOfCardsV3SectionDescription_25: "Ich hatte das schon lange kommen sehen, aber es ist in Ordnung für mich. Dies war von Anfang an ein Projekt zum Erlernen neuer Technologien." +
        "__LINEBREAK__" +
        "\nDie serverlose Architektur ermöglichte es weiterhin, dass Box of Cards profitabel wird. Aber es blieb kaum noch Spaß übrig, und die Administration fühlte sich unnötig umständlich an." +
        "__LINEBREAK__" +
        "\nIch wollte Appsync loswerden, da es ohne Websocket-Subscriptions nur ein teureres und umständlicheres Api Gateway war." +
        "\nAber das Api Gateway war auch unzuverlässig für Websockets, und so wollte ich mit einem kleinen Prototyp eine Alternative ausprobieren. Denn diesmal vertraue ich der Dokumentation nicht.",
    boxOfCardsV3SectionImageDescription_26: "Vorausblick",
    boxOfCardsV3SectionHeader_26: "Caching ist dein Freund",
    boxOfCardsV3SectionDescription_26: "AWS Lambda reduzierte die Serverkosten, aber es fehlte an einem kosteneffizienten Cache für meinen Anwendungsfall. So seltsam es klingen mag, aber DynamoDB war einfach überdimensioniert für die meisten meiner Caching-Anforderungen." +
        "__LINEBREAK__" +
        "\nEin Megabyte gemeinsamer Lambda-Cache wäre genug gewesen, um meine DynamoDB-Aufrufe um ca. 90% für Tausende gleichzeitiger Spiele zu reduzieren." +
        "\nAWS Lambda hat einen begrenzten gemeinsamen Cache, solange sie hot sind, aber das ist ernsthaft nicht für diesen Zweck gedacht." +
        "__LINEBREAK__" +
        "\nAlso was ich brauche, ist im Grunde ein semi-persistenter Server. Dann könnte ich die Serveranzahl je nach Bedarf anpassen, und so versuchte ich das.",
    boxOfCardsV3SectionImageDescription_27: "Du darfst wirklich versuchen, mich umzustimmen",
    boxOfCardsV3SectionHeader_27: "Prototyping dedizierter AWS-Instanzen",
    boxOfCardsV3SectionDescription_27: "Ich möchte, dass Box of Cards skalierbar bleibt, obwohl es wahrscheinlich für immer auf einem einzigen Server laufen könnte. Der Wechsel zu dedizierten Instanzen würde stabile Websocket-Verbindungen und Kosteneinsparungen durch Ersetzung von DynamoDB mit In-Memory-Cache ermöglichen." +
        "__LINEBREAK__" +
        "\nDer größte Teil meines Codes läuft auf AWS, daher werde ich es zuerst dort ausprobieren." +
        "\nGibt es also eine Möglichkeit, günstige und horizontal skalierbare Node-Instanzen auf AWS zu haben?" +
        "\nIch versuchte, AWS Fargate zu verwenden, da es genau dafür gedacht ist, und die Migration meiner NodeJs-Lambda auf einen NodeJs-Server in Docker wäre einfach." +
        "__LINEBREAK__" +
        "\nDer Fargate-Cluster lief gut, und es gab nur ein Problem zu lösen: Wie ziele ich auf eine bestimmte Instanz ab?" +
        "\nDie Dokumentation besagte, dass ich die Fargate-Instanzen öffentlich machen könnte, aber das stellte sich als falsch heraus. Dann hieß es, ich könnte AWS CloudMap verwenden, um auf eine öffentliche IP zuzugreifen, aber es gibt nur eine private zurück." +
        "__LINEBREAK__" +
        "\nIch konnte nur auf den gesamten Fargate-Cluster abzielen, aber könnte ich Daten weitergeben, die es z.B. dem Load Balancer ermöglichen würden, eine bestimmte Instanz auszuwählen?" +
        "\nSticky Sessions ermöglichen es, die Verbindung zu einer bestimmten Instanz aufrechtzuerhalten, aber leider wird die erste Verbindung immer noch zufällig gewählt." +
        "\nFür ein Mehrspieler-Spiel benötige ich, dass Spieler desselben Spiels auf derselben Instanz landen." +
        "__LINEBREAK__" +
        "\nIch könnte dedizierte Server manuell und ohne Fargate skalieren, aber AWS ist verdammt teuer, und dann braucht man immer etwas Kostspieliges zusätzlich wie ein Nat Gateway, einen VPC Endpoint usw.",
    boxOfCardsV3SectionImageDescription_28: "Zurück zum einfacheren Leben",
    boxOfCardsV3SectionHeader_28: "Digital Ocean <3",
    boxOfCardsV3SectionDescription_28: "Moment, lief Box of Cards nicht schon in V1 auf Digital Ocean?" +
        "\nPsssst!" +
        "__LINEBREAK__" +
        "\nBox of Cards V1 lief bereits einigermaßen gut auf Digital Ocean mit Kubernetes, aber das verwendete keine dedizierten Server, sondern ein gemeinsames Redis." +
        "__LINEBREAK__" +
        "\nWarum wähle ich diesmal Digital Ocean?" +
        "\nDie Daten-Verkehrskosten und Nodes sind viel günstiger. Die Nodes können öffentlich sein, und ich brauche nicht: Load Balancer, Vpc Endpoint, Vpc Gateway, Nat Gateway." +
        "\nEs hat alles, was ich brauche, und eine wunderbare Benutzeroberfläche." +
        "__LINEBREAK__" +
        "\nAWS ist in Ordnung für größere Projekte und wenn man sich an die Kerndienste hält." +
        "\nEs muss ja einen Grund geben, warum ich mich durch die AWS Solution Architect Associate-Zertifizierung gequält habe!",
    boxOfCardsV3SectionImageDescription_29: "Alle im Web-Client verwendeten Technologien",
    boxOfCardsV3SectionHeader_29: "Web-Client-Technologie",
    boxOfCardsV3SectionDescription_29: "GraphQL ist nicht mehr Teil davon, aber ansonsten ist dies das Gleiche wie in V2.",
    boxOfCardsV3SectionImageDescription_30: "Technologien für die Bereitstellung des Web-Clients",
    boxOfCardsV3SectionHeader_30: "Web-Client-Bereitstellungstechnologie",
    boxOfCardsV3SectionDescription_30: "Ich habe die Bereitstellung des Web-Clients auf AWS S3 und die Generierung von Web-Zertifikaten mittels AWS Cloudformation automatisiert",
    boxOfCardsV3SectionImageDescription_31: "Technologien, die über Backend-Node hinweg geteilt werden",
    boxOfCardsV3SectionHeader_31: "Backend-Kerntechnologie",
    boxOfCardsV3SectionDescription_31: "Für weitere Informationen zu diesem Tech-Stack werfen Sie einen Blick auf mein Ts-Cluster-Projekt.",
    boxOfCardsV3SectionImageDescription_32: "AWS & Digital Ocean Komponenten",
    boxOfCardsV3SectionHeader_32: "Komponenten",
    boxOfCardsV3SectionDescription_32: "Dies ist auch sehr ähnlich zum Ts-Cluster-Projekt mit kleinen Ergänzungen." +
        "__LINEBREAK__" +
        "\nIch habe eine MongoDB-Instanz in den Registrar-Droplet integriert, um Decks & Benutzereinstellungen zu speichern." +
        "\nDer Registrar-Droplet hat standardmäßig viel ungenutzten Speicherplatz und benötigt nicht so viel RAM & CPU. Das funktioniert, weil nur der Registrar-Droplet eine Datenbank benötigt und der Web-Client Decks an die Websocket-Droplets weiterleitet." +
        "\nAutomatisierte MongoDB-Backups werden in Digital Ocean Spaces gespeichert und beim Start eines Registrars verwendet." +
        "__LINEBREAK__" +
        "\nDroplets werden mit Snapshots aus der Digital Ocean Registry gestartet." +
        "__LINEBREAK__" +
        "\nSchließlich verwaltet mein Registrar die horizontale Skalierung von Websocket-Droplets und erstellt/löscht DNS-Einträge für den dedizierten Serverzugriff über AWS Route 53." +
        "__LINEBREAK__" +
        "\nIch liebe die Digital Ocean API wirklich. Insgesamt gab es nur 2 kleine Probleme, und ich kann mich nicht einmal an sie erinnern.",
    boxOfCardsV3SectionImageDescription_33: "Alle Tests in Webstorm in einem Durchlauf",
    boxOfCardsV3SectionHeader_33: "Backend Tests",
    boxOfCardsV3SectionDescription_33: "Die Anwendung besitzt ausschließlich End-To-End Tests." +
        "\nDer großteil der internen Logik ist recht simpel und mich interessiert ob das Gesamtsystem wie erwartet funktioniert." +
        "\nDie Tests haben vor allem bei den Migrationen zwischen Technologien unheimlich geholfen.",
    boxOfCardsV3SectionImageDescription_34: "Als Entwickler benutze ich dieses Meme oft",
    boxOfCardsV3SectionHeader_34: "Spaß mit Axios",
    boxOfCardsV3SectionDescription_34: "Axios, ein Rückgrat des World Wide Web." +
        "__LINEBREAK__" +
        "\nDeshalb fühlt es sich lustig an, wenn du deine baseUrl wie 'https://boxof.cards' an eine Axios-Anfrage übergibst und Axios sie einfach mit 'http://localhost:8080' überschreibt." +
        "__LINEBREAK__" +
        "\nEs hat mich Stunden gekostet, den Code dahinter zu debuggen und zu verstehen. Es gibt mehrere Ebenen von Standardwerten für URLs, und es ignoriert einfach deinen Parameter." +
        "__LINEBREAK__" +
        "\nAll das wäre kein Problem, wenn man mit einem einzigen Server spricht und die Konstruktor-baseUrl verwendet, aber ich verwalte mehrere Websocket-Nodes." +
        "__LINEBREAK__" +
        "\nEs reicht auch nicht aus, den Quellcode einmal zu ändern, da dies Teil mehrerer generierter APIs ist, die meine Dienste miteinander verbinden." +
        "\nNach der API-Generierung wird daher ein Skript ausgeführt, um den problematischen Code in den generierten Dateien zu ersetzen.",
    boxOfCardsV3SectionImageDescription_35: "React Router, alles in Ordnung?",
    boxOfCardsV3SectionHeader_35: "Überall Major Updates",
    boxOfCardsV3SectionDescription_35: "Ich bin froh, dass sich das React-Ökosystem und Material UI verlangsamt haben." +
        "__LINEBREAK__" +
        "\nWährend der Entwicklung von Box of Cards habe ich zwei major Updates für die meisten Bibliotheken durchlaufen." +
        "\nNach meinem letzten Update war ich ziemlich überrascht, als react-router beschloss, eine wesentliche Funktion zu entfernen und keine Möglichkeit bot, sie zu ersetzen." +
        "\nWie habe ich das gelöst? Nun, ich habe es nicht. Nicht alles muss gelöst werden." +
        "__LINEBREAK__" +
        "\nIch könnte dutzende Stunden über die Entwicklung von Box of Cards sprechen. Melde dich bei mir, wenn dich etwas interessiert." +
        "__LINEBREAK__" +
        "\nDanke fürs Lesen. Viel spaß mit Box of Cards und hinterlass mit gerne Feedabck auf dem Discord Server.",

    // Ts-cluster
    tsClusterName: "TS-Cluster",

    tsClusterDescription: "Eine horizontale Cluster-Skalierung für dedizierte Server mit NestJs und Digital Ocean",
    tsClusterSubHeader: "Eine horizontale Cluster-Skalierung für dedizierte Server mit NestJs und Websockets.",
    tsClusterSectionImageDescription_01: "Verwendete Technologien (DrawIo)",
    tsClusterSectionHeader_01: "Tech Stack",
    tsClusterSectionDescription_01: "Alle Nodes basieren auf NestJs und damit auf NodeJs. Es ist in Typescript geschrieben und dockerized." +
        "\nFür die Kommunikation zwischen den Nodes (Registrar-Node, Websocket-Node, Test-Node) werden mit Swagger und Nest-OpenApi HTTP-Clients aus den Controller Klassen generiert." +
        "__LINEBREAK__" +
        "\nDie Erstellung und Löschung der Nodes erfolgt über Digital Ocean als Cloud-Provider. Meine Domains liegen in AWS und für HTTPS/SSL/CORS muss ich A-Records/Subdomains registrieren." +
        "\nAlso erstelle ich nach dem Hochfahren eines Digital Ocean Droplet auch einen A-Record für eine subdomain mit der IP des Droplets." +
        "__LINEBREAK__" +
        "\nAber warum das Ganze? Ich brauche für andere Projekte eine horizontale Cluster-Skalierung mit dedizierten Servern." +
        "\nDas gibt es doch bestimmt schon? Dachte ich auch, aber ich habe diverse Cloud-Anbieter durchprobiert. Viele bieten nur an, dass du eine beliebige Node zurückbekommst. Sticky Sessions für einen Load Balancer garantieren nur, dass du nach der Verbindung die gleiche Node zugewiesen bekommst." +
        "__LINEBREAK__" +
        "\nFür Mehrspieler-Spiele möchte ich aber In-Memory-Cache verwenden und muss daher garantieren, dass alle Nutzer sich mit der gleichen Node verbinden." +
        "\nIch habe z. B. viel mit spezialisierten Services, Kubernetes, AWS Fargate mit AWS CloudMap ausprobiert und in der Dokumentation wird behauptet, dass dedizierte Zugriffe möglich sind, aber dies konnte ich nicht bestätigen." +
        "__LINEBREAK__" +
        "\nEs gibt dann einige Services und vor allem einige große Umwege, mit denen so etwas möglich wäre, aber die Kosten sind mindestens 5 - 20 Mal höher für die gleichen Ressourcen." +
        "\nAlso habe ich eine Cluster-Skalierung prototyped und anschließend mit diesem Projekt umgesetzt.",
    tsClusterSectionImageDescription_02: "Backend Komponentendiagramm (DrawIo)",
    tsClusterSectionHeader_02: "Komponenten",
    tsClusterSectionDescription_02: "Meine Domains und meine Webseiten liegen derzeitig in AWS und meine Deployments dorthin erfolgen mit AWS-Cloudformation." +
        "\nFür die Digital Ocean Cluster-Skalierung verwende ich das NPM-Paket 'do-wrapper'. Viele Funktionalitäten sind abgebildet aber einige habe ich dann doch mit Axios nachgefügt." +
        "\nIch fahre den Registrar-Droplet hoch und weil noch keine Websocket-Droplets existieren, wird direkt einer hochgefahren." +
        "__LINEBREAK__" +
        "\nDer Endnutzer lädt den Webclient herunter und dieser wird dann den Registrar-Droplet Endpunkt https://registrarnode1@mydomain.de/get-websocket-url anfragen und eine URL für den Websocket-Droplet zurückbekommen." +
        "\nJe nach Auslastung kann das dann websocketnode1, websocketnode2, etc. sein." +
        "__LINEBREAK__" +
        "\nDerzeitig werden Droplets nur heruntergefahren, wenn keine aktiven Sessions mehr auf ihnen vorhanden sind und mindestens ein anderer Droplet unterlastet ist." +
        "\nEin neuer Droplet wird hingegen gestartet, wenn alle Droplets überlastet sind. Es gibt ein Websocket-Droplet-Minimum von 1 und ein absolutes Maximum von X, um nicht über Nacht bankrott zu gehen.",
    tsClusterSectionImageDescription_03: "Ordnerstruktur (Webstorm)",
    tsClusterSectionHeader_03: "Ordnerstruktur",
    tsClusterSectionDescription_03: "Das Projekt besteht aus mehreren NestJs Anwendungen, die mit 'node' enden. Hinzu kommt ein Ordner mit Deployment Skripten." +
        "\nIn '_common' liegt der Code, den sich alle Wendungen teilen, wie z. B. array- & string Utility-Funktionen." +
        "\nIn '_shared' liegen generierte APIs, Models und Typen." +
        "\nDer Ordner 'certificates' enthält Wildcard-Zertifikate, die ich fürs HTTPS/CORS in den nestJs Anwendungen verwende." +
        "\nUnd '_test' enthält Tests für jede Node und zwischen den Nodes. Die '.env.*' Dateien enthalten Umgebungsvariablen für unterschiedliche Deployments & Tests.",
    tsClusterSectionImageDescription_04: "UI Digital Ocean Container Registry",
    tsClusterSectionHeader_04: "Docker Images",
    tsClusterSectionDescription_04: "Die Digital-Ocean Droplets müssen ihre Docker-Images von irgendwo ziehen, und daher lager ich diese auch in Digital Ocean." +
        "\nDie NestJs Anwendungen werden im 1. Schritt ihrer Dockerfile kompiliert und nur die kompilierten Anwendungen werden in den 2. Schritt übertragen." +
        "\nSo werden unnötige Dateien minimiert und nur notwendige Dateien wie die fertige Anwendung und Zertifikate werden kopiert." +
        "\nIch brauche Anwendungen für unterschiedliche Tests, und daher gibt es z. B. das Registrar-Image für beta und dev.",
    tsClusterSectionImageDescription_05: "UI Digital Ocean Snapshots",
    tsClusterSectionHeader_05: "Droplet Snapshots",
    tsClusterSectionDescription_05: "Digital Ocean bietet es an, exakte Kopien von aktiven Droplets zu machen. Diese ermöglichen ein schnelleres Hochfahren von z. B. neuen Websocket-Droplets, da das Setup des Debian OS bereits abgeschlossen ist." +
        "\nDies inkludiert: Docker installieren, Images ziehen, SSL initialisieren, unnötige Systemprozesse stoppen und Systempakete deinstallieren, etc.." +
        "__LINEBREAK__" +
        "\nTipp: Beim Erstellen eines Snapshots sollten keine Docker-Container aktiv sein, da diese sonst gestoppt werden und beim Starten des Droplets dann bereits der Name des Docker-Containers vergeben ist." +
        "\nAuch alle Logs werden nahtlos mitübernommen und ich dachte eine ganze Weile, dass mein Snapshot einen fehlgeschlagenen Container hätte." +
        "\nTldr: Container sollten erst im Snapshot gestartet werden.",
    tsClusterSectionImageDescription_06: "UI Domains in AWS Route53",
    tsClusterSectionHeader_06: "Domains",
    tsClusterSectionDescription_06: "Das sind die Subdomains, die beim Hochfahren des Clusters erstellt werden." +
        "\nIn diesem Fall sind die Subdomains für einen Test, der Sessions erstellt hat, bis 3 Websocket-Nodes aktiv waren, und anschließend wurden Sessions auf websocketnode2 beendet, bis dieser Droplet heruntergefahren und die Subdomain gelöscht wurde." +
        "\nJeder Domain-Provider mit einer guten API ist ausreichend hierfür.",
    tsClusterSectionImageDescription_07: "Tests (Webstorm)",
    tsClusterSectionHeader_07: "Tests",
    tsClusterSectionDescription_07: "Lokal wird mit Jest getestet, ob z. B. eine Registrar-Node Websocket-Nodes über die Digital Ocean API startet." +
        "\nHierfür werden Endpunkte mit Nock gemockt und Endpunkte werden durch die .env.* Dateien bestimmt." +
        "__LINEBREAK__" +
        "\nZusätzlich gibt es Tests, die direkt die Digital Ocean Cloud ansprechen. Diese Tests können 5-15 Minuten brauchen, da mehrere Droplets durch Snapshots hoch und heruntergefahren werden." +
        "\nManchmal schlägt ein Test wegen des Cachings von IP-Adressen auf meinem lokalen Betriebssystem fehl." +
        "\nDie Subdomains werden während der Tests häufig neu zugewiesen, und dies ist kein Verhalten, das im Live-Betrieb auftreten wird.",
    tsClusterSectionImageDescription_08: "UI Digital Ocean Droplets",
    tsClusterSectionHeader_08: "Droplets",
    tsClusterSectionDescription_08: "Registrar-Droplets und Websocket-Droplets brauchen einander und sind nicht alleinstehend in einer Cloud-Live-Umgebung testbar." +
        "\nDaher habe ich noch zusätzliche Test-Droplets mit denen ich einfachere Tests laufen lassen kann.",
    tsClusterSectionImageDescription_09: "",
    tsClusterSectionHeader_09: "Fazit",
    tsClusterSectionDescription_09: "Auf niedrigster Skalierung habe ich einen Registrar-Droplet und einen Websocket-Droplet. Zusammen mit Snapshot & Image Registry zahle ich weniger als 10 € im Monat für die Minimalauslastung." +
        "\nJedoch bleibt da auch nicht mehr viel RAM für aktive Sessions über. Von dem 500 MB RAM sind schon 400 - 450 von OS, Docker und dem NestJs Docker Container verbraucht." +
        "\nIch lasse die Anwendung also direkt mit 1 GB RAM laufen und erhöhe den Wert, sobald es Sinn ergibt." +
        "__LINEBREAK__" +
        "\nAuf vertikale Skalierungen verzichte ich erstmal, da ich mit diesem Projekt direktere Erfahrungen mit horizontalen Skalierungen sammeln möchte." +
        "\nMigrationen von Sessions würde ich später gerne angehen. Damit kann ich Droplets früher herunterfahren und Ressourcen effizienter verwalten." +
        "__LINEBREAK__" +
        "\nAber erstmal bin ich sehr zufrieden mit dem Projekt. Ich freue mich darauf, es zeitnah auf Box of Cards anwenden zu können.",

    // BoxOfCards V2
    boxOfCardsV2Name: "Box of Cards V2",
    boxOfCardsV2Description: "Miration eines Kartenspiels zu Serverless",
    boxOfCardsV2SubHeader: "Migration eines Kartenspiels zu AWS Serverless. Für mehr Infos zur Spielidee siehe V1 und V3.",
    boxOfCardsV2LandingPageImageDescription: "Startseite",
    boxOfCardsV2CardTutorialImageDescription: "Tutorial",
    boxOfCardsV2ComponentsImageDescription: "Architektur",

    boxOfCardsV2SectionImageDescription_01: "Box of Cards Startseite",
    boxOfCardsV2SectionHeader_01: "Warum V2?",
    boxOfCardsV2SectionDescription_01:
        "Die vorangegangene Version lief mit Kubernetes und einem Redis Cluster." +
        "__LINEBREAK__" +
        "\nWährend das System in Testdurchläufen funktionierte, ergaben Lastentests, dass die Synchronisation der Nodes über Redis einen Flaschenhals darstellt." +
        "\nTrotz automatischer Deployments erwiesen sich auch die Wartung und vor allem das Logging als noch nicht ausreichend." +
        "__LINEBREAK__" +
        "\nBeruflich stand ein Projekt mit Migrationsanteilen nach AWS Serverless an und so entschied ich mich, dies an Box of Cards zu testen." +
        "__LINEBREAK__" +
        "\nDies ist möglich, da das Kartenspiel keine schnelle Latenzen benötigt und auch mit gelegentlichen Cold-Starts zurechtkommt." +
        "\nErste Berechnungen ergaben, dass AWS serverless kostenmäßig aufgehen müsste, wobei die korrekte Parameterisierung schwer abzuschätzen ist." +
        "\nZusätzliche Erkenntnisse hierzu später.",
    boxOfCardsV2SectionImageDescription_02: "Tutorial der Startseite",
    boxOfCardsV2SectionHeader_02: "Kurzes Tutorial",
    boxOfCardsV2SectionDescription_02:
        "Auf der Startseite und einigen anderen Seiten ist nun ein interaktives Tutorial." +
        "\nAus zwei Antworten kann eine in den Satz eingefügt werden. Wörter in der ersten Antwort sind austauschbar.",
    boxOfCardsV2SectionImageDescription_03: "Verwende Technologien (DrawIo)",
    boxOfCardsV2SectionHeader_03: "Tech Stack",
    boxOfCardsV2SectionDescription_03: "Die  verwendeten Technologien haben sich stark zu V1 verändert." +
        "\nDer Code ließ sich leicht nach AWS Lambda migrieren. Ich habe mich bei der backend-API zunächst für AppSync (mit Apollo und GraphQL) entschieden, weil es Websocket-Subscriptions ermöglicht." +
        "Erst später merkte ich, das diese Subscriptions nur auf ihr eigenes Topic reagieren können. Zudem wird kein MQTT-Protokoll unterstützt." +
        "\nDeswegen benötige ich nun ein Websocket Api Gateway, dass Websocket-Verbindungen aufrechterhält und Lambdas auslöst." +
        "__LINEBREAK__" +
        "\nProblematisch ist, dass dieses Gateway und die Sockets keinerlei Cache bereitstellen und alle Verknüpfungen von socketID zu userID in der DynamoDB persistiert werden müssen." +
        "\nAuch der Lambda Cache wäre nicht geeignet. Ich habe viele Lösungsansätze probiert, aber letztendlich bleiben erhöhte DynamoDB Kosten." +
        "\nDies ist besonders ärgerlich, da stets mindestens 1KB berechnet wird, auch wenn ich nur ein paar Bytes lese." +
        "__LINEBREAK__" +
        "\nFür die Authentifizierung hab ich mich von Google-Firestore gelöst und einiges ausprobiert." +
        "\nAWS Cognito ist ausgeschieden, da es Kompatibilitätsprobleme mit AWS Cloudformation hat und das Einrichten von OAuth ein Alptraum war." +
        "\nAnschließend habe ich Keycloak ausprobiert und obwohl ich ein großer Fan der Oberfläche und Dokumentation bin, so bleibt es Overkill für meine Anwendungszwecke." +
        "\nNun gibt es einen 3rd-Party Login über Discord und später folgen dann noch andere." +
        "__LINEBREAK__" +
        "\nDer Rest lief hingegen sehr gut. Die Webseite liegt im S3. GameStates und Decks werden in DynamoDB persistiert." +
        "\nDie komplette Anwendung wird mit AWS Cdk (Cloudformation) deployed. Es gibt einen AWS-Root-Account mit Domains und Berechtigungen und darunter 3 Accounts für dev, beta und live." +
        "__LINEBREAK__" +
        "\nAlle Tests sind Jest End-to-End Tests auf einer dev-Umgebung. Auf der beta-Umgebung teste ich mit Freunden." +
        "\nChatGPT spart inzwischen gut Zeit beim Testschreiben und Fehleranalysieren.",
    boxOfCardsV2SectionImageDescription_04: "Backend Komponentendiagramm (DrawIo)",
    boxOfCardsV2SectionHeader_04: "Komponenten",
    boxOfCardsV2SectionDescription_04: "Als Entwickler kann ich mit einem Befehl alle Stacks und Testdaten mit Cloudformation deployen." +
        "\nAls Endnutzer rufe ich die Domain auf und durch die in Route 53 hinterlegten DNS-Einträge findet eine Auflösung nach Cloudfront statt." +
        " Cloudfront leitet dann an den S3 weiter, in dem die statische Webanwendung liegt. Cloudfront gibt zumeist die nun heruntergeladene Webseite greift für das Backend nun wieder auf AWS Route53 Einträge und Cloudfront zu, wird aber für Websockets an das AWS Api-Gateway und für HTTP-Anfragen an AWS AppSync weitergeleitet." +
        "\nCaching in Cloudfront verkürzt diese Wege." +
        "__LINEBREAK__" +
        "\nAls Entwickler greife ich zumeist nur auf Cloudformation für das Deployment, sowie Cloudwatch für Logging und Alerts zu." +
        "\nGelegentlich schaue ich mir beim Debuggen noch Daten in der DynamoDB an.",
    boxOfCardsV2SectionImageDescription_05: "Startseite im neueren Design",
    boxOfCardsV2SectionHeader_05: "UI Anpassungen",
    boxOfCardsV2SectionDescription_05: "Das ursprüngliche Design fühlte sich noch nicht gepolisht an und so habe ich noch weitere Styles ausprobiert." +
        "\nDurch Drop-Shadows lassen sich schöne Pop-Effekte erzeugen und diese werden nun auf viele interaktive Elemente angewendet." +
        "\nDie Responsiveness macht auf sehr geringen Auflösungen wie 300 x 640 noch Probleme, und daher passe ich einige UI-Layouts an." +
        "\nWie auch in diesem Beispiel helfen Tabs, ungemein sichtbare Elemente zu reduzieren.",
    boxOfCardsV2SectionImageDescription_06: "Spiellobby in der Überarbeitung",
    boxOfCardsV2SectionHeader_06: "UI - Work in Progress",
    boxOfCardsV2SectionDescription_06: "So sieht es zeitweise nunmal aus wenn Kernkomponenten überarbeitet wurden aber andere Komponenten noch nicht aktualisiert sind.",
    boxOfCardsV2SectionImageDescription_07: "Spiellobby nach der Überarbeitung",
    boxOfCardsV2SectionHeader_07: "UI - Work after Progress",
    boxOfCardsV2SectionDescription_07: "So sieht es dann aus, wenn die GameLobby Komponente aufgeräumt wurde. Sie ist noch nicht final, aber definitiv besser als vorher.",
    boxOfCardsV2SectionImageDescription_08: "Aktives Spiel in mobiler Ansicht",
    boxOfCardsV2SectionHeader_08: "Herausforderung Responsiveness",
    boxOfCardsV2SectionDescription_08: "Auf der Spieleseite gibt es viele Tabs, und diese in mehreren Reihen anzuzeigen, sieht nicht gut aus und macht auch mit der Maximalhöhe Probleme." +
        "\nDaher wird hier eine Menü verwendet, um Tabs auf schmalen Bildschirmbreiten zusammenzufassen.",
    boxOfCardsV2SectionImageDescription_09: "Aktives Testspiel in Desktop Ansicht",
    boxOfCardsV2SectionHeader_09: "Historie und Layout Tests",
    boxOfCardsV2SectionDescription_09: "Im History Tab können die besten Karten der letzten Runden eingesehen werden." +
        "\nZunächst habe ich Grids verwendet, aber die waren nicht flexibel genug. Also bin ich auf Flex-Boxen umgestiegen.",
    boxOfCardsV2SectionImageDescription_10: "Aktives Testspiel mit langen Texten",
    boxOfCardsV2SectionHeader_10: "Responsiveness to the limit!",
    boxOfCardsV2SectionDescription_10: "Zunächst hatte ich scrollbare Karten aber da Karten selber in einem scrollbaren Container sind, macht dies die Bedienung fehleranfällig." +
        "\nNun haben Karten eine Minimalgröße und skalieren mit ihrem Inhalt in der Höhe. Dies sorgt dafür, dass Flex-Box allein nicht mehr ausreichend ist, da die Reihengröße sich am größten Element orientieren muss." +
        "\nGamestate-abhängig wird auch dem oberen oder unteren Karten-Container mehr Höhe zugesprochen. In diesem GameState soll der Gewinner ausgewählt werden, also hat der obere Container mehr Höhe verfügbar." +
        "\nDie Resthöhe oder Minimalhöhe geht an den unteren Container.",
    boxOfCardsV2SectionImageDescription_11: "Dynamische Fenstergrößen für aktives Spiel",
    boxOfCardsV2SectionHeader_11: "Responsiveness in action",
    boxOfCardsV2SectionDescription_11: "Das responsive Verhalten wird durch eine Vielzahl an Designentscheidungen ermöglicht." +
        "\nDas Auslagern von Elementen in Tabs, das Ausblenden von dem Tab-Container, das Zusammenfassen der Navbar Elemente in ein Burger-Menü und das flex-Verhalten der Karten Container." +
        "\nVor allem in den Karten-Containern steckt inzwischen sehr viel Logik, da CSS dieses Level an Responsiveness nicht ermöglicht." +
        "\nDas Problem besteht darin, dass vorab nicht bekannt ist, wie viel Platz ein Text benötigt und wie viele Zeilenumbrüche und somit Textreihen es gibt." +
        "__LINEBREAK__" +
        "\nIch lasse mir nach dem Rendern der Elemente die Maße der Container ausgeben und benutze dann die Fenstergrößen, Kartengrößen und welcher Karten-Container Vorang hat, um das optimale Layout zu bestimmen." +
        "\nAuch wenn an einigen Stellen 5 Karten nebeneinander passen würden, so zeige ich sie lieber in 2 Reihen an." +
        "\nAll dies kann für ein minimales Flickern sorgen, da es 2 Renderings benötigt und Höhen sich ändern, aber ohne einen komplett eigenen Text-Renderer zu schreiben, geht es nicht besser." +
        "__LINEBREAK__" +
        "\nIch finde es hübsch.",
    boxOfCardsV2SectionImageDescription_12: "Chat und Avatare in Spiellobby",
    boxOfCardsV2SectionHeader_12: "Avatare",
    boxOfCardsV2SectionDescription_12: "Alleinstehende Namen sind ziemlich langweilig und längere Namen muss ich für die Responsiveness abkürzen." +
        "\nZudem benötige ich platzsparende Buttons zum Entfernen der Spieler und einen Ort, an den ich spielerbezogene Info Icons anzeigen kann." +
        "__LINEBREAK__" +
        "\nAvatar-Buttons sind hier die optimale Lösung. Ich kann anzeigen: ist Host, ist Kartinal, ist bereit, wird erwartet und ist rauswerfbar.",
    boxOfCardsV2SectionImageDescription_13: "KI Spieler und Dark Modein aktivem Spiel",
    boxOfCardsV2SectionHeader_13: "KI-Spieler",
    boxOfCardsV2SectionDescription_13: "KI-Spieler sehen alle aus wie Roboter und sind Dank hervoragender KI mindestens so lustig wie echte Spieler." +
        "\nEs wäre schön, wenn sie Antwortkarten syntaktisch korrekt an den Satz anpassen könnten, aber es gibt noch keine preiswerten APIs oder gute Open-Source-Lösungen hierfür." +
        "__LINEBREAK__" +
        "\nKIs können jederzeit hinzugefügt oder entfernt werden und der Gamestate repariert sich selber, indem rückwirkend Entscheidungen getroffen werden." +
        "\nIch habe sie primär hinzugefügt, weil das Testen mit 2 Browserfenstern mühselig ist." +
        "__LINEBREAK__" +
        "\nDer Darkmode ist nun auch integriert.",
    boxOfCardsV2SectionImageDescription_14: "Backend Skripte in package.json",
    boxOfCardsV2SectionHeader_14: "Backend Skripte",
    boxOfCardsV2SectionDescription_14: "Ich habe all meine Skripte gerne an einem Ort; in diesem Fall in der package.json." +
        "\nEs gibt inzwischen Tools, die solche Skripte besser abstrahieren, aber bis jetzt hat mir noch keines gut gefallen." +
        "\nDies sind großteils Deployment-Skripte für das Backend und die Webanwendung. Durch die unterschiedlichen Laufzeitumgebungen sind es soviele Skripte.",
    boxOfCardsV2SectionImageDescription_15: "AWS Lambda Concurrency UI",
    boxOfCardsV2SectionHeader_15: "Lambda Quota",
    boxOfCardsV2SectionDescription_15: "Per Default können nur 10 Lambdas parallel laufen. Das fiel mir auf, weil meine End-to-End Tests irgendwann willkürlich fehlschlugen." +
        " Erhöhungen müssen mit längeren Wartezeiten angefragt werden.",
    boxOfCardsV2SectionImageDescription_16: "Todos für jest Backend Tests",
    boxOfCardsV2SectionHeader_16: "Noch mehr Tests",
    boxOfCardsV2SectionDescription_16: "Ich kann kaum ausdrücken, wie viel Zeit mir meine Tests erspart haben." +
        "\nIch habe mir Funktionen geschrieben, die mir meinen GameState in einen bestimmten Zustand bringen, damit ich ihn dann gezielt laufen lassen kann. Dies reduziert meine Testgrößen enorm." +
        "\nAlle Objekte und ihre Felder basieren auf Indices wie: userName1, userName2, etc.. Hierdurch kann ich alles beliebig skaliert abtesten." +
        "__LINEBREAK__" +
        "\nDarauf aufbauend gibt es Funktionen, die mir ein Spiel erstellen,  Spieler hinzufügen, das Spiel starten und einen bestimmten Gamestate erreichen." +
        "\nDadurch kann der Test sich darauf fokussieren, z. B. die Auswahl einer Handkarte und den Übergang in den nächsten Gamestate zu testen.",
    boxOfCardsV2SectionImageDescription_17: "Ein mit Antworten gefüllter Satz",
    boxOfCardsV2SectionHeader_17: "Bugs",
    boxOfCardsV2SectionDescription_17: "Es gibt sehr viele sehr unterhaltsame Bugs. Hier wurde stets die erste Antwort für alle Felder ausgewählt.",
    boxOfCardsV2SectionImageDescription_18: "Kollage der meisten Test Suit Ausgaben",
    boxOfCardsV2SectionHeader_18: "Viele, viele Tests",
    boxOfCardsV2SectionDescription_18: "Es sind inzwischen tausende Tests, und wenn ich alle auf einmal durchlaufen lassen, gibt es doch eine handvoll, die fehlschlagen." +
        "\nZwei Tests räumen entweder nicht ausreichend oder nicht rechtzeitig auf, und dadurch schlagen nachfolgende Tests fehl, die dann aber wieder gut aufräumen." +
        "\nEinzeln funktionieren die Tests einwandfrei und es stehen zumindest Todos dran.",
    boxOfCardsV2SectionImageDescription_19: "AWS Cloudformation UI des Spiel Objektes",
    boxOfCardsV2SectionHeader_19: "Cloudformation UI",
    boxOfCardsV2SectionDescription_19: "So sieht die Anwendung im AWS-UI für Cloudformation aus.",
    boxOfCardsV2SectionImageDescription_20: "AWS DynamoDB UI ein",
    boxOfCardsV2SectionHeader_20: "DynamoDB UI",
    boxOfCardsV2SectionDescription_20: "Objekte interaktiv analysieren zu können, hat sehr geholfen beim Debuggen der Fehler." +
        "\nIch bin dennoch nicht überzeugt von DymamoDb an sich. Die Syntax ist fehleranfällig und die verfügbaren Clients für DynamoDB machen es weder einfacher noch sicherer.",
    boxOfCardsV2SectionHeader_21: "Fazit",
    boxOfCardsV2SectionDescription_21: "Serverless ist eine wundervolle Technologie, aber aufgrund der Art, wie es von AWS angeboten wird, ist es nur begrenzt für meinen Anwendungsfall geeignet." +
        " Oft bin ich in einer Sackgasse gelandet, weil ein essentielles AWS Feature noch ein offenes Ticket aus dem Jahr 2018 hat." +
        "\nDies nimmt so abstruse Ausmaße an, dass die Community Appsync und Apollo in AWS Lambda nachgebaut hat." +
        "\nDie Kern Services wie AWS S3, DynamoDb, Lambda Cloudfront, Route53 funktionieren gut. Viele andere Services werde ich meiden." +
        "__LINEBREAK__" +
        "Gerade größere Anwendungen werde ich zukünftig nicht mehr Serverless abgehen." +
        "Ich freue mich darauf wieder etwas mit dedizierten Servern und In-Memory-Caches zu bauen. Ein Projekt, das mich weniger an Cloud-Anbieter mit proprietären Lösungen bindet.",

    // BoxOfCards V1
    boxOfCardsV1Name: "Box of Cards V1",
    boxOfCardsV1SubHeader: "Ein Gesellschafts- und Kartenspiel im Web mit Kubernetes",
    boxOfCardsV1LandingPageImageDescription: "Startseite",
    boxOfCardsV1DeckSelectionImageDescription: "Deckauswahl",
    boxOfCardsV1DeckEditorImageDescription: "Deck Bearbeitung",
    boxOfCardsV1MultiplayerLobbyImageDescription: "Mehrspielerlobby",
    boxOfCardsV1GameLobbyImageDescription: "Spiellobby",
    boxOfCardsV1WebAppImageDescription: "Aktives Spiel",
    boxOfCardsV1ComponentsAllImageDescription: "Architektur",
    boxOfCardsV1ComponentWebAppImageDescription: "Web-App bereitstellen",
    boxOfCardsV1ComponentBackendWebAppImageDescription: "Backend Architektur",
    boxOfCardsV1ComponentRedisImageDescription: "Redis Architektur",
    boxOfCardsV1ComponentRabbitMqDescription: "RabbitMq Architektur",
    boxOfCardsV1ComponentGoogleCloudImageDescription: "Google Cloud Authentifizierung",
    boxOfCardsV1ComponentKubeCtlGetAllImageDescription: "Cluster Übersicht im terminal",
    boxOfCardsV1ComponentDigitalOceanKubernetesImageDescription: "Cluster Übersicht in Digital Ocean",
    boxOfCardsV1WebClientImageDescription: "Web-App Architektur",
    boxOfCardsV1BackendServicesImageDescription: "Backend-Dienst Architektur",
    boxOfCardsV1PackagesImageDescription: "Backend Pakete",
    boxOfCardsV1GoogleCloudFunctionsImageDescription: "Google Cloud Pakete",
    boxOfCardsV1RabbitMqImageDescription: "RabbitMq Konfiguration",
    boxOfCardsV1GitWorkflowImageDescription: "Github Actions",
    boxOfCardsV1ShellScriptImageDescription: "Deployment Scripte verwalten",
    boxOfCardsV1GameTestsImageDescription: "Erfolgreiche Tests",
    boxOfCardsV1TimeoutHandlerImageDescription: "Beispiel Test Ausgabe",
    boxOfCardsV1OldDesign1ImageDescription: "1. Design für aktives Spiel",
    boxOfCardsV1OldDesign2ImageDescription: "2. Design für aktives Spiel",
    boxOfCardsV1FirstLandingPageImageDescription: "1. Design für Startseite",
    boxOfCardsV1SecondLandingPageImageDescription: "2. Design für Startseite",
    boxOfCardsV1LoginDesignsImageDescription: "Iterative Design-Phase",
    boxOfCardsV1LogoAttemptImageDescription: "2. Logo Design",
    boxOfCardsV1LandingPageDesignsImageDescription: "3. Logo Design",
    boxOfCardsV1GameDesign1ImageDescription: "3. Design für aktives Spiel",
    boxOfCardsV1PeopleChooseFontImageDescription: "Iteratives Font testen",
    boxOfCardsV1FontNoUmlautsImageDescription: "Font Bearbeitung",
    boxOfCardsV1FontDoesNotLikeBordersImageDescription: "Problematische Font Borders",
    boxOfCardsV1ColorDifferenceOfMyMonitorsImageDescription: "Bildschirm Farbabweichung",
    boxOfCardsV1ObstacleTypesImageDescription: "Test Fehlschlag",
    boxOfCardsV1ObstaclesZeitplanungImageDescription: "Komedische Zwischeneinlage",
    boxOfCardsV1Description:
        "Ein anpassbares Kartenspiel zum Erzählen von Geschichten mit Freunden und sehr viel Overengineering",
    boxOfCardsV1WebappSectionHeader_01: "Vor einer langen Zeit",
    boxOfCardsV1WebappSectionDescription_01:
        "Dies ist eine der ersten Startseiten und viel hat sich seither verändert. Siehe V2 und V3 für Neuerungen.",
    boxOfCardsV1WebappSectionHeader_02: "Deck Auswahl",
    boxOfCardsV1WebappSectionDescription_02:
        "Der Host kann entscheiden, ob er ein oder mehrere Decks für das Spiel verwenden möchte.",
    boxOfCardsV1WebappSectionHeader_03: "Decks erstellen",
    boxOfCardsV1WebappSectionDescription_03:
        "Spieler können ihre eigenen Decks erstellen und direkt testen." +
        "\nDie Sätze enthalten Antwortplatzhalter durch '_'." +
        "\nAntworten können austauschbare Wörter haben, indem diese Wörter komma-getrennt in eckige Klammern [eins, zwei] gesetzt werden.",
    boxOfCardsV1WebappSectionHeader_04: "Mehrspieler-Lobby",
    boxOfCardsV1WebappSectionDescription_04:
        "Öffentliche Spiele können von jedem eingesehen werden." +
        "\nIch gebe zu, dass ich bei der Wahl der Testnamen faul war.",
    boxOfCardsV1WebappSectionHeader_05: "Spiel-Lobby",
    boxOfCardsV1WebappSectionDescription_05:
        "Der Host kann die Spieleinstellungen in der Spiel-Lobby festlegen." +
        "\nAußerdem bestätigt er beitretende Spieler." +
        "\nSobald alle Spieler bereit sind, kann das Spiel beginnen.",
    boxOfCardsV1WebappSectionHeader_06: "Spiel",
    boxOfCardsV1WebappSectionDescription_06:
        "Basierend auf den Einstellungen wird ein Satz ausgewählt und die Spieler reichen ihre Antworten zur Abstimmung ein." +
        "\nIn diesem Bild können bis zu zwei Antworten eingereicht werden." +
        "\nEs wurde bereits eine Runde gespielt und haben daher eine abgeschlossene Karte in ihrer Historie am oberen Bildrand.",
    boxOfCardsV1ArchitectureSectionHeader_00: "Overengineering",
    boxOfCardsV1ArchitectureSectionDescription_00:
        "Ich habe dieses Projekt begonnen, weil ich viele, neue Technologien ausprobieren wollte." +
        "\nAll das hätte man auch mit einem Express-Server auf einem Raspberry Pi machen können." +
        "\nEin weiser Mensch sagte einst:" +
        "\nGib einem Mann einen Fisch und er isst für einen Tag." +
        "\nGib einem Mann eine Fischereiboot-Industrie und er wird nie wieder einen Fisch sehen.",
    boxOfCardsV1ArchitectureSectionHeader_01: "Komponenten",
    boxOfCardsV1ArchitectureSectionDescription_01:
        "Was habe ich nun gewählt, wenn ein node.js-Server ausgereicht hätte?" +
        "\nWie wäre es mit einem Kubernetes-Cluster mit Microservices!" +
        "\nUnd wie funktioniert das Ganze?" +
        "\nFunktioniert das Ganze?" +
        "\nFinden wir es heraus!",
    boxOfCardsV1ArchitectureSectionHeader_02: "Web Client",
    boxOfCardsV1ArchitectureSectionDescription_02:
        "Der Web-Client wird kompiliert und anschließend von einem express-Server bereitgestellt." +
        "\nDer express Server wird in einem Docker-Container ausgeführt." +
        "\nUnd der Docker Container wird durch ein Kubernetes Deployment .... deployed." +
        "\nZuletzt verweist die Domain auf einen Load-Balancer-Service, der auf den Express-Server verweist.",
    boxOfCardsV1ArchitectureSectionHeader_03: "Backend-Dienste",
    boxOfCardsV1ArchitectureSectionDescription_03:
        "Drei Dienste verwalten die Mehrspieler-Logik." +
        "\nDie Mehrspieler-Lobby informiert über offene Spiel-Lobbies." +
        "\nDie Spiel-Lobby verwaltet... die Spiel-Lobby." +
        "\nSobald der Host auf den Start in der GameLobby klickt, migrieren alle Spieler auf einen Spiel-Server",
    boxOfCardsV1ArchitectureSectionHeader_04: "Redis Cluster",
    boxOfCardsV1ArchitectureSectionDescription_04:
        "Redis wird zum Cachen von Daten verwendet, die für diese Backend-Dienste benötigt werden." +
        "\nZum Beispiel speichert es, welcher Spieler welchem Spiel oder welcher GameLobby zugeordnet sind." +
        "\nDies verhindert, dass Spieler in mehreren Spielen sind oder sich nicht wieder verbinden können.",
    boxOfCardsV1ArchitectureSectionHeader_05: "RabbitMq Broker",
    boxOfCardsV1ArchitectureSectionDescription_05:
        "Der Broker ermöglicht es, Client-Sitzungen lose mit Backend-Diensten zu koppeln und so Skalierung zu ermöglichen." +
        "\nWenn sich ein Client über die Domain verbindet, muss er Websockets (WebStomp-Protokoll) verwenden, weil wegen Browser-Limitierungen und so." +
        "\nDie Backend-Dienste sind Express-Server und verwenden daher das AMQP-Protokoll.",
    boxOfCardsV1ArchitectureSectionHeader_06: "Google Cloud",
    boxOfCardsV1ArchitectureSectionDescription_06:
        "Warum um alles in der Welt verwende ich zusätzlich zu Kubernetes auch noch eine Google Cloud?" +
        "\nNun, mein ursprünglicher Plan war es, Firebase zu verwenden, um den Gamestate zu verwalten, aber meine Berechnungen führten zu meinem Bankrott." +
        "\nIch verwende aber immer noch Google Cloud Funktionen um Authentifizierungen zu verwalten und Decks zu speichern." +
        "\nEs ist nicht nötig, die Authentifizierung selbst zu implementieren." +
        "\nCloud Functions sind Spitze!",
    boxOfCardsV1ArchitectureSectionHeader_07: "Mein Cluster im Überblick",
    boxOfCardsV1ArchitectureSectionDescription_07:
        "Dies sind alle Dienste und Konfigurationsdateien meines laufenden Clusters, obwohl einige, persistente Volumes nicht angezeigt werden." +
        "\nEs gibt nur einen Pod von jedem Dienst, da ich den günstigsten verfügbaren Node-Plan verwende." +
        "\nWarum die Neustarts? Der Broker braucht einige Zeit, um hochzufahren, und ich muss noch Readiness-Probes hinzufügen.",
    boxOfCardsV1ArchitectureSectionHeader_08: "Digital Ocean Dashboard",
    boxOfCardsV1ArchitectureSectionDescription_08:
        "Nichts Ausgefallenes, nur mein Cluster und die beiden Load-Balancer, die auf ihn zeigen." +
        "\nEiner für den Abruf des Webclients und einer für den Zugriff auf den Broker für die Mehrspieler-Interaktion." +
        "\nWarum kann das nicht ein einziger Loadbalancer sein? " +
        "\nNun, ich habe schon einiges ausprobiert, aber aufgrund der Port-Anforderungen für die verschiedenen Dienste funktioniert es nicht.",
    boxOfCardsV1TechStackSectionHeader_00: "Tech-Stack",
    boxOfCardsV1TechStackSectionDescription_00:
        "Welche Bibliotheken habe ich verwendet? " +
        "\nHabe ich Bibliotheken verwendet?" +
        "\nFinden wir es heraus!",
    boxOfCardsV1TechStackSectionHeader_01: "Web-App",
    boxOfCardsV1TechStackSectionDescription_01:
        "Der meiste Inhalt befindet sich im Client, daher habe ich einige Frontend-Bibliotheken verwendet, damit es auch schön aussieht." +
        "\nMaterial Ui als solide Designbasis, React für wiederverwendbare Komponenten und Redux für globale States." +
        "\nTypescript, um die Javascript-Hölle zu vermeiden, Webpack, um den Build kompakter zu machen und Docker für einfaches Deployment." +
        "\nImagekit.io ist kompatibel mit React und ermöglicht die Auslagerung von Bildern in die Cloud, was die Ladezeit reduziert." +
        "\nDer Server ist nur ein Skript, um alles bereitzustellen und einige Anfragen an die Google Cloud weiterzuleiten.",
    boxOfCardsV1TechStackSectionHeader_02: "Backend-Dienste",
    boxOfCardsV1TechStackSectionDescription_02:
        "Diese Dienste haben alle die gleichen Kernkomponenten (Core)." +
        "\nDie grünen Boxen sind npm-Pakete, die Github Worfklows aus meinen anderen Repositories erstellt." +
        "\nAnsonsten verwende ich Jest für Unit-Tests." +
        "\nDas Broker-Paket lässt diese Dienste mit dem RabbitMq-Broker kommunizieren." +
        "\nTypes ermöglicht ein konsistentes Senden und Empfangen von Daten." +
        "\nTestData und MockProvider sind Dependencies, um Redundanz in Unit-Tests zu vermeiden." +
        "\nDann gibt es noch CheckAlive, das einfach prüft, ob ein Spieler noch verbunden ist." +
        "\nUnd mein Wrapper für Redis-Interaktion GameRedis.",
    boxOfCardsV1TechStackSectionHeader_03: "Backend-Pakete",
    boxOfCardsV1TechStackSectionDescription_03:
        "Das folgende ist der Tech-Stack meiner Pakete." +
        "\nDer Broker unterstützt RabbitMq mit stomp.js über Websockets und AMQP über CloudAMQP." +
        "\nGameRedis verwendet mein generischeres RedisClient-Paket, das Pakete wiederum für die Interaktion mit dem Redis-Cluster verwendet." +
        "\nAll die anderen Pakete enthalten nur den Core",
    boxOfCardsV1TechStackSectionHeader_04: "Google Cloud Functions",
    boxOfCardsV1TechStackSectionDescription_04:
        "Die Cloud Functions laufen auf node.js und verwenden ein Firebase-Paket zur Interaktion mit dem Firestore." +
        "\nDer Firestore speichert Decks und Verifizierungslinks sowie einige, grundlegende Accountdaten.",
    boxOfCardsV1TechStackSectionHeader_05: "RabbitMq",
    boxOfCardsV1TechStackSectionDescription_05:
        "RabbitMq wird nur mit Kubernetes-Konfigurationsdateien erstellt und verfügt über Plugins, damit Server und Client mit dem Broker kommunizieren können.",
    boxOfCardsV1DeploymentSectionHeader_00: "Deployment",
    boxOfCardsV1DeploymentSectionDescription_00:
        "So, jetzt haben wir all dieses Kababl, aber wie bilden wir daraus eine Cloud?" +
        "\nDevOps und Pipelines zur Rettung.",
    boxOfCardsV1DeploymentSectionHeader_01: "Github Workflow",
    boxOfCardsV1DeploymentSectionDescription_01:
        "Einfach eine Git-Workflow-Datei im Repository anlegen und schon können wir Jobs definieren." +
        "\nJobs können voneinander abhängig sein, Commits auschecken und sogar selbst Plugins installieren." +
        "\nEs ist Magie und ich liebe sie!" +
        "\nIch verwende einen Job, um die Paketversionen zu erhalten und zu prüfen, ob sie im aktuellen Commit aktualisiert wurden." +
        "\nFalls ja baue ich die Docker-Images neu." +
        "\nWenn etwas neu gebaut wurde, lösche ich es aus meinem Digital Ocean Cluster und deploye neu." +
        "\nJa, mein Workflow loggt sich in Digital Ocean ein!" +
        "\nUnd das alles in nur ~300 Zeilen Konfiguration (ohne Leerzeilen).",
    boxOfCardsV1DeploymentSectionHeader_02: "Der Werkzeugkasten",
    boxOfCardsV1DeploymentSectionDescription_02:
        "Ein guter Freund gab mir eine nette Vorlage für ein Shell-Skript und es machte das Testen von Dingen so viel einfacher." +
        "\nIch habe es mit der Zeit erweitert und es erlaubt mir, zwischen meinem lokalen Cluster und dem Digital Ocean Cluster zu wechseln." +
        "\nWenn ich den Github-Workflow nicht verwenden möchte, um einen Pod zu aktualisieren, dann kann ich einfach alle oder nur einen einzelnen Dienst redeployen." +
        "\nWenn ich richtig liege, dann macht Helm etwas ähnliches, also wird das die nächste Sache sein, die ich mir ansehen werde." +
        "\nIch habe auch einen Cluster mit Terraform erstellt, aber es wirkte unnötig für dieses Projekt." +
        "\nJa, es scheint als hätte ich eine Grenze für Overengineering.",
    boxOfCardsV1TestsSectionHeader_01: "Unit Tests",
    boxOfCardsV1TestsSectionDescription_01:
        "Grüne Zahlen auf einem Unit Test vermitteln eines der besten Gefühle." +
        "\nIn diesem Projekt gibt es über 400 Unit-Tests und einige Dutzend Integrationstests." +
        "\nIch muss jedoch noch einige logische Branches abdecken und der Web-Client hat überhaupt keine Unit-Tests.",
    boxOfCardsV1TestsSectionHeader_02: "Unit Test Output",
    boxOfCardsV1TestsSectionDescription_02:
        "Dies ist die Ausgabe meines TimeoutHandler-Pakets." +
        "\nJa, ich zeige dieses kleinere Paket, weil meine größeren Pakete nicht ganz so gut abgedeckt sind, aber psssht!",
    boxOfCardsV1DesignSectionHeader_00: "Anfänge",
    boxOfCardsV1DesignSectionDescription_00:
        "In den folgenden Abschnitten werde ich Teile der Pläne und Designs posten, die ich auf dem Weg gemacht habe." +
        "\nIch erinnere mich daran, wie mein Professor für Softwaredesign immer wieder sagte: 'Planung ist essentiell. Pläne sind nutzlos.'",
    boxOfCardsV1DesignSectionHeader_01: "1. Spielfeld",
    boxOfCardsV1DesignSectionDescription_01:
        "Ich konzipiere alles in draw.io, da ich dieses Tool als am wenigsten störend empfinde." +
        "\nUnten links ist meine erste Idee für ein Spielfeld zu sehen." +
        "\nEs war nicht flexibel genug für Auflösungen und Spieloptionen.",
    boxOfCardsV1DesignSectionHeader_02: "2. Spielfeld",
    boxOfCardsV1DesignSectionDescription_02:
        "Dieses Layout ist flexibler und Rundungen wirken entspannter.",
    boxOfCardsDesignSectionHeader_03: "Seitenwechsel",
    boxOfCardsDesignSectionDescription_03:
        "Mit allem in einem Dokument kann ich auch vor Ort Seitenübergänge konzipieren.",
    boxOfCardsDesignSectionHeader_04: "Game-loop",
    boxOfCardsDesignSectionDescription_04:
        "Es ist nicht schön, aber es reichte aus, um die Game-States zu erstellen." +
        "\nBeim Spielstart werden die Game-States basierend auf den Spieloptionen aus der Spiellobby verknüpft." +
        "\nZ.B. gibt es für die Auswahl eines Satzes einen GS1GetRandomSentenceGameState und einen GS1SelectingSentenceGameState." +
        "\nBeide teilen sich eine Basisklasse GetSentenceGameStateBase, um Redundanz zu vermeiden.",
    boxOfCardsDesignSectionHeader_05: "UML-Klassendiagramme",
    boxOfCardsDesignSectionDescription_05:
        "Um einen groben Überblick zu bekommen, welche Komponenten benötigt werden, beginne ich gerne mit der Erstellung von Klassendiagrammen." +
        "\nEs fühlt sich an wie das Lösen eines Sodoku, nur dass es wirklich spannend ist.",
    boxOfCardsDesignSectionHeader_06: "Sequenzierung",
    boxOfCardsDesignSectionDescription_06:
        "Der Web-Client und die Dienste kommunizieren über den Broker unter Verwendung von Queues, die sie abonnieren und in denen sie veröffentlichen." +
        "\nUm z.B. eine Spiel-Lobby zu erstellen, müssen mehrere Nachrichten über verschiedene Queues ausgetauscht werden.",
    boxOfCardsV1DesignSectionHeader_07: "Erste Seite",
    boxOfCardsV1DesignSectionDescription_07:
        "Dies war meine erste Seite, die auf localhost lief." +
        "\nWahnwitzig, wie es einmal aussah.",
    boxOfCardsV1DesignSectionHeader_08: "Vielleicht ein Scribble-Design verwenden?",
    boxOfCardsV1DesignSectionDescription_08:
        "Ich habe wirklich versucht, einen handgezeichneten Look zu erreichen, aber ein gutes Nutzungs-Feedback zu ermöglichen war einfach zu schwierig." +
        "\nEs scheint einen Grund zu geben, warum Webseiten immer so sauber gestaltet sind",
    boxOfCardsV1DesignSectionHeader_09: "Designs entwerfen",
    boxOfCardsV1DesignSectionDescription_09:
        "In Affinity Designer habe ich verschiedene Design-Ideen entworfen." +
        "\nAuch wenn einige davon sehr schön aussahen, war es schwierig, alle Komponenten aufeinander abzustimmen.",
    boxOfCardsV1DesignSectionHeader_10: "Logos entwerfen",
    boxOfCardsV1DesignSectionDescription_10:
        "Dies war mein zweiter Ansatz für ein Logo." +
        "\nIch schäme mich zu sehr, meine erste Version zu zeigen, und selbst diese Hände sind... aus den Weiten des Internets gestohlen." +
        "\nIch mag es wirklich, aber es war unmöglich, ein gut aussehendes Icon daraus zu machen.",
    boxOfCardsV1DesignSectionHeader_11: "Gestaltung des Logos",
    boxOfCardsV1DesignSectionDescription_11:
        "Ich habe angefangen, mir nebenbei Logo-Design-Videos anzuschauen und eines gefunden, in dem ein Würfel aus Buchstaben gestaltet wurde." +
        "\nIch konnte es mit den Buchstaben B, O und C anpassen und einige Karten hinzufügen." +
        "\nDinge fingen an zu harmonieren.",
    boxOfCardsV1DesignSectionHeader_12: "Das Spiel designen",
    boxOfCardsV1DesignSectionDescription_12:
        "Ich begann mich darauf zu konzentrieren, die Benutzeroberfläche ansprechend zu gestalten." +
        "\nEine Historie mit fester Höhe am oberen Rand, Handkarten unten, Satz und Info links und ein Spielfeld, das den restlichen Platz füllt." +
        "\nIch habe die optionalen Dinge wie Chat, Spielerliste und Optionen ausblendbar gemacht." +
        "\nEs stellte sich heraus, dass diese Komponenten-Header ein Alptraum im responsive-design waren, also habe ich sie in die Komponenten verschoben" +
        "\nSie sind daher nur in leeren Komponenten dargestellt.",
    boxOfCardsV1DesignSectionHeader_13: "Schriftarten testen",
    boxOfCardsV1DesignSectionDescription_13:
        "Ich habe einige Freunde gebeten, Schriftarten für diese Anwendung zu testen." +
        "\nSie wählten 4 und 11 und ich entschied mich dann für Nnummer 4.",
    boxOfCardsV1ObstaclesSectionHeader_00: "Wie viele Hindernisse könnte es geben?",
    boxOfCardsV1ObstaclesSectionDescription_00:
        "Nun, ich habe nie gezählt, aber sagen wir mal, es wurde geflucht!" +
        "\nBesondere Erwähnungen: Scrollbars, Tabellenimplementierungen, Überprüfung negierter Enums, Cors, Caching, Caching, Git mit Groß-/Kleinschreibung, Google Agones, " +
        "\nPaketabhängigkeitskonflikte, React-Router v5->v6" +
        "\nSeltsames Verhalten von Cluster-Standorten und Github sagt mir, dass ich 9500 von 2000 Build-Minuten erreicht habe, mit einem Guthaben von 56$ auf meinem 0$-Limit." +
        "\nWar aber ein Bug auf deren Seite~",
    boxOfCardsV1ObstaclesSectionHeader_01: "Umlaute!",
    boxOfCardsV1ObstaclesSectionDescription_01:
        "In der deutschen Sprache gibt es Umlaute (ä,ö, etc.) und es stellte sich heraus, dass die Schriftart, die ich gewählt hatte, diese nicht hatte, also...." +
        "\nIch habe sie selbst hinzugefügt!" +
        "\nIch denke, das ist in Ordnung, da ich diese Schriftart gekauft habe und ansonsten: psssht.",
    boxOfCardsV1ObstaclesSectionHeader_02: "Font Borders",
    boxOfCardsV1ObstaclesSectionDescription_02:
        "Die Schriftart hatte auch einige überlagernde Linien aus... Gründen denke ich." +
        "\nEs war in Ordnung, bis ich eine border hinzugefügt habe, die etwas seltsam aussah." +
        "\nAlso habe ich sie herausgearbeitet. Ich kannte den Font-Editor inzwischen.",
    boxOfCardsV1ObstaclesSectionHeader_03: "Anzeigeeinstellungen",
    boxOfCardsV1ObstaclesSectionDescription_03:
        "Was ist das, fragst du dich?" +
        "\nModerne Kunst?" +
        "\nJa, wahrscheinlich." +
        "\nEs ist auch der Farbunterschied zwischen meinen beiden Monitoren, und ich war nicht in der Lage, sie näher aneinander zu bringen." +
        "\nIch beschloss, dieses Problem zu lösen, indem ich mich überhaupt nicht darum kümmerte und weitermachte.",
    boxOfCardsV1ObstaclesSectionHeader_04: "Debugging Unit Tests",
    boxOfCardsV1ObstaclesSectionDescription_04:
        "Nun, einige Fehlermeldungen sind zunächst verwirrend und dann werden sie unheimlich." +
        "\nIch verwende Typescript, so dass die Typen festgelegt sind, aber bei der Übergabe von Daten kann eine Zahl (Number) immer noch ein String sein," +
        "\nobwohl der Compiler denkt, dass es eine Zahl ist." +
        "\nNananananananana Javascriiiipt",
    boxOfCardsV1ObstaclesSectionHeader_05: "Wie lange hat diese Reise gedauert?",
    boxOfCardsV1ObstaclesSectionDescription_05:
        "Nun, ich weiß es nicht, aber alle Repositories zusammen haben 1000+ Commits." +
        "\nIch habe nun ein paar schöne Templates und ein paar Sachen, die ich noch aufräumen muss." +
        "\nWas ist noch zu tun? " +
        "\nQuality of Life, mehr Unit-Tests, Login mit Google, etc." +
        "\nAh, und ich habe irgendwie vergessen, eine Benutzerkonto-Verwaltung hinzuzufügen...das braucht niemand." +
        "\nIch liebe die Entwicklung einfach <3",

    // Career Projects
    today: 'Heute',

    boxOfCardsV3CareerHeader: "Release Box of Cards Beta",
    boxOfCardsV3CareerSubHeader: "Web Game",
    boxOfCardsV3CareerDescription: "Migration eines kollaborativen Web-Spiels auf eine günstigere Architektur und Cloud.\n" +
        "Notwendige Kosteneinsparungen durch horizontal skalierende, dedizierte Server und effizientes Caching.",
    boxOfCardsV3CareerBulletPoint1: "Umsetzung dedizierter Spieleserver in einem droplet cluster.",
    boxOfCardsV3CareerBulletPoint2: "Horizontale Skalierung von Droplets anhand von Echtzeit-Metriken.",
    boxOfCardsV3CareerBulletPoint3: "Automatisierte Docker Image, Snapshot & Ssl Genierung.",
    boxOfCardsV3CareerBulletPoint4: "Konformität mit globalen Richtlinien zum Daten und Verbraucherschutz.",
    boxOfCardsV3CareerBulletPoint5: "Verwaltung von Google Analytics & Google Adsense.",
    boxOfCardsV3CareerBulletPoint6: "Umfangreiche Testabdeckung durch ~ 1400 End To End Tests.",

    hrisHeader: "Verwaltung von Mitarbeitern und Unternehmensressourcen",
    hrisSubHeader: "HRMS & IT-Asset-Management",
    hrisDescription: "Ein Firmenportal zur Verwaltung von:\n" +
        "Kontakten, Beschäftigungsverhältnissen, Finanzen, Versicherungen, Zusatzleistungen, Ausrüstung, verfolgter Hardwareverteilung und mehr.",
    hrisBulletPoint1: "Automatisierte Bereitstellung durch AWS CDK",
    hrisBulletPoint2: "Rollenbasierter Zugriff durch HR und Mitarbeiter",
    hrisBulletPoint3: "Automatisierte Erstellung von Dokumenten",
    hrisBulletPoint4: "Automatisierte Historie zur DSGVO-Konformität",
    hrisBulletPoint5: "Automatisierte Backups",
    hrisBulletPoint6: "Automatisierte E-Mail-Benachrichtigungen",

    kotlinRecommendationAppHeader: "KI Bewertung auf Android",
    kotlinRecommendationAppSubHeader: "Android App PoC",
    kotlinRecommendationAppDescription: "Gib deine Idee ein und ein LLM gibt dir Feedback.\n" +
        "Dieses Projekt ist ein Lückenfüller und diente der Einarbeitung in Kotlin.",

    boxOfCardsV2CareerHeader: 'Überarbeitung einer Mehrspieler Web-App (v2)',
    boxOfCardsV2CareerSubHeader: 'Web Game',
    boxOfCardsV2CareerDescription:
        'Die App ist funktional aber bei der derzeitigen Architektur ergeben sich Probleme.\n' +
        'Dies liegt an den initialen Kosten, skalierenden Kosten, dem Wartungsaufwand und der GCP Dokumentation.\n' +
        'Daher erfolgt eine serverless-Migration von NodeJs in Kubernetes zu AWS Lambda und von Redis zu DynamoDB.\n' +
        'Zusätzlich wird die Google Authentication durch oAuth via Drittanbieter wie e.g. Discord ersetzt.\n' +
        'Aufgrund des Websocket Supports wird zukünftig GraphQl als Api eingesetzt und RabbitMq fällt weg.\n' +
        'Es wurden diverse Ui-Designs prototyped und daher wird das UI overhauled.',
    boxOfCardsV2CareerBulletPoint1: 'Migration zu Serverless in AWS',
    boxOfCardsV2CareerBulletPoint2: 'Kommunikation über GraphQl',
    boxOfCardsV2CareerBulletPoint3: 'Deployment von Architektur & Code über AWS-Cdk',
    boxOfCardsV2CareerBulletPoint4: 'Bereitstellung der Web-App über CloudFront',
    boxOfCardsV2CareerBulletPoint5: 'Überarbeitung des UI Designs',

    charityHeader: 'CRM für wohltätige Organisation',
    charitySubHeader: 'Charity B2C',
    charityDescription: 'Entwicklung einer Anwendung zur Verwaltung & Verteilung gespendeter Waren an Bedürftige.',
    charityBulletPoint1: 'Terminbuchung',
    charityBulletPoint2: 'Kundenverwaltung',
    charityBulletPoint3: 'Warenverwaltung',
    charityBulletPoint4: 'Email-Benachrichtigungen',
    charityBulletPoint5: 'Lokalisierung',
    charityBulletPoint6: 'Api Anbindungen',

    agricultureHeader: 'CRM + ERP für mittelständischen Händler',
    agricultureSubHeader: 'Landwirtschaft & Vorverarbeitung B2B',
    agricultureDescription: 'Neuentwicklung eines historischen, monolithischen Warenwirtschaftssystems auf Basis von Microsoft Access.\n' +
        'Das ablösende System ist modular, integriert & geschlossen.',
    agricultureBulletPoint1: 'Bestimmung & Optimierung von Geschäftsprozessen',
    agricultureBulletPoint2: 'Backend mit .NET, Entity Framework & PostgreSQL',
    agricultureBulletPoint3: 'TextControl ermgölicht automatisierte Generierung von Verträgen & Rechnungen',
    agricultureBulletPoint4: 'Testabdeckung mit Moq & XUnit',
    agricultureBulletPoint5: 'Webanwendung durch React, MUI & Datagrid, Typescript & RTK-Query',
    agricultureBulletPoint6: 'Automatisierte Backend-Api- & Http-Client-Generierung durch RTK-Codegen',
    agricultureBulletPoint7: 'Pipeline deployment durch Azure DevOps',

    eCommerceHeader: 'Automatisierung E-Mail & Marketing',
    eCommerceSubHeader: 'E-Commerce B2C & B2B',
    eCommerceDescription: 'Entwicklung bei einem führenden, deutschen Katalog & Online-Shop. \n' +
        'Monatlicher Versand von Emails & Push-Nachrichten in 3-stelliger Millionenhöhe. \n' +
        'Verwaltung & Weiterentwicklung diverser Services zur Anbindung, Anreicherung & Aussteuerung \n' +
        'von Kunden-Events. Aufgrund von jahrzehnten vorangegangener Entwicklung waren diverse Technologien im Einsatz.',
    eCommerceBulletPoint1: 'Anbindung & Anreicherung von Events zum Emailversand',
    eCommerceBulletPoint2: 'Automatisierung der Accountdatenverwaltung für DSGVO',
    eCommerceBulletPoint3: 'Templating-Engine Integration für personalisierte Aussteuerung',
    eCommerceBulletPoint4: 'Cloud-Optimierung durch Parallelisierung & Batching',
    eCommerceBulletPoint5: 'Fortentwicklung Angular Web-Client zur Verwaltung vom Push-Versand',
    eCommerceBulletPoint6: 'Ablösen von Altsystemen',
    eCommerceBulletPoint7: 'Ausbau & Testdurchläufe von Disaster Recovery & Alarming',
    eCommerceBulletPoint8: 'Automatisiertes Testing über mehrere Teams hinweg',

    bookingHeader: 'Webapp zur Büroflächenverwaltung',
    bookingSubHeader: 'SaaS B2C',
    bookingDescription: 'Buchung und Verwaltung von Sitzplätzen, Räumen & Ausstattung für Mitarbeiter.',
    bookingBulletPoint1: 'Cloud Architektur (Infrastructure as Code)',
    bookingBulletPoint2: 'CI/CD (Automatisches Deployment)',
    bookingBulletPoint3: 'Backend Entwicklung',
    bookingBulletPoint4: 'UI-Konzeption',
    bookingBulletPoint5: 'Frontend Entwicklung',

    awsSolutionArchitectHeader: 'AWS Certified Solutions Architect',
    awsSolutionArchitectSubHeader: 'Zertifikat',
    awsSolutionArchitectDescription: 'Ich hatte noch Zeit vor dem nächsten Projekt also habe ich mich direkt hieran gemacht.\n' +
        'Ich empfehle einen Bachelor für das Grundwissen, Vorerfahrung mit AWS, einen Monat Zeit und viel Kaffee.',

    awsCloudPractitionerHeader: 'AWS Certified Cloud Practitioner',
    awsCloudPractitionerSubHeader: 'Zertifikat',
    awsCloudPractitionerDescription: 'Ein guter Einstieg um Erfahrung mit Zertifizierungen zu sammeln.\n' +
        'Ist je nach Wissensstand in 1-3 Tagen gut zu machen.',

    boxOfCardsV1CareerHeader: 'Mehrspieler Web-App (v1)',
    boxOfCardsV1CareerSubHeader: 'Web Game',
    boxOfCardsV1CareerDescription: 'Umsetzung eines kartenbasierten Gesellschaftsspieles im Browser.\n' +
        'Nutzer können eigene Decks anlegen, kombinieren und in unterschiedlichen Modi miteinander spielen.\n' +
        'Die Kommunikation erfolgt durch http / websockets über RabbitMq mit NodeJs Containern in Kubernetes.\n' +
        'Diese verwalten das Matchmaking, die Spielerstellung und das aktive Spiel.\n' +
        'Spielerdaten werden in Redis gelagert, wohingegen Accountdaten & Decks im Google Firestore persistiert werden.\n' +
        'Alle Anwendungen laufen als Docker-Images und können durch GitHub-Actions mit einem Klick selektiv redeployed werden.',
    boxOfCardsV1CareerBulletPoint1: 'Konzeption vom Spieldesign',
    boxOfCardsV1CareerBulletPoint2: 'Konzeption von UI',
    boxOfCardsV1VCareerBulletPoint3: 'Konzeption der Architektur',
    boxOfCardsV1CareerBulletPoint4: 'Umsetzung (Frontend, Backend, Datenbanken, Authentifizierung)',
    boxOfCardsV1CareerBulletPoint5: '(Automatisches) Deployment',

    fundingHeader: 'Förderungen & Prototypen',
    fundingSubHeader: 'Pc Games',
    fundingDescription: 'Mein größtes Hobby ist die Spieleentwicklung und dies nahm auch gegen Ende meiner Depression wieder Fahrt auf.\n' +
        'Ich habe diverse Prototypen entwickelt aber keine Förderung bekommen.\n' +
        'Nach Box of Cards werde ich den farbbasierten 2D-Platformer fortsetzen, da dieser bereits Tests, einen Level Editor, ein Pitck Deck, 60 Seiten GDD, etc. besitzt.\n' +
        'Dieser ist bis jetzt nicht in meinen Projekten gelistet aber ich freue mich so sehr drauf!',

    diagnosisAdhdHeader: 'Diagnose ADHS',
    diagnosisAdhdSubHeader: 'Gesundheit',
    diagnosisAdhdDescription: 'Asperger Autismus konnte meine Besonderheiten nicht gänzlich erklären aber mit ADHS zusammen wurde das Bild stimmig.\n' +
        'Vor allem die Kombination von beidem sorgte dafür, dass es 30 Jahre lang nicht erkannt wurde.\n' +
        'Symptome aus dem einen Feld verdeckten Symptome aus dem anderen Feld.\n' +
        'Ich möchte anmerken, dass ich sehr unkompliziert mit all dem umgehe und Menschen auch fast nie etwas auffällt wenn ich es nicht anspreche.',

    diagnosisAspergersHeader: 'Diagnose Asperger Autismus',
    diagnosisAspergersSubHeader: 'Gesundheit',
    diagnosisAspergersDescription: 'Während meiner Verhaltenstherapie ging ich auch dem Thema Autismus nach, da ich es schon immer im hinterkopf hatte.\n' +
        'Ich bekam sehr zeitnah meine Diagnose und sie erklärt sehr viel und es stellte sich heraus, dass auch meine Kontakte zum Großteil im neurodiversen Sprektum sind.\n' +
        'Einige dachten sogar ich hätte schon meine Autismus-Diagnose und wollten es nur nicht ansprechen.\n' +
        'Auch hier rede ich sehr gerne drüber und kann Therapien jedem nur empfehlen.',

    depressionHeader: 'Burnout & Depression',
    depressionSubHeader: 'Gesundheit',
    depressionDescription: 'Es gibt soviel zu erzählen und nur so wenig Platz also sprecht mich gerne direkt an.\n' +
        'Kurzum lebte ich schon zuviele Jahre über meinem Limit.\n' +
        'Mein Körper teilte mir physisch mit ,dass nach zuviel Arbeit, schlechten Arbeitsbedingungen und mit familiäre Altlasten nun eine Auszeit ansteht.\n' +
        'Es war eine der besten Zeiten. Ich habe viel über mich und andere gelernt und helfe seither auch Anderen wo ich nur kann.\n' +
        'Dies ist ein so wichtiges Thema und daher sollte es auch nicht versteckt werden, um mehr Akzeptanz in der Gesellschaft zu erreichen',

    memoreHeader: 'Neugestaltung einer Plattform von Spielmodulen',
    memoreSubHeader: 'Serious Games B2B',
    memoreDescription: 'Der Auftraggeber verfügt über eine Plattform für therapeutische, bewegungsgesteuerte Computerspiele für Senioren.\n' +
        'Diese Spiele werden auf einer eigenen Konsole ausgeliefert.\n' +
        'Die Code-Basis wurde erneuert, um kompaktere und günstigere Hardware zu ermöglichen.\n' +
        'Zusätzlich wurden modulare Updates durch Deployment Pipelines ermöglicht.',
    memoreBulletPoint1: 'Konzeption der Architektur',
    memoreBulletPoint2: 'Test-Driven Implementation',
    memoreBulletPoint3: 'Neuentwicklung des Gamestate Systems',
    memoreBulletPoint4: 'Implementierung individueller Gesten nach therapeutischen Vorgaben',
    memoreBulletPoint5: 'Dokumentation',
    memoreBulletPoint6: 'Performance-Optimierung ~300%',
    memoreBulletPoint7: 'Genaueres Motion-Tracking.',
    memoreBulletPoint8: 'DevOps',

    bachelorFinishHeader: 'Bachelor Abschluss',
    bachelorFinishSubHeader: 'Angewandte Informatik - HAW Hamburg',
    bachelorFinishDescription: '',

    bachelorThesisHeader: 'Navigation in nicht-euklidischer VR',
    bachelorThesisSubHeader: 'VR-Research',
    bachelorThesisDescription: 'VR-Umgebungen ermöglichen neuartige Navigationsmöglichkeiten, da simulierte Welten nicht den uns gewohnten Gesetzen folgen müssen.\n' +
        'Es wurde untersucht, ob nicht-euklidische (gekrümmte) Räume eine zeitlich effizientere Fortbewegung ermöglichen.\n' +
        'Für die Umsetzung wurden zwei 3D-Umgebungen gebaut, wobei eine Umgebung über Portale und verkürzte Wege verfügte.\n' +
        'Die Portale waren auch beim Durschreiten für den Nutzer nicht spürbar und befanden sich in den Türen zwischen den Räumen.\n' +
        'Die Untersuchung ergab, dass nicht-euklidische Räume eine durchschnittlich 40% effizientere Fortbewegung ermöglichen.',
    bachelorThesisBulletPoint1: 'Grundlagenforschung',
    bachelorThesisBulletPoint2: 'Konzeption & Umsetzung der VR-Anwendung',
    bachelorThesisBulletPoint3: 'Konzeption & Durchführung des Experiments mit 20 Probanden',
    bachelorThesisBulletPoint4: 'Statistische Auswertung',

    memoreCareHeader: 'Web-App zur Verwaltung einer medizinischen Konsolenanwendung',
    memoreCareSubHeader: 'Serious Games B2B',
    memoreCareDescription: 'Der Auftraggeber verfügt über eine Plattform für therapeutische, bewegungsgesteuerte Computerspiele für Senioren.\n' +
        'Fitness ist individuell und es wird eine Wep-App zur Konfiguration der Spiele, Datenerfassung & Datenvisualisierung benötigt.\n' +
        'Spieler, Pfleger, Admins haben unterschiedliche Zugänge und Daten sind anonymisiert hinterlegt.',
    memoreCareBulletPoint1: 'Erhebung der Use-Cases',
    memoreCareBulletPoint2: 'Projektmanagement',
    memoreCareBulletPoint3: 'Konzeption der Webanwendung, Backend-Services & Datenbanken',
    memoreCareBulletPoint4: 'Umsetzung',
    memoreCareBulletPoint5: 'Dokumentation',

    magentoHeader: 'Web-Shop-Module',
    magentoSubHeader: 'E-Commerce B2B',
    magentoDescription: 'Für ein Hamburger E-Commerce Unternehmen wurden Web-Shop-Module für Kunden entwickelt.\n' +
        'Es wurden neue E-Shops konzipiert und bestehende erweitert.\n' +
        'Zusätzlich wurden diverse Module erstellt wie z.B. interaktive Karten, visualisierte Produktkonfiguration & automatisierte Dokumentenerstellung',
    magentoBulletPoint1: 'Konzeption',
    magentoBulletPoint2: 'Umsetzung',
    magentoBulletPoint3: 'Integration',

    synonymServiceHeader: 'Synonym-Service zur Suchoptimierung',
    synonymServiceSubHeader: 'E-Commerce B2B',
    synonymServiceDescription: 'In Sprachen gibt es eine Vielzahl von Wörtern mit ähnlichen Bedeutungen.\n' +
        'Damit Nutzer stets die beste Sucherfahrung haben sollen auch Synonyme mit in die Suche einbezogen werden.\n' +
        'Hierfür wurde eine Synonymdatenbank erstellt und mit einer Web-App zur Verwaltung der eingepflegten Suchbäume ausgestattet.',
    synonymServiceBulletPoint1: 'Konzeption',
    synonymServiceBulletPoint2: 'Interaktive Visualisierung & Pflege der Suchbäume',

    bachelorStartHeader: 'Bachelor Start',
    bachelorStartSubHeader: 'Angewandte Informatik - HAW Hamburg',
    bachelorStartDescription: 'Schon während des Studiums 3D & Animation driftete ich in Richtung Programmierung.' +
        'Ich habe selbständig und mit Unterstützung meiner Kollegen viel gelernt und mich für einen kompletten Wechsel entschieden.',

    racingHeader: '2D Racing',
    racingSubHeader: 'Mobile Game',
    racingDescription: 'Level basiertes 1-Click Racing Game.',
    racingBulletPoint1: 'Game Design',
    racingBulletPoint2: 'Level Design',
    racingBulletPoint3: 'Scripting',

    puzzleHeader: '2D Puzzle',
    puzzleSubHeader: 'Mobile Game',
    puzzleDescription: 'Decke Symbole mit platzierbaren Strichen auf und errate ihren Namen mit vorgegebenen Buchstaben.',
    puzzleBulletPoint1: 'Umsetzung 700+ Level',
    puzzleBulletPoint2: 'App/Playstore Optimization',
    puzzleBulletPoint3: 'Scripting',

    jumpnRunHeader: '2D Jump’n run',
    jumpnRunSubHeader: 'Mobile Game',
    jumpnRunDescription: 'Ein Rogue-Light in Fallen-durchsäten Turm.\n' +
        'Der Spieler erklimmt diesem, indem er durch den unteren Bildschirmrand springt und am oberen erscheint.',
    jumpnRunBulletPoint1: 'Umsetzung 150+ Level in 10 Zeitaltern mit 30+ Fallenarten',
    jumpnRunBulletPoint2: '~ 100 Achievements',
    jumpnRunBulletPoint3: 'Scripting',
    jumpnRunBulletPoint4: 'App/Playstore Optimization',

    saeFinishHeader: '3D & Animation - SAE Hamburg',
    saeFinishSubHeader: 'Diplom Abschluss',
    saeFinishDescription: 'Ich hätte gerne mehr Zeit in das Studium investiert, da ich drei Tage pro Woche im Einzelhandel arbeiten musste, um mich zu finanzieren.\n' +
        'Ich habe tolle Kontakte geknüpft, die bis heute sehr aktiv sind.',

    brawlerHeader: '3D Coop Couch Brawler',
    brawlerSubHeader: 'Pc Game',
    brawlerDescription: 'Ich repräsentiere meine ehemalige Universität mit einem 3D-Spiel für die Gamescom.\n' +
        'Superhelden mit einzigartigen Fähigkeiten beschützen gemeinsam eine Stadt vor Horden von Feinden.\n' +
        'Die Stadt ist komplett zerstörbar und soll bei der Verteidigung nicht beschädigt werden.',
    brawlerBulletPoint1: '3D-Modellierung',
    brawlerBulletPoint2: 'Texturierung',
    brawlerBulletPoint3: 'Animation',

    saeStartHeader: '3D & Animation - SAE Hamburg',
    saeStartSubHeader: 'Diplom Start',
    saeStartDescription: 'Ich war schon immer ein Computerspiel-Enthusiast.' +
        "Ich beschäftigte mich bereits mit Webprogrammierung, der Erstellung von Warcraft 3 Mods & 3D Modeling, also fühlte sich dieser Schritt natürlich an.",

    abiturHeader: 'Abitur',
    start: 'Start',

    // Skills
    websockets: 'Websockets',
    redux: 'Redux',
    jest: 'Jest',
    redis: 'Redis',
    kubernetes: 'Kubernetes',
    gcp: 'GCP',
    firebase: 'Firebase',
    affinityDesigner: 'Affinity Designer',
    affinityPhoto: 'Affinity Photo',
    nuget: 'Nuget',
    git: 'Git',
    sensorTower: 'SenorTower',
    appAnnie: 'AppAnnie',
    aso: 'ASO',
    unity3D: 'Unity3D',
    vite: 'Vite',
    java: 'Java',
    typescript: 'Typescript',
    nodeJs: 'NodeJs',
    digitalOcean: 'Digital Ocean',
    nextJs: 'NextJs',
    prisma: 'Prisma',
    react: 'React',
    rtk: 'RTK',
    postgreSQL: 'PostgreSQL',
    azure: 'Azure',
    dotNet: '.NET',
    entityFramework: 'Entity Framework',
    swagger: 'Swagger',
    xUnit: 'XUnit',
    moq: 'Moq',
    mui: 'MaterialUi',
    muiDatagrid: 'Mui DataGrid',
    yup: 'Yup',
    rtkQuery: 'RTK Query',
    scrum: 'Scrum',
    businessProcessReengineering: 'Business Process Engineering',
    textControl: 'TextControl (Automatisierte Pdf Generierung & Signatur)',
    figma: 'Figma',
    miro: 'Miro',
    aws: 'AWS',
    awsCdk: 'CDK',
    awsEc2: 'EC2',
    awsFargate: 'Fargate',
    awsEcr: 'ECR',
    awsS3: 'S3',
    awsDynamoDb: 'DynamoDB',
    awsLambda: 'Lambda',
    awsSns: 'SNS',
    awsSqs: 'SQS',
    awsCloudwatch: 'Cloudwatch',
    awsCloudFront: 'Cloudfront',
    awsCloudformation: 'Cloudformation',
    awsCognito: 'Cognito',
    awsEcs: 'ECS',
    awsAurora: 'Aurora',
    awsRoute53: 'Route53',
    apiGateway: 'ApiGateway',
    appsync: 'Appsync',
    graphql: "GraphQl",
    apollo: "Apollo",
    terraform: 'Terraform',
    keycloak: 'Keycloak',
    githubCiCd: 'Github CI/CD',
    gitlabCiCd: 'Gitlab CI/CD',
    docker: 'Docker',
    rabbitMq: 'RabbitMq',
    kafka: 'Kafka',
    hibernate: 'Hibernate',
    springIntegration: 'Spring Integration',
    jUnit: 'JUnit',
    maven: 'Maven',
    angularMaterial: 'Angular Material',
    yarn: 'Yarn',
    liquidJs: 'LiquidJs',
    emarsys: 'Emarsys',
    confluence: 'Confluence',
    springBoot: 'Spring Boot',
    azureAd: 'Azure AD',
    ruby: 'Ruby',
    prolog: 'Prolog (AAAAAHHHHHHHH)',
    c: 'C',
    assembler: 'Assembler',
    cSharp: 'C#',
    databases: 'Datenbanken',
    broker: 'Broker',
    automation: 'Automatisierung',
    algorithms: 'Algorithmen',
    softwareDevelopment: 'Software Entwicklung',
    softwareArchitecture: 'Software Architektur',
    distributedSystems: 'Verteilte Systeme',
    itSecurity: 'IT Sicherheit',
    vr: 'VR',
    machineLearning: 'Machine Learning',
    nUnit: 'NUnit',
    Nuget: 'Nuget',
    jira: 'Jira',
    motionTracking: 'Motion Tracking',
    jenkins: 'Jenkins',
    excel: 'Excel',
    lateX: 'LateX',
    aspNetCore: 'AspNet Core',
    mySQL: 'MySQL',
    linux: 'Linux',
    apache: 'Apache',
    php: 'PHP',
    magento: 'Magento (AAAAAHHHHHHHH)',
    jQuery: 'JQuery',
    symfony: 'Symfony',
    javascript: 'Javascript',
    android: 'Android',
    iOs: 'iOS',
    adobePhotoshop: 'Adobe Photoshop',
    autodeskMaya: 'Autodesk Maya',
    zBrush: 'ZBrush',
    mudbox: 'Mudbox',
    adobeIllustrator: 'Adobe Illustrator',
    rigging: 'Rigging',
    threeDAnimation: '3D Animation',
    substancePainter: 'Substance Painter',
    nDo: 'NDO',
    dDo: 'DDO',
    kotlin: 'Kotlin',
    material: 'Material',
    chatGpt: 'ChatGPT',
    sharepoint: "Sharepoint",
    microsoftGraphApi: "Microsoft Graph Api",

    // Quotes
    quotes: [
        /*1*/    "Gib einem Menschen einen Fisch und er isst für einen Tag.\nGib einem Menschen ein Fass voller Fisch und er isst für eine Woche.",
        /*2*/    "Wenn du in den Abgrund schaust\ndann schaut auch der Abgrund aus dir heraus in dich hinein.",
        /*3*/    "Aber weißt du auch warum ich Cini Minis so liebe?",
        /*4*/    "Superkräfte existieren!\nSie sind nur einfach nicht gut. Wie Sommersprossen oder Allergien.",
        /*5*/    "Der Debugger ist genug Dokumentation.",
        /*6*/    "Ich mag sehr enthusiastische Spaziergänge.",
        /*7*/    "Ich liebe Software Architektur.",
        /*8*/    "Im Hintergrund findet kein Krypto-Mining statt.",
        /*9*/    "Hast du den Herd angelassen?",
        /*10*/    "Warum gibt es keinen Aufstrich mit Brotbelag?",
        /*11*/    "Butter, butter ,butter, butter.",
        /*12*/    "Sind Feinde die Freunde die wir auf dem Weg nicht gefunden haben?",
        /*13*/    "Macht Existenz mehr Sinn als Inexistenz?",
        /*14*/    "Was ist nur mit den Tomaten passiert?",
        /*15*/    "Menschen sind tendenziell weder Kjeld noch Schneemänner",
    ],
    quoterPrefix: [
        "",
        "~ ",
        "von ",
    ],
    quoter: [
        "Tim Fehrmann",
        "T. Fehrmann",
        "T.F.",
        "Tim F.",
        "T. Fehrmann",
        "Tim",
    ],
};

export interface ILanguageTokens extends IBaseStrings {
    formatString: any;
}

export const LanguageTokens: any = new LocalizedStrings(
    {
        EN,
        DE,
    },
    {}
);
export const formatString = LanguageTokens.formatString;
